export default {
  app: {
    title: {
      rentablo: "Rentablo - Smart Fund Savings",
      depotcheck: "Depotcheck.ai - Intelligent Portfolio Optimization",
      compliance: "Compliance",
    },
  },
  today: "Today",
  common: {
    confirm: "Confirm",
    close: "Close",
    back: "Back",
    chartNoData: "No data",
    chartOther: "Other",
    englishLegalNote:
      "Note: This English translation is provided for convenience only. The German version is the sole legally binding document.",
  },
  notFound: {
    title: "Oh no! Error 404",
    text: "Oops! This page seems to have taken a detour. Let us help you find your way back to your goal.",
    button: "Back to Home",
  },
  dateRangePicker: {
    title: "Select period",
    startLabel: "From",
    endLabel: "To",
    resetLabel: "Reset",
    applyLabel: "Apply",
  },
  expiresIn: {
    day: "1 day",
    days: "{{days}} days",
    month: "1 month",
    months: "{{months}} months",
  },
  copiedToClipboard: "Copied to clipboard",
  currencyMode: {
    global: "in {{currency}}",
    account: "in account currency",
  },
  currencyToggle: {
    original: "Original currency",
    global: "{{currency}}",
  },
  bankImportStatus: {
    importedData: "Imported bank data",
    updatedData: "Updated bank data",
    successImport: "Bank data successfully imported",
    successUpdate: "Bank data successfully updated",
    errorImport: "Bank data import failed",
    errorUpdate: "Bank data update failed",
    status: {
      CONNECTING: "Connecting to the bank",
      DECOUPLED_AUTH_REQUIRED:
        "Please confirm the banking login in your banking app",
      VERIFYING_CHALLENGE_RESPONSE: "Checking TAN",
      AUTHENTICATION_IN_PROGRESS: "Performing authentication",
      AUTHENTICATION_FAILED: "Authentication failed",
      ACCOUNTS: "Retrieving accounts",
      TRANSACTIONS: "Retrieving transaction data",
      SECURITIES: "Retrieving securities data",
      PERSISTING_TRANSACTIONS: "Saving transaction history",
      PERSISTING_BOOKINGS: "Saving order history",
      SUCCESS: "All data saved",
      FAILED_WITH_ERROR: "Unexpected error",
    },
  },
  dropdownWithSections: {
    noOptions: "No options available",
    noMatches: "No matches found",
    loading: "Loading...",
  },
  form: {
    yes: "Yes",
    no: "No",
    successMessage: "Your data has been saved successfully",
    errors: {
      pdfImport:
        "Unfortunately, we could not read one or more of your PDF files, please try again",
      pdfImportFileLength:
        "You have selected more than 10 files. A maximum of 10 files can be processed. Additional files will not be accepted",
      required: " This field is required.",
      wrongEmailFormat: "Invalid email format.",
      emailsNotMatched: "Emails should match.",
      passwordMinLength: "Password should be at least 8 characters long.",
      passwordsNotMatched: "Passwords should match.",
      wrongDateFormat: " Invalid date format.",
      wrongIbanFormat:
        "IBAN is invalid. Please check this and enter a valid IBAN.",
      wrongPhoneFormat:
        "Invalid phone format. Please only use digits and the + symbol.",
      min: "This Field must be at least {{min}} characters long.",
      max: "This field must be at most {{max}} characters long.",
      emailAlreadyExists: "This email address is already registered.",
      somethingWentWrong: "Something went wrong. Please try again.",
      noData: "No data available",
    },
  },
  domains: {
    dividends: {
      dividendsTable: {
        noDividends: "No dividends",
      },
    },
    accountPreviewCard: {
      updateRecommended: "Update recommended",
    },
    cashback: {
      download: {
        customerFirstName: "First name",
        customerLastName: "Last name",
        bank: "Bank",
        depotId: "Depot identifier",
        securityIsin: "ISIN",
        securityName: "Fund name",
        date: "Date",
        netCommission: "Commission",
        valuationBase: "Valuation",
        commissionType: "Commission type",
      },
      dashboard: {
        details: {
          title: "Commission-item",
          commission: "Commission for",
          evaluation: "Valuation",
        },
        summary: {
          accountingFrom: "Invoice date: ",
          download: "Download",
          notBilledYet: "Not billed yet",
          afterBilling: "After Billing",
          trailerCommission: "One-time commission",
          commissionRetention: "Commission retention",
          yourCashback: "Your Cashback",
          incomplete: "Incomplete",
          lastBills: "Last invoices",
          goToBilling: "Go to invoices",
          period: "Period",
          taxHelper: "Tax Helper",
        },
        tabs: {
          overview: "Overview",
          invoices: "Invoices",
          contacts: "Contact & Payment",
        },
        title: "My Cashback",
        breadcrumbs: {
          home: "Home",
          cashback: "Cashback",
        },
        titleAction: "New cashback subscription",
        openBookings: "My cashback subscriptions",
        showAll: "Show all",
        info: {
          title: "Invite friends and benefit twice!",
          text: "Get a <blueText>{{amount}} € cashback bonus</blueText> now for every referred friend.\nYour friend will also receive a <blueText>{{amount}} € bonus.</blueText>",
          recommend: "Recommend Rentablo",
          notNow: "Not now",
        },
        cashbackBonusBanner: {
          amountText: "{{amount}} bonus available",
          inactiveText: "• Activation after booking is complete",
        },
        footer:
          "* Your cashback-bonus will lower our fee and thus increase your cashback payout.",
        item: {
          depositNumber: "Depot Identifier",
          edit: "Edit",
          abort: "Cancel",
          pdf: "PDF",
          deleteSuccess: "The cashback subscription was successfully deleted",
        },
        status: {
          incomplete: "Please complete your subscription",
          in_progress: "Please submit documents",
          internal_processing: "Documents received",
          processing_at_bank: "Documents forwarded to your bank",
          processing_at_bank_reduced: "Opening process forwarded to bank",
          processed: "Active",
          contract_terminated: "Terminated",
          cancelled: "Cancelled",
        },
        taxHelper: {
          title: "Tax Helper",
          back: "back",
          categories: {
            EQUITY_FUND: "Equity Fund, Equity Portion > 51%",
            BALANCED_FUND: "Mixed Fund, Equity Portion > 25%",
            GERMAN_REAL_ESTATE_FUND: "Real Estate, Germany > 51%",
            FOREIGN_REAL_ESTATE_FUND: "Real estate, abroad > 51%",
            OTHERS: "Other (no exemption)",
          },
          summary: {
            period: "Period",
            taxableAmount: "Tax-relevant amount",
            export: "Export",
            exportData: "Data export",
          },
          banner: {
            title: "Exclusion of tax advice",
            text: "The information presented here does not constitute tax advice. The values and software tools provided are only intended as a guide. In particular, Rentablo does not guarantee the information displayed Values and also assumes no liability. This cannot replace individual advice from experts.",
          },
          info: {
            title: "Partial exemptions",
            text: "Any fund that wants to guarantee a partial exemption of income for its investors must In the future, the fund conditions will stipulate the proportions of shares or real estate shares and provide evidence to the Federal Financial Supervisory Authority (BaFin). According to the legislator, WM Datenservice provides the relevant data. In practice, the <linkText>WM Datenservice</linkText> is unfortunately not able to provide this data.",
            text2:
              "For this reason, we carry out a pre-classification based on internal data and the input of other Rentablo users. Therefore, please check the values provided.",
          },
          products: {
            name: "Product",
            category: "Tax Exemption",
            taxableAmount: "Tax-Relevant Amount",
            success: "The exemption was updated successfully",
          },
        },
      },
      form: {
        breadcrumbs: {
          home: "Home",
          contacts: "Contacts",
          editContact: "Edit",
        },
        required: "Required Field",
        accountData: "Payout information",
        payment: "Payout",
        cancel: "Cancel",
        save: "Save changes",
        recommend: "Send recommendation",
      },
      paymentDataForm: {
        nameWarning:
          "Please contact our support team to change this account holders name",
        payment: "Payout",
        owner: "Account Holder",
        iban: "IBAN",
        bank: "Bank",
        bic: "BIC",
        bankLocation: "Bank location",
        ownerData: "Account holder information",
        lastName: "Last name",
        firstName: "First name",
        ibanError: "This IBAN is invalid. Please verify the given IBAN",
      },
      accountDataForm: {
        title: "Edit account holder",
        accountData: "Payout account data",
        name: "Account holder name",
        type: "Type",
        phone: "Phone / mobile (for further inquiries)",
        address: "Address",
        street: "Street",
        number: "Street number",
        zip: "ZIP",
        city: "City",
        region: "Country",
        anschrift: "Address",
        nameWarning:
          "Please contact our support to change the account holder name",
      },
      contact: {
        owner: "Account Holder",
        edit: "Edit",
        person: "PERSON",
        company: "COMPANY",
        details: "Details",
      },
      invite: {
        breadcrumbs: {
          page: "Recommend Rentablo",
        },
        title: "Recommend {{appName}} Cashback and get {{amount}} € bonus!",
        subtitle: "That’s how it works",
        subtitle2:
          "You may also send an email containing the promotion code right now",
        description:
          "Please send your personal promotion-code to your friend using SMS or WhatsAPP. Your friend may use this code during subscription.",
        myName: "Sender name",
        friendName: "Recipient name",
        email: "Recipient email",
        message: "Message (optional)",
        send: "Send",
        promotion: "Promotion code",
        success: "The email with the code was successfully sent to your friend",
      },
      breadcrumbs: {
        home: "Home",
        cashback: "Cashback",
      },
    },
  },
  questions: {
    INVESTMENT_HORIZON: {
      title: "How long would you like to invest your money?",
      subtitle: "Please select your investment horizon",
      options: {
        LONG_TERM: {
          title: "Long Term Investing",
          subtitle:
            "Investment with an investment horizon of more than 7 years",
        },
        MID_TERM: {
          title: "Medium-Term Investing",
          subtitle: "Investment with an investment horizon of 3 to 7 years",
        },
        SHORT_TERM: {
          title: "Short Term Investing",
          subtitle:
            "Investment with an investment horizon of less than 3 years",
        },
      },
    },
    SUSTAINABILITY: {
      title: "How important is sustainability to you?",
      subtitle: "Please select your preference",
      options: {
        MORE_IMPORTANT: {
          title: "Sustainability is more important to me than return",
          subtitle:
            "Sustainability is a priority, I would too forego higher returns",
        },
        IMPORTANT: {
          title: "Sustainability is important to me",
          subtitle: "Basically important, but not an exclusion criterion",
        },
        LESS_IMPORTANT: {
          title: "Returns are more important to me than sustainability",
          subtitle: " I want a good return, sustainability is secondary",
        },
        NOT_IMPORTANT: { title: "I don't care", subtitle: "No preference" },
      },
    },
    RISK_RETURN_PREFERENCE: {
      title:
        "How would you rate your personal Assess the risk/reward propensity?",
      subtitle: "Choose the option that best applies to you",
      options: {
        NO_RISK: {
          title: "I don't accept any risk of loss",
          tooltip:
            "No risk. Only fixed-term deposit products with fixed interest.",
        },
        LOW_RETURN_EXPECTATION: {
          title:
            "My expected return is low. I accept small price fluctuations.",
          tooltip: "Low risk. Investments focused on stability.",
        },
        MODERATE_RETURN_EXPECTATION: {
          title:
            "I have a moderate return expectation. In return, I accept a moderate risk of loss due to market fluctuations.",
          tooltip:
            "Medium risk. Investments focused on long-term capital growth.",
        },
        HIGH_RETURN_EXPECTATION: {
          title:
            "I expect a high return that is above the capital market interest rate level for as long as possible. In return, I accept the corresponding market fluctuations and higher risk of loss.",
          tooltip:
            "High risk. Investments focused on opportunities and higher returns.",
        },
      },
    },
    LIQUID_ASSETS: {
      title: "How high is your amount of liquid assets?",
      subtitle:
        "The details of your assets and liabilities help us to assess your risk-bearing capacity and to determine a maximum investment amount.",
      CASH: "How much cash assets do you have?",
      CASH_placeholder: "Please select",
      cashAssetsOptions: {
        UNDER_20K: "Under € 20.000",
        "20K_TO_50K": "€ 20.000 - € 50.000",
        "50K_TO_100K": "€ 50.001 - € 100.000",
        OVER_100K: "Over € 100.000",
      },
      ASSETS_IN_SECURITIES:
        "How much of your assets have you invested in securities?",
      ASSETS_IN_SECURITIES_placeholder: "Please select",
      securitiesOptions: {
        UNDER_20K: "Under € 20.000",
        "20K_TO_50K": "€ 20.000 - € 50.000",
        "50K_TO_100K": "€ 50.001 - € 100.000",
        OVER_100K: "Over € 100.000",
      },
    },
    NET_INCOME_AND_NET_EXPENSES: {
      title: "What experience and knowledge do you have with funds and ETFs?",
      subtitle:
        "We want to make sure you're comfortable with your investment products, so we ask how experienced you are with specific investments.",
      YEARS_INVESTING_FUNDS:
        "Experience - How many years have you been investing in this financial instrument?",
      investingYearsOptions: {
        NO_INVEST: "No experience",
        UP_TO_1: "Up to 1 year",
        UP_TO_3: "Up to 3 years",
        OVER_3: "More than 3 years",
      },
      KNOWLEDGE_FUNDS:
        "Knowledge - How familiar are you with the workings, opportunities and risks of this financial instrument?",
      knowledgeOptions: {
        NO_KNOWLEDGE: "No knowledge",
        LOW_KNOWLEDGE: "Little knowledge",
        MEDIUM_KNOWLEDGE: "Moderate knowledge",
        HIGH_KNOWLEDGE: "Extensive knowledge",
      },
      TRADES_PER_YEAR_FUNDS: "Average number of trades per year",
      averageFundTransactionsOptions: {
        "1_TO_4": "0 to 4",
        "5_TO_10": "5 to 10",
        "11_TO_50": "11 to 50",
        OVER_50: "More than 50",
      },
    },
    PREFERENCE_ETF_OR_FUNDS: {
      title: "Do you prefer ETFs or managed funds for your investments?",
      subtitle:
        "We want to make sure that you feel comfortable with your investment products. We therefore ask you about your preferences for certain investments.",
      infoBox: {
        title: "The difference between ETF and mutual fund",
        text: "The goal of traditional investment funds is to outperform an index, while exchange traded funds (ETFs) track the respective indices. Investment funds are actively managed by a fund management, whereas ETFs works without active fund management. Investors have to pay higher fees for active fund management than for passively managed ETFs.",
      },
      options: {
        ETF: {
          title: "ETFs",
          subtitle: "Passive fund management",
        },
        FUNDS: {
          title: "Fonds",
          subtitle: "Active fund management",
        },
        NO_PREFERENCE: {
          title: "Not important",
          subtitle: "No preference",
        },
      },
    },
    age: {
      title: "How old are you?",
      subtitle: "Please select your age",
      age: "Age",
      options: {
        "under-18": "Under 18",
        "18-25": "18 to 25 years",
        "26-40": "26 to 40 years",
        "41-60": "41 to 60 years",
        "over-60": "Over 60 years",
      },
    },
    children: {
      title: "How many children do you have?",
      subtitle: "Please enter the number",
      children: "Number of children",
    },
    income: {
      title: "What is your monthly income and expenses?",
      subtitle:
        "Please provide realistic information so we can suggest the investment that best suits you.",
      income: "Monthly net income",
      expenses: "Monthly expenses",
      options: {
        income: {
          "under-1000": "Under 1.000 euros",
          "1000-1500": "1.000 - 1.500 euros",
          "1501-2500": "1.501 - 2.500 euros",
          "over-2500": "Over 2.500 euros",
        },
        expenses: {
          "under-1000": "Under 1.000 euros",
          "1000-1500": "1.000 - 1.500 euros",
          "1501-2500": "1.501 - 2.500 euros",
          "over-2500": "Over 2.500 euros",
        },
      },
    },
  },
  recommender: {
    title: "Our investment suggestions for you",
    description:
      'We show you alternative products to your fund "{{name}}". The product suggestions are sorted by a score that measures how well the product matches your investment profile. Additionally, each product shows specific advantages compared to "{{name}}" (e.g. lower fees, higher returns).',
    matchScore: "Matches your information by {{score}}%",
    openProductDetails: "to the product details",
    addToWatchlist: "Add to watchlist",
    removeFromWatchlist: "Remove from watchlist",
    goToWatchlist: "To watchlist",
    compare: "Compare product",
    showMore: "show more products",
    showLess: "show fewer products",
    results: "{{count}} product results",
    watchlistName: "Rentablo product suggestions",
    scoreTooltip:
      "The product suggestions are sorted by a score that measures how well the product matches your investment profile",
    back: "Back",
    chips: {
      all: "All",
      fonds: "Funds",
      etf: "ETF",
    },
    tags: {
      popular: "Popular with other investors",
      popularTooltip:
        "Popularity is measured by the volume of customer funds (AuM) managed by a fund or ETF. The label 'Popular with other investors' is only given to funds or ETFs with a volume over 500 million euros.",
      savingsPlan: "Eligible for savings plan",
      distributing: "Distributing",
      retaining: "Accumulating",
      lowerRisk: "{{percentage}}% Lower risk",
      higherReturn: "{{percentage}}% Higher return",
      lowerFees: "{{percentage}}% Lower fees",
      lowerFeesTooltip:
        "Fees are compared based on the total expense ratio (TER). The total expense ratio is a percentage indicator that shows the annual costs of a fund or ETF.",
      holdings: "Holdings",
    },
    compareView: {
      title:
        "Compare your selected product with the existing product in the portfolio.",
      stockPerformanceOf: "Stock performance of {{name}}",
      noData: "No data is currently available.",
      performanceRisk: {
        title: "Compare performance and risk",
        yieldTitle: "{{name}} has a {{percentage}}% higher return",
        yieldTooltip:
          "Performance is determined by the annualized return. This is calculated based on historical performance for the available period.",
        yieldLabel: "Return",
        riskTitle: "{{name}} has a {{percentage}}% lower risk",
        riskTooltip:
          "Risk is determined by volatility. Volatility is expressed as the annualized standard deviation of daily returns for the available period.",
        riskLabel: "Risk",
      },
      fees: {
        title: "Compare Ongoing Fee",
        feeTitle: "{{name}} has {{percentage}}% lower ongoing fee",
        feeTooltip:
          "Ongoing costs are a measure of the total expenses associated with managing and operating an investment fund or ETF.",
        feeLabel: "Ongoing Fee",
        cost: "Cost",
        productName: "PRODUCT",
        ongoingFee: "Ongoing Fee",
      },
      donutCharts: {
        showMore: "Show more details",
        showLess: "Show less details",
        regionTitle: "Investments by region",
        industryTitle: "Investments by Industry",
        region: "Regions",
        industries: "Industries",
        branch: "Investments by branch",
        top10Holdings: "Top 10 Holdings",
        fromFund: "From {{name}} Fund",
        global: "Global",
        regions: {
          americas: "Americas",
          europe: "Europe",
          asia: "Asia",
          africa: "Africa",
          oceania: "Oceania",
        },
      },
      productInfo: {
        title: "Important product information",
        header: {
          label: "Label",
          productDataOf: "Product data of {{name}}",
        },
        rows: {
          provider: "Provider",
          replicationMethod: "Replication method",
          distributionPolicy: "Distribution policy",
          directPurchaseVia: "Direct purchase via",
          savingsPlan: "Savings plan",
          payoutPlans: "Payout plans",
          qualityRating: "FWW® Rating",
          sustainability: "Sustainability",
          popularity: "Popularity",
          diversificationOverlapTitle:
            "Diversification of top holdings with the existing portfolio",
          before: "Before",
          after: "After",
        },
      },
    },
    detailsModal: {
      header: {
        isin: "ISIN",
        wkn: "WKN",
      },
      details: {
        thema: "Theme",
        region: "Regions",
      },
      quoteChartTitle: "Performance chart",
      ideaTitle: "Investment idea",
      holdings: "Top 10 holdings",
      cashback: {
        title: "Costs",
        cashbackTitle: "Costs and Cashback Savings",
        ter: "Total expense ratio (TER)",
        adminFee: "Management fee",
        amountPercentage: "Cashback-eligible amount",
        premiumDiscount: "Your front-end load discount",
        commision: "Trailer fee: which bank pays how much?",
        example: "You can view an investment of 10,000 euros.",
        goToCashback: "Apply for fund cashback now",
      },
      distributionTypes: {
        distributing: "Distributing",
        retained: "Accumulating",
      },
      distributionFrequency: {
        monthly: "Monthly",
        quarterly: "Quarterly",
        halfYearly: "Half-yearly",
        annually: "Annually",
        daily: "Daily",
      },
    },
  },
  gaugeChart: {
    risk: "Risk",
    performance: "Perf.",
    riskClass: {
      extremelyLow: "Extremely low",
      veryLow: "Very low",
      low: "Low",
      medium: "Medium",
      high: "High",
      veryHigh: "Very high",
      extremelyHigh: "Extremely high",
      unknown: "Unknown",
    },
    performanceClass: {
      negative: "Negative",
      veryLow: "Very low",
      low: "Low",
      medium: "Medium",
      high: "High",
      veryHigh: "Very high",
      top: "Top",
      unknown: "Unknown",
    },
  },
  performanceTags: {
    title: "Price Development",
    tags: "Tags",
  },
  performanceGauges: {
    risk: "Risk",
    riskClass: "Risk class",
    riskTooltip:
      "Each product is assigned a risk class. The classification into 7 classes is based on volatility. Volatility is given as the annualized standard deviation of daily returns over the available period per strategy.",
    performance: "Performance",
    performanceClass: "Performance class",
    performanceTooltip:
      "Each product is assigned a performance class. The classification into 7 classes is based on annualized return. This is calculated based on historical performance over the available period per strategy.",
    volatility: "Volatility (1Y / 3Y)",
    noData: "N/A",
  },
  performanceNumbers: {
    value: "Value",
    actual: "Actual",
  },
  cashflowAnalyzer: {
    title: "Budget",
    accountsBalance: "Account balance",
    bannerTitle:
      "Your expenses this month were <red>{{amount}}</red> above your average value",
    chartTitle: "Income and expenses by category",
    actualMonth: "Actual month",
    mean: "Average",
    income: "Income",
    expenses: "Expenses",
    balance: "Liquid funds",
    monthly: "Monthly",
    quarterly: "Quarterly",
    yearly: "Yearly",
    total: "Total expenses",
    sankeyChart: {
      noExpenses: "No expenses",
      revenue: "Income",
    },
    chartSwitcher: {
      flow: "Flow",
      distribution: "Distribution",
    },
    chart: {
      period: "Period",
      unclassified: "Not classified",
    },
    statistic: {
      currentMonth: "Current Month",
      average: "Average",
      revenue: "Revenue",
      expenditure: "Expenditure",
      liquidAssets: "Liquid Assets",
    },
    transactionsTable: {
      title: "Transactions",
      showMore: "Show more transactions",
      noData: "No transactions for the selected period",
      filter: "Filter",
      thisTransactionIs: "This transaction is",
      category: "Category",
      regular: "Regular",
      accountTransfer: "An account transfer",
      account: "Account",
      counterpart: "Counterpart",
    },
    depotsSelector: {
      allAccounts: "All accounts",
      amountAccounts: "{{ selected }} of {{ total }} accounts",
    },
    categoryModal: {
      searchPlaceholder: "Quick Search Category",
      title: "Change Category",
      addCategory: "Add New Category",
      back: "Back",
      save: "Save",
    },
    addCategoryModal: {
      title: "Add New Category",
      main: "Create parent category",
      sub: "Create subcategory",
      mainCategory: "Choose parent category",
      mainCategory_placeholder: "Please select",
      subCategoryName: "Create subcategory",
      subCategoryName_placeholder: "New category",
      mainCategoryName: "Create category",
      mainCategoryName_placeholder: "New Category",
      created: "Category was created successfully",
      deleted: "Category was deleted successfully",
      assigned: "Category was assigned successfully",
    },
  },
  contractAnalyzer: {
    title: "Contract Analyzer",
    ytdExpenses: "Contract expenses year-to-date",
    fullYearExpenses: "Contract expenses full year {{year}}",
    showInactive: "Show inactive contracts",
    createNewContract: "Add new contract",
    curation: {
      menuItem: "Contract curation",
      modalTitle: "Contract curation",
      description:
        "Our assistant reviews all contracts of one account and automatically fixes duplicates, wrong names and misclassified contracts.",
      selectAccount: "Account",
      noAccounts: "No accounts available.",
      start: "Start curation",
      runningTitle: "Curation in progress…",
      resultTitle: "Curation completed",
      successGeneric:
        "The contracts of your account were reviewed and curated successfully.",
      failedTitle: "Curation failed",
      failedGeneric:
        "The curation could not be completed. Please try again later.",
      errorSnackbar: "Contract curation failed",
    },
    infoBanner:
      "Please update your accounts so that your contracts can be recognized automatically. The contracts will then be displayed here, grouped by payment period.",
    categories: {
      all: "All",
      7: "Insurances",
      8: "Housing",
      1: "Finance",
      6: "Savings",
      4: "Telecommunication",
      2: "Leisure",
      3: "Children",
      5: "Mobility",
      74: "Care and Social Services",
      75: "Productivity",
      notClassified: "Not classified",
    },
    subCategories: {
      9: "Bank charges",
      10: "Mortgage financing",
      11: "Loan repayment and interest",
      12: "Donation",
      13: "Taxes",
      14: "Other financial expenses",
      15: "Membership",
      16: "Streaming services",
      17: "Sports & Fitness",
      18: "Software & Cloud",
      19: "Newspapers & Magazines",
      20: "Other leisure expenses",
      21: "Childcare",
      22: "School & Support",
      23: "Other children's expenses",
      24: "Internet & Telephone",
      25: "Mobile communications",
      26: "Car (car subscription, leasing)",
      27: "Bicycle (leasing)",
      28: "Bus & Train",
      29: "Building savings contract",
      30: "Savings plan",
      31: "Trailer insurance",
      32: "Builder's liability insurance",
      33: "Occupational disability insurance",
      34: "Eyeglass insurance",
      35: "Drone liability insurance",
      36: "Device insurance",
      37: "Statutory pension insurance",
      38: "Water damage liability insurance",
      39: "Liability insurance",
      40: "Household contents insurance",
      41: "Hunting liability insurance",
      42: "Vehicle insurance",
      43: "Capital life insurance",
      44: "Deposit insurance",
      45: "Combined property insurance",
      46: "Daily sickness benefits insurance",
      47: "Supplementary health insurance",
      48: "Life insurance",
      49: "Motorcycle insurance",
      50: "Long-term care insurance",
      51: "Photovoltaic liability insurance",
      52: "Private health insurance",
      53: "Legal protection insurance",
      54: "Travel health insurance",
      55: "Pension insurance",
      56: "Riester pension",
      57: "Term life insurance",
      58: "Rürup/Basis pension",
      59: "Other property insurance",
      60: "Death benefit insurance",
      61: "Animal owner liability insurance",
      62: "Animal health insurance",
      63: "Accident insurance",
      64: "Residential building insurance",
      65: "Caravan insurance",
      66: "Supplementary dental insurance",
      67: "Other insurance",
      68: "Gas",
      69: "Rent",
      70: "Broadcasting fees",
      71: "Electricity",
      72: "Incidental housing costs",
      73: "Other housing expenses",
      76: "Nursing home",
      77: "Home care",
      78: "Other social expenses",
      79: "Other productivity expenses",
      83: "Statutory health insurance",
      notClassified: "Not classified",
    },
    newContractModal: {
      createContract: {
        title: "Create new contract",
        subtitle: "New contract into which the transactions will be imported",
        description:
          "Note: Amount and frequency will be entered automatically after the corresponding transactions have been selected and the new contract has been created.",
      },
      selectTransactions: {
        title: "Search transactions for the new contract",
        accountPlaceholder: "Account",
        selectPeriod:
          "Select the account and the desired period for your transaction search",
        periods: {
          default: "Default period",
          from: "From",
          to: "To",
        },
        defaultPeriodOptions: {
          oneDay: "1 day",
          threeDays: "3 days",
          tenDays: "10 days",
          thirtyDays: "30 days",
          sixtyDays: "60 days",
          ninetyDays: "90 days",
          hundredEightyDays: "180 days",
          threeHundredSixtyDays: "360 days",
        },
        showOtherSearchOptions: "Show all other search criteria",
        all: "All",
        notClassified: "Not classified",
        noData:
          "No transactions found for the selected filters. Please try again",
      },
      confirmSelection: {
        title: "Please check your entries",
        subtitle: "You can add the preselected transactions to a new contract.",
        allPreselectedTransactions: "All preselected transactions",
        yourContract: "Your contract into which the transactions are imported",
        info: "Note: Amount and frequency are entered automatically after the new contract has been created.",
      },
      category: {
        title: "Change category",
      },
      buttons: {
        back: "Back",
        createNewContract: "Create new contract",
        addToNewContract: "Add to new contract",
      },
      success: "The contract was created successfully",
      error: "Something went wrong. Please try again",
    },
    notRecognized: {
      titleSingle: "1 contract was not fully recognized.",
      subtitleSingle: "I have identified 1 contract where I am not sure.",
      title: "{{count}} contracts were not fully recognized.",
      subtitle: "I have identified {{count}} contracts where I am not sure.",
      reviewContracts: "Review contracts",
    },
    graph: {
      period: "Period",
      totalAmount: "Total amount",
    },
    table: {
      allContracts: "All contracts",
      category: "Category:",
      subcategory: "Subcategory: {{count}}",
      noData: "No contracts available",
      noDataSelectedFilter: "No contracts available for this category",
      noDataAllSubsUnchecked:
        "No contracts available. Please select a subcategory.",
      showAll: "Show all others",
      needsReviewTooltip:
        "This contract was not fully recognized. Please click on the pencil icon to edit and complete or correct the details if necessary.",
      timeIntervals: {
        1: "Monthly",
        2: "Every 2 months",
        3: "Quarterly",
        6: "Semi-annually",
        12: "Annually",
        other: "Other",
      },
      columns: {
        logo: "Deadline",
        contractNameExpiryDate: "Contract name / Expiry date",
        type: "Type",
        costs: "Costs",
      },
      options: {
        delete: "Delete contract",
        showAllContracts: "Show all contracts",
        showAllContractsHint: "Including unconfirmed and hidden ones",
      },
      expiryIn: "Expires in {{time}}...",
      expiryInTooltip:
        "The days or months indicate the time until the next contract extension. You always know how long you have left to cancel your contract. If you have not specified the end of the contract and the notice period yourself, a 30-day notice period before the next payment date will be used as standard.",
      noExpiry: "Monitor contract deadlines now",
      noExpiryTooltip:
        "Would you like to be reminded when you can cancel your contract? Please enter the end of the contract and the notice period manually.",
      debitedOn: "Debited on {{date}}",
      deleteContract: {
        title_one: "Delete contract",
        title_other: "Delete {{count}} contracts",
        text_one: "Are you sure you want to delete this contract?",
        text_other:
          "Are you sure you want to delete {{count}} contracts? This action cannot be undone.",
        cancel: "Back",
        confirm: "Delete contracts",
        success: "Contracts successfully deleted",
        error: "Something went wrong. Please try again",
      },
      newProvider: "New provider",
    },
    unrecognizedContractsModal: {
      title: "Check contract ({{current}} of {{total}})",
      titleSingle: "Check contract",
      description: "Is this contract recognized correctly?",
      transactionDetails: "Details of the last transaction:",
      confirmButton: "Confirm contract",
      cancelButton: "Skip contract",
      discardButton: "Discard contract",
      discardConfirm: {
        title: "Delete this contract?",
        text: "This action cannot be undone.",
        confirm: "Yes",
        cancel: "No",
        success: "The contract was deleted.",
        error: "Failed to delete the contract. Please try again.",
      },
      success: "The contract has been successfully confirmed.",
      error: "Confirmation of the contract failed. Please try again.",
      completeReview:
        "You have processed all contracts that were not fully recognized. You can now close the modal by clicking on the X in the top right or anywhere on the web page.",
    },
    editModal: {
      title: "Edit contract",
      description:
        "Here you can change the provider and the category / subcategory of your contract.",
      tabs: {
        details: "Details",
        transactions: "Transactions",
        transactionsWithCount: "Transactions ({{count}})",
        manage: "Manage",
      },
      providerPlaceholder: "Sample provider",
      labels: {
        provider: "Provider*",
        name: "Name",
        subCategory: "Subcategory",
        amount: "Amount",
        timeInterval: "Frequency",
        comment: "Comment",
      },
      subCategoryPlaceholder: "Please select",
      cancelButton: "Back",
      confirmButton: "Save",
      success: "The changes were saved successfully.",
      error: "Something went wrong. Please try again",
      category: {
        modalTitle: "Change category",
        searchPlaceholder: "Quick search category",
      },
      alarm: {
        copy: "You can set a reminder for the expiration date of the contract so that you do not forget to cancel the contract at the time specified in the contract.",
        toggle: "Activate contract alarm",
        label: "Alarm",
      },
      alarmEdit: {
        copy: "The contract alarm can be configured when the contract alarm feature is activated.",
        button: "Configure contract alarm",
        label: "Configure",
        description: "Please enter the cancellation date as per the contract.",
        modalTitle: "Activate contract alarm for this contract",
        modalTitleEdit: "Edit contract alarm for this contract",
        save: "Activate contract alarm",
        labels: {
          endDate: "Contract end date",
          endDateTooltip:
            "Please enter the date on which the contract can be terminated as soon as possible (minimum term).",
          noticePeriod: "Notice period",
          noticePeriodTooltip:
            "Please enter the period by which you must terminate the contract at the latest before the minimum term expires.",
          contractDuration: "Contract duration",
          contractDurationTooltip:
            'Contract duration: "Please enter the term by which the contract will automatically be extended after the minimum term expires."',
        },
        global: {
          title: "Global settings for all contracts",
          copy: "Here you can specify certain periods in which you would like to be notified about the expiration date of your contracts. This setting will automatically be applied to all contacts in your list.",
          labels: {
            remindMe: "Remind me before",
            snooze: "Snooze (snooze button)",
          },
          back: "Back",
          save: "Save settings",
        },
        noticePeriods: {
          notSpecified: "Not specified",
          monthlyCancelable: "Cancelable monthly",
          twoWeeks: "2 weeks",
          fourWeeks: "4 weeks",
          sixWeeks: "6 weeks",
          twoMonths: "2 months",
          threeMonths: "3 months",
          fourMonths: "4 months",
          fiveMonths: "5 months",
          sixMonths: "6 months",
          oneYear: "1 year",
        },
        contractTerms: {
          oneTime: "One-time",
          monthly: "Monthly",
          biMonthly: "Every two months",
          quarterly: "Quarterly",
          biAnnually: "Semi-annually",
          annually: "Annually",
        },
        reminder: {
          noSnooze: "No snooze",
          oneDay: "1 day",
          twoDays: "2 days",
          threeDays: "3 days",
          fourDays: "4 days",
          fiveDays: "5 days",
          sixDays: "6 days",
          oneWeek: "1 week",
          twoWeeks: "2 weeks",
          threeWeeks: "3 weeks",
          oneMonth: "1 month",
        },
        snooze: {
          noReminder: "No reminder",
          oneDay: "1 day",
          threeDays: "3 days",
          oneWeek: "1 week",
          twoWeeks: "2 weeks",
          threeWeeks: "3 weeks",
          oneMonth: "1 month",
          twoMonths: "2 months",
          threeMonths: "3 months",
        },
      },
      transactions: {
        modalTitle: "Bookings",
        transactionsNumber:
          "You have made {{count}} bookings under this contract",
        nextTransaction: "The next booking will be made after {{inTime}}",
        split: {
          description:
            "You can split this contract into two contracts. To do this, first select the transactions that should be removed from the existing contract and added to a new contract",
          addToNewContract: "Add transactions to new contract",
          addToNewContractShort: "Add to new contract",
          splitButton: "Add to new contract",
        },
      },
      split: {
        button: "Split contract",
        label: "Split",
        tooltip:
          "After the split, the additional contract will be displayed in your contract overview. The costs of the additional contract are included in the total costs.",
        modalTitle: "Split contract",
        description:
          "Select the transactions to remove from „{{name}}“ and move into a new contract.",
        previewEmptyNote:
          "Select at least one transaction above to create a new contract.",
        resultLabel: "New contract",
        transactionCount_one: "{{count}} transaction",
        transactionCount_other: "{{count}} transactions",
        selectedSuffix: "{{count}} selected",
        deselectAll: "Clear selection",
        deselectAllShort: "Clear",
        confirmButton: "Create new contract",
        confirmModal: {
          modalTitle: "Create new contract?",
          text: "This action cannot be automatically undone.",
          confirmButton: "Yes",
          cancelButton: "No",
        },
      },
      merge: {
        tooltip:
          "After the combination, the second contract is deleted and no longer appears in your contract overview.",
        button: "Combine",
        label: "Combine",
        modalTitle: "Combine contracts",
        description:
          "You can combine a second contract with this contract. The data of the master contract remains. The amounts of the two contracts are added together in the master contract.",
        masterContract:
          "Master contract (into which the second contract is read)",
        masterTag: "Master contract",
        addSecondContract: "Add second contract",
        secondContract: "Second contract",
        absorbedTag: "will be merged",
        removeSecondContract: "Remove second contract",
        resultLabel: "Result",
        confirmButton: "Combine contracts",
        confirmModal: {
          modalTitle: "Combine contracts?",
          text: "Are you sure you want to combine these contracts? Unfortunately, it is not possible to separate them automatically again.",
          confirmButton: "Yes",
          cancelButton: "No",
        },
      },
      selectContract: {
        modalTitle: "Search contract",
        searchPlaceholder: "Provider, Name, Type, Amount",
        showMore: "Show more",
        noDataForAccount: "No contracts available for this account",
        columns: {
          name: "Contract name",
          type: "Type",
          amount: "Costs",
        },
      },
      showHide: {
        copy: "Exclude from overview and total costs.",
        toggle: "Hide contract",
        tooltip:
          "If you hide the contract, it will no longer be displayed in your contract overview. The costs of the contract will no longer be included in the total costs. However, the contract will not be deleted and can be shown again at any time",
      },
      internalTransfer: {
        copy: "Payments between your own accounts don't count as expenses.",
        toggle: "Mark as internal transfer",
      },
    },
  },
  contractAdminPage: {
    title: "Provider Name",
    breadcrumb: "Provider Name",
    searchLabel: "Here you can search for provider names",
    searchPlaceholder: "Enter name",
    table: {
      name: "Name",
      iban: "Iban",
      category: "Category",
      subCategory: "Sub-category",
      popularity: "Popularity",
      status: "Status",
      date: "Date",
      done: "Done",
    },
    buttonText: "Done",
    tooltip: {
      userSuggestions: "User suggestions for provider name",
      edit: "Edit",
    },
    noData: "No classification data available",
    modal: {
      title: "Mark this entry as completed?",
      subtitle: "This action cannot be undone.",
      cancelButton: "No",
      confirmButton: "Yes",
      success: "Entry completed successfully.",
      error: "Something went wrong. Please try again later",
    },
  },
  settings: {
    changesSaved: "Changes saved",
    errorOccurred: "An error has occurred",
    sidebar: {
      title: "Settings",
      common: {
        title: "General",
        profile: "Profile",
        notifications: "Notifications",
        premium: "Premium Packages",
        advanced: " Advanced",
        currency: "Default Currency",
        apiAccess: "API access",
      },
      themeMode: {
        title: "Interface view",
        dark: "Dark mode",
      },
      bankConnections: {
        title: "Bank Connections",
        addNewConnection: "Add new connection",
        noAccountsTooltip:
          "No accounts or depots exist for this bank connection. Before rebuilding the bank connection, please first delete the existing bank connection. This will prevent potential problems when importing accounts or depots.",
      },
      twoFA: {
        title: "Security settings",
      },
      userId: {
        label: "USER ID",
        tooltip:
          "This is your UserID. You need this ID e.g. for support requests or to connect with KICS.",
      },
      language: {
        title: "Language",
      },
    },
    currency: {
      title: "Change Default Currency",
      description:
        "Here you can change the default currency for your account. Every user has 'Euro' preset as the default currency. If you'd like to use a different currency (e.g. US Dollar or British Pound), simply select it from the dropdown. Finally, apply the new default currency by clicking the 'Save new default currency' button.",
      form: {
        label: "Currencies",
      },
      saveButton: "Save new default currency",
      saveSuccess: "Default currency successfully saved",
    },
    twoFA: {
      title: "Security settings",
      subtitle: "Two-factor authentication",
      codeLabel: "Enter code",
      methods: {
        title: "Your 2FA method",
        subtitle:
          "Two-factor authentication generates a unique, temporarily valid security code for each login attempt. The following overview suggests suitable apps.",
        googleAuth: "Google Authenticator",
        microsoftAuth: "Microsoft Authenticator",
        linkForAndroid: "Link for Android",
        linkForApple: "Link for Apple",
      },
      disabled: {
        description:
          "Protect your account by enabling two-factor authentication (2FA). To set it up, an authenticator app is required (see options below).",
        toggle: "Enable two-factor authentication",
      },
      enabled: {
        description:
          "Your account is protected by two-factor authentication (2FA).",
        description1:
          "To disable two-factor authentication, use the toggle and enter the provided one-time code.",
        toggle: "Disable two-factor authentication",
      },
      setup: {
        step1: {
          title: "Step 1 – Secure your account",
          subtitle:
            "Scan the QR code below with your preferred authenticator app and then enter the generated one-time code below.",
        },
        step2: {
          title: "Step 2",
          subtitle: "Enter the two-factor verification code.",
        },
        confirmButton: "Enable 2FA",
      },
      disable: {
        description: "Enter the two-factor verification code.",
        disableButton: "Disable 2FA",
      },
      messages: {
        error: "Something went wrong. Please try again",
        qrLoadError: "The QR code could not be loaded. Please try again.",
        invalidCodeError: "Invalid or expired code. Please try again.",
        disableSuccess: {
          title: "Two-factor authentication",
          text: "Two-factor authentication for your account has been disabled.",
        },
        enableSuccess: {
          title: "Two-factor authentication",
          text: "Two-factor authentication has been enabled.",
        },
      },
    },
    apiAccess: {
      title: "API access",
      subtitle:
        "Manage API tokens for programmatic access to your assets. Each token is limited to the permissions you select.",
      createButton: "Create token",
      table: {
        id: "ID",
        name: "Name",
        permissions: "Permissions",
        lastUsed: "Last used",
        expires: "Expires",
        createdAt: "Created {{date}}",
        lastUsedToday: "today, {{time}}",
        neverUsed: "Never used",
        noExpiry: "No expiry",
        expired: "Expired {{date}}",
        revokeAction: "Revoke token",
        footnote:
          "Revoked tokens become invalid immediately. The secret token value is only shown once, at creation.",
      },
      emptyState: {
        title: "No API tokens yet",
        text: "Create a token to access your data from your own applications.",
      },
      createModal: {
        title: "Create new API token",
        subtitle: "The token receives exactly the permissions you select here.",
        nameLabel: "Name",
        namePlaceholder: "e.g. Portfolio Sync",
        nameHint: "Helps you recognize the token later.",
        unnamedToken: "Unnamed token",
        permissionsLabel: "Permissions",
        selectAll: "Select all",
        deselectAll: "Deselect all",
        permissionsError: "Select at least one permission.",
        permissions: {
          accountsRead: "Read accounts",
          accountsWrite: "Modify accounts",
          investmentsRead: "Read investments",
          investmentsWrite: "Modify investments",
          transactionsRead: "Read transactions",
          transactionsWrite: "Modify transactions",
          profileRead: "Read profile",
          profileWrite: "Modify profile",
        },
        validityLabel: "Validity",
        validity: {
          days30: "30 days",
          days60: "60 days",
          days90: "90 days",
          oneYear: "1 year",
          never: "No expiry",
        },
        cancel: "Cancel",
        submit: "Create token",
        error: "The token could not be created. Please try again later.",
      },
      createdModal: {
        title: "Token created",
        subtitle: "“{{name}}” is active as of now.",
        warning:
          "Copy the token now — for security reasons it is only shown this one time and cannot be retrieved later.",
        tokenLabel: "Your API token",
        done: "Done",
      },
      deleteModal: {
        title: "Revoke token?",
        text: "“{{name}}” becomes invalid immediately. Applications using this token will receive 401 Unauthorized from then on.",
        cancel: "Cancel",
        confirm: "Revoke",
        error: "The token could not be revoked. Please try again later.",
      },
      snackbar: {
        revoked: "Token revoked",
      },
    },
    profile: {
      title: "Your User Profile",
      subtitle: "Customize Your User Information",
      avatar: {
        title: "Avatar",
        upload: " Upload avatar",
        replace: "Replace avatar",
        delete: "Delete",
        info: "We support PNGs, JPEGs with a file size below 10MB.",
      },
      form: {
        gender: "Salutation",
        academicTitle: "Title",
        genderOption: {
          male: "Mr.",
          female: "Ms.",
        },
        academicTitleOption: {
          none: "No title",
          dr: "Dr.",
          prof: "Prof.",
          profDr: "Prof. Dr.",
        },
        firstName: "First name",
        lastName: "Last name",
        email: "Email address",
        oldEmail: "Current email address",
        newEmail: "New email address",
        newEmail_placeholder: "Your new email address",
        newEmailConfirmation: "New email address repeat",
        newEmailConfirmation_placeholder: "Your new email address",
        oldPassword: "Current password",
        forgotPassword: "Forgot your password",
        oldPassword_placeholder: "Please enter your current password",
        newPassword: "Set new password",
        newPassword_placeholder: "Please set a password...",
      },
      emailEditLink: "Change email address",
      passwordEditLink: "Change password",
      emailEditModal: {
        title: "Change email",
        subtitle: "Enter your new email address",
        close: "Close",
        submit: "Change email address",
        success:
          "We have sent a confirmation email to <strongText>{{email}}</strongText>. Your old email address will remain valid until confirmed.",
      },
      passwordEditModal: {
        title: "Change Password",
        subtitle: "Enter your new password",
        close: "Cancel",
        submit: "Change Password",
        success: "Your password was successfully changed",
        forgotPassword: "Forgot your password",
        error: "Something went wrong. Please try again",
      },
      emailChangeSuccess: "Email address changed",
      emailChangeError:
        "Email address could not be changed. Please contact our support.",
      saveSuccess: "Changes saved",
    },
    notifications: {
      title: "Notifications",
      subtitle: "Customize your notifications",
      banner: {
        title: "All notifications disabled",
        subtitle: "You are currently not receiving any notifications",
      },
      form: {
        investmentReportFrequency: "Investment Report",
        investmentReportFrequency_weekly: "Weekly",
        investmentReportFrequency_monthly: "Monthly",
        investmentReportFrequency_never: "Never",
        emailNotification: "Automatic notification of portfolio updates ",
        emailNotification_yes: "Yes",
        emailNotification_no: "No",
      },
      kpmgReport: {
        buttonText: "Send report now",
        tooltip:
          "This button sends the status report immediately to the registered email address. This can be done as many times as needed for testing purposes. The regular delivery schedule (Weekly/12 Days/Monthly) is not affected.",
        success: "The report was sent successfully.",
        error: "The report could not be sent. Please try again.",
      },
    },
    advanced: {
      title: "Advanced",
      subtitle: "Customize the advanced features that affect your account",
      bankImport: { title: "Bank import connection settings" },
      deleteConnection: {
        title: "Delete all finAPI bank connection data",
        text: "Delete all of your data stored at <linkText>finAPI</linkText> . Data that has already been imported is retained. It is then no longer possible to synchronize your depots and accounts.",
        info: "If you only want to delete a saved PIN, please do so here in the account management",
        buttonText: "Delete bank data",
        deleteConnectionConfirmModal: {
          title: " Are you sure?",
          text: "If you delete your bank details, there will no longer be an automatic depot and account update.",
          cancel: "Cancel",
          confirm: "Delete connection",
        },
      },
      tracking: {
        title: "Tracking",
        text: "Help us to improve {{appName}} through statistics on website usage and user behavior. The data will only be used to improve our website.",
        buttonTextOff: "Revoke consent",
        buttonTextOn: "Give consent",
      },
      deleteAccount: {
        title: "Close {{appName}} Account Permanently",
        text: "Your {{appName}} is hereby closed accounts. Your data will be irrevocably deleted as a result. Access to your account is no longer possible after the closure.",
        info: "This process cannot be undone!",
        buttonText: "Delete {{appName}} Account",
        deleteAccountConfirmModal: {
          title: "Are you sure?",
          text: "Your account will be closed and all data will be irrevocably deleted. Further access is then no longer possible.",
          cancel: "Cancel",
          confirm: "Delete account",
          success: "Your account has been successfully deleted",
        },
      },
    },
    bankConnection: {
      subtitle: "Manage accounts and custody accounts",
      accounts: {
        title: "Accounts",
        menu: {
          deleteSavedPins: "Delete Saved Pins",
          deleteBankDetails: "Delete Bank Details",
        },
      },
      accountTypes: {
        1: "Checking account",
        2: "Savings account",
        3: "Credit card",
        4: "Portfolio",
        5: "Loan account",
        6: "Checking account",
        7: "Membership",
        8: "Building savings",
        21: "Settlement account",
        22: "Foreign currency account",
        "01_depot": "Portfolio",
        "02_cash": "Checking account",
      },
      deletePinsModal: {
        title: "Are you sure?",
        text: "The next time you update your securities depot account, {{appName}} will ask for your new banking PIN.",
        cancel: "Cancel",
        submit: "Delete Pins",
        error: "Something went wrong. Please try again later",
        success: "Pins were successfullly deleted",
      },
      deleteBankConnectionModal: {
        title: "Are you sure?",
        text: "If you delete your bank details, the automatic portfolio and account update will no longer take place.",
        cancel: "Cancel",
        submit: "Delete connection",
        error: "Something went wrong. Please try again later",
        success: "Connection was successfully deleted",
      },
      interfaces: {
        title: "Interfaces",
        active: "Active",
        info: "{{appName}} enables access to around 3,500 bank connections. The corresponding interfaces (API) are primarily provided by our partner finAPI. In addition, {{appName}} has connected some banks and brokers itself via direct API. These include comdirect, Trade Republic, Whitebox, Quirion and Scalabe.",
        actualized: "Updated",
      },
    },
  },
  components: {
    depotSelect: {
      label: "Select portfolios or accounts",
      noOptions: "No portfolios or accounts found",
      loading: "Loading portfolios and accounts...",
      types: {
        "01_depot": "PORTFOLIOS",
        "02_cash": "ACCOUNTS",
      },
      modal: {
        title: "Create new portfolio",
        name: "Portfolio name",
        name_placeholder: "Portfolio name",
        save: "Create",
      },
    },
    depotsStatistic: {
      showHistoricSwitch: "Show historic",
      tabs: {
        export: "Export CSV",
        exportShort: "Export",
        investments: "Investments",
        bookings: "Bookings",
      },
      bookingsTable: {
        noItems: "There are no bookings",
        headers: {
          type: "Type",
          name: "Name",
          price: "Price",
          amount: "Amount",
        },
        lots: "Pc.",
        mobile: {
          count_one: "{{count}} booking",
          count_other: "{{count}} bookings",
          typeFilter: {
            label: "Transaction type",
            all: "All transaction types",
            selected: "{{count}} transaction types",
          },
          sort: {
            valueDate: "Date",
            amount: "Amount",
            newest: "Newest first",
            oldest: "Oldest first",
          },
          loadingMore: "Loading more bookings…",
          allLoaded: "All bookings loaded",
          loadMoreFailed: "More bookings could not be loaded.",
          retry: "Try again",
        },
      },
      chart: {
        today: "today",
        subheader: {
          performance: "Total value:",
          valuation: "Valuation:",
        },
        typeSwitcher: {
          performance: "Performance",
          valuation: "Valuation",
        },
      },
    },
    bankSearchField: {
      label: "Please select your bank",
      placeholder: "Enter name, ISIN or WKN",
      useSlug: 'Search "{{value}}"',
    },
    watchlistsCreateAndEditForm: {
      form: {
        nameInputLabel: "New Watchlist",
        saveButton: "Save",
      },
    },
    AssetTypeCard: {
      ytd: "YTD",
    },
    quotes: {
      quoteChartContainer: {
        subheader: "Current value",
      },
    },
    layouts: {
      showcaseLayout: {
        imageAlt: "{{appName}} Logo",
      },
    },
  },
  aboutCompany: {
    support: {
      phone: "(0) 30 - 71 53 30 10",
      phoneLink: "+03071533010",
      phoneInfo: "Available Monday to Friday from 9 a.m. to 6 p.m.",
      email: "{{supportEmail}}",
    },
    company: {
      name: "{{appName}}, eine Marke der wealthAPI GmbH",
      street: "Fanny-Zobel-Str.",
      streetNumber: "9",
      zip: "12435",
      city: "Berlin",
      claim: "Das kostenfreie Tool für Ihren Finanzerfolg",
    },
    brand: {
      name: "{{appName}}",
    },
    media: {
      email: "presse@rentablo.de",
      b2bEmail: "presse@wealthapi.eu",
    },
    b2b: {
      name: "wealthAPI GmbH",
      claim: "Smart Financial Decisions",
      email: "info@wealthapi.eu",
      privacyEmail: "datenschutz@wealthapi.eu",
      website: "https://wealthapi.eu",
    },
  },
  docs: {
    agb: {
      title: "Allgemeine Geschäftsbedingungen (AGB)",
    },
    disclaimer: {
      title: "Haftungsausschluss",
    },
    impressum: {
      title: "Imprint",
    },
    privacy: {
      title: "Data protection",
    },
  },
  feedbackGlobalButton: {
    tooltip: "Feedback",
    emailSubject: "Feedback for the {{teamName}} Team",
  },
  customerSupport: {
    tooltip: "Report a problem",
    title: "Report a problem",
    subtitle:
      "Please fill in the form below. We will process your request as soon as possible.",
    userId: {
      label: "User ID:",
    },
    bank: {
      label: "Bank",
    },
    isin: {
      label: "ISIN",
    },
    stepsToReproduce: {
      label: "Steps to reproduce",
      required: "Please describe the problem.",
    },
    errorCodeOrUrl: {
      label: "Error code / URL",
    },
    attachments: {
      label: "Attachment - screenshot, video",
      hint: "Please drag the screenshot or the video here.",
      remove: "Remove attachment",
      limits: "Up to {{max}} files, 10 MB each. Images, videos or PDF.",
      full: "The maximum of {{max}} files is reached.",
      ready: "Ready",
      rejected:
        "Up to {{max}} files (image, video or PDF) of at most 10 MB each are allowed.",
      readError: "The attachments could not be read. Please try again.",
    },
    cancel: "Back",
    submit: "Submit",
    success: "Thank you! Your request has been submitted.",
    error: "Your request could not be submitted. Please try again later.",
  },
  navigation: {
    cancel: "Cancel",
    previous: "Previous",
    next: "Next",
    save: "Save",
    deleteModal: {
      errorTitle: "Error",
      confirmTitle: "Confirm delete?",
      yes: "Yes",
      no: "No",
      close: "Close",
      cannotBeUndone: "This action cannot be undone",
    },
  },
  somethingWrong: {
    loginFailed: "Login failed, please check your email and password",
    shortTitle: "Sorry, something went wrong.",
    subTitle:
      "Try again. Please contact our support using {{supportEmail}} if this problem persist.",
    title:
      "Sorry, something went wrong. Try again. Please contact our support using {{supportEmail}} if this problem persist.",
    message: "{{message}}.",
    eventIdMessage: "The error ID is: {{eventId}}",
    reload: "Reload",
  },
  company: {
    name: "{{appName}} GmbH",
    customerService: "Customer service",
    street: "Fanny-Zobel-Straße 9",
    zip: "12435",
    city: "Berlin",
  },
  cashback: {
    50: "Cashback-50",
    100: "Cashback-100",
    "50upTo": "up to 75.000 €",
    "100from": "from 75.000 €",
  },
  terms: {
    agb: "Terms of use",
    impressum: "Imprint",
  },
  ranges: {
    years: {
      oneYear: "1 Year",
      threeYears: "3 Years",
      fiveYears: "5 Years",
      tenYears: "10 Years",
    },
    max: "Max",
  },
  accountTypes: {
    "01_depot": "Depot",
    "02_cash": "Accounts & Credit Card",
    "04_insurance": "Insurance",
    "05_material_assets": "Precious metals and tangible assets",
    "06_crypto": "Crypto",
    "07_real_estate": "Real Estate",
    bankSelect: {
      label: "Bank Name, BIC or IBAN",
      noOptions: "No options",
      bankName: "Bank name",
      bic: "BIC",
    },
  },
  bookingTypes: {
    buy: "Buy",
    sell: "Sell",
    dividend: "Dividend",
    book_in: "Book-in",
    book_out: "Book-out",
    split: "Split",
    reverse_split: "Reverse split",
    retained_dividend: "Retained dividend",
    purchase_right: "Purchase right",
    carve_out: "Carve-out",
    pre_tax_allowance: "Tax-free allowance",
    switch: "Switch",
    cap_gains_tax: "Withholding tax",
    cap_gains_tax_refund: "Withholding refund",
    fees: "Fees",
  },
  investmentTypes: {
    "11_stock": "Stock",
    "21_fund": "Fund",
    "22_etf": "ETF",
    "31_bond": "Bond",
    "41_cash": "Cash",
    "51_certos": "Certificate / OS",
    "52_future": "Future",
    "61_pmetals": "Precious metal",
    "71_massets": "Material Asset",
    "81_fcurr": "Foreign currency",
    "82_crypto": "Cryptocurrency",
    "91_managed": "Robo / Managed depot",
    "92_other": "Other",
  },
  quantities: {
    pieces: "lots",
    percent: "per cent",
  },
  signupWizard: {
    restoreWizardDialog: {
      title: "You have a booking in progress. Would you like to continue?",
      contentText: "You can have only one booking in progress in a time.",
      continueButton: "Continue",
      startNewButton: "Start new",
    },
    validation: {
      isNotEmpty: "is required",
      isNotEmptyArray: "must not be empty",
      isPhoneNumber: "phone number is invalid",
      isPassword: "password must have at least 8 characters",
      isAgbAccepted: "you must accept agb",
      isEmail: "email is invalid",
      isPayoutBank: "Given IBAN is not correct",
      isComdirectCustomerNumber: "must be 10 numbers (0-9)",
      isEbaseDepotNumber: "must be 10 or 11 numbers (0-9)",
      isDabAccountNumber: "must be 7 numbers (0-9)",
      isAugsburgerAktienbankDepotNumber: "must be 10 numbers (0-9)",
      isDwsDepotNumber: "starting with letter and 7 numbers",
      isFfbDepotNumber: "must be 10 numbers (0-9)",
      isFondsdepotDepotNumber: "must be 9 or 10 numbers (0-9)",
      isMetzlerDepotNumber: "must be 10 numbers (0-9)",
      isStreetWithNumber: "is required",
    },
    cashbackProcessIntroduction: {
      heading: "That's how it works:",
      enterData: "Enter Data",
      print: "Print",
      sendToUs: "Send to us",
      youRequire:
        "You require: About <1>5 minutes</1> together with your account or customer ID in case you are already a customer of one of our partner banks.",
      startNow: "Start now",
      thatIsHowWeCalculateCashback: "That is how we calculate your cashback",
      depotSize: "Depot size",
      bestPriceGuarantee:
        "<0>Best-Price Guarantee:</0> we automatically select the cashback model that fits you best",
      onceForAllYourDepots: "no matter how many depots you have",
      discountOnAgio: "Agio discount",
      cost: "Cost",
      noCost: "None",
      youReceive: "Your cashback",
      "50percentCashback": "50 % of the portfolio commission",
      "100percentCashback": "up to 100 % of the portfolio commission",
      administrationFee: "15 € / month",
      administrationFeeDetails: "(offset against Cashback)",
      rentabloReceives: "Rentablo receives",
      moreAssetsMoreCashback: "Receive up to 100% Cashback",
      seeIllustration: "See interactive chart",
    },
    cashbackSummary: {
      heading: "Print PDF form now",
      printOutNote:
        "Your Cashback form has been generated and are available for download.",
      printedOutQuestion: "Printed out?",
      foundAMistake: "Found a mistake",
      correctDataButton: "Change data",
      print: "Print here",
      printPdf: "Print forms",
      nextStepsButton: "That's next",
      wouldYouLikeToCorrectYourData: "Would you like to correct your data?",
    },
    cashbackNextSteps: {
      heading: "Perfect, almost done!",
      reviewForms: "Please review the generated forms.",
      printOutAndSign:
        "Now <1>please sign the printed out documents</1> and send it to us!",
      sendBack: "Send document",
      sendBackDescription: "A return-cover is included in your documents.",
      identifyViaPostident: "and <1>identify using PostIdent</1>",
      identifyViaPostidentDescription:
        "The PostIdent form is included in the generated documents.",
      identifyViaRentablo: "and <1>include a copy of your ID card</1>",
      identifyViaRentabloDescription:
        "To open the depot, our staff will identify you. We will contact you after receiving your documents.",
      birthCertificate: "Include a <1>Certificate of birth</1>",
      birthCertificateDescription:
        "Please include the minors certificate of birth, which is required by the bank.",
      allDone: "All done!",
      backButton: "Back to subscription",
      addAnotherDepot: "Add another depot",
      altExit: "or",
      backToMainPage: "Back to overview",
    },
    cashbackNextStepsForCompany: {
      heading: "Perfect, the next steps are...",
      dataReceived: "We received your request for opening a depot",
      weWillContactYou: "We will contact you shortly",
      weWillContactYouDescription:
        "Unfortunately, banks frequently change the process to open a company depot. One ouf our employees will contact you shortly and support you with the steps required to open your companies depot.",
      contactUs:
        "Should you not hear from us within the next working day, please do not hesitate to contact us via Email to <1>{{supportEmail}}</1> or give us a call under <1>030 - 71533009</1>.",
    },
    selectNewOrExistingDepotStep: {
      naturalPerson: "Private customer",
      legalPerson: "Legal Person (UG / GmbH / AG / Foundation)",
      newDepot: "Open new depot",
      newCompanyDepot: "Open new depot for company",
      existingDepot: "I have an existing depot",
      existingCompanyDepot: "I have an existing depot for my company",
      question: "Please select an option:",
    },
    companyDepotTermsStep: {
      question: "Note: Terms for company depots",
      terms:
        "Company depots are pretty distinct from private customer depots in terms of size and administration effort. For this reason, your cashback will be <1>80 % overall</1> of portfolio commission received by Rentablo.",
      oneClick:
        "On top, you will have free access to the Rentablo One-Click Import to easily manage your portfolio.",
    },
    selectBankStep: {
      question: "At which bank would you like to open a depot?",
      onvistaQuestion:
        "At which partner bank would you like to open an onvista-cashback depot?",
      recommendedBankHeading:
        "Due to their excellent service and our positive experience we recommend comdirect bank",
    },
    selectRecommendedBankStep: {
      question: "At which bank would you like to open a depot?",
      recommendedBankHeading:
        "Due to their excellent service and our positive experience we recommend comdirect bank",
    },
    selectExistingDepotStep: {
      question: "Which of the Rentablo partner banks is managing your depot?",
      noDepotYet: "No depot at a Rentablo partner bank as of yet?",
      openDepot: "Open depot now.",
    },
    emailStep: {
      question: "What's your email?",
      placeholder: "Email",
    },
    passwordStep: {
      question: "Type secure password",
      placeholder: "Password",
    },
    acceptTermsAndConditionsStep: {
      question: "Please accept terms and conditions",
      agb: "With the registration I accept the <1>terms and conditions</1> and <3>data protection regulations</3>*",
      newsLetters:
        "I would like to be informed about new functions and savings offers",
      accountCreationFailed:
        "Sorry, but we could not create a user for the following reason:",
      pleaseLogin:
        "In case you you used this email address before, please <1>Login to your Rentablo account</1>",
    },
    selectAccountHolderTypeStep: {
      questionNewDepot: "Which type of account would you like to open?",
      questionAdvisorChange:
        "Which kind of account would you like to transfer?",
      single: "Single",
      joined: "Joined",
      minor: "Minor (with legal custodians)",
    },
    // Natural person
    summaryStep: {
      takeoverData: "Yes, continue",
      editData: "No, edit data",
    },
    personalInformationSummaryStep: {
      question: "Is account holder's personal data correct?",
      questionPartner: "Is your partners personal data correct?",
      questionMinor: "Is the minors personal data correct?",
      questionLegalGuardian1:
        "Is the first legal guardians personal data correct?",
      questionLegalGuardian2:
        "Is the second legal guardians personal data correct?",
      questionCompany: "I the companies' data correct?",
      gender: "Gender",
      firstName: "First name",
      lastName: "Last name",
      nameAtBirth: "Name at birth",
      dateOfBirth: "Date of birth",
      placeOfBirth: "Place of birth",
      countryOfBirth: "Country of birth",
      street: "Street",
      houseNumber: "Street number",
      zip: "ZIP",
      city: "City",
      addressCountry: "Country",
    },
    companyInformationSummaryStep: {
      question: "Are the company data correct?",
      salutation: "Salutation",
      companyName: "Company name",
      legalForm: "Legal form",
      street: "Street",
      houseNumber: "Street number",
      zip: "ZIP",
      city: "City",
      addressCountry: "Country",
    },
    payoutSummaryStep: {
      question: "Is the Cashback payout information correct?",
      bankNameWithBic: "Bank",
      iban: "IBAN",
      payoutAccountFirstName: "Holders first name",
      payoutAccountLastName: "Holders last name",
    },
    mifidSummaryStep: {
      question: "Is your MIFID data correct",
      questionPartner: "Is your partners MIFID data correct?",
      questionMinor: "Is the minors MIFID data correct?",
      questionLegalGuardian1:
        "Is the first legal guardians MIFID data correct?",
      questionLegalGuardian2:
        "Is the second legal guardians MIFID data correct?",
      mifidOccupationGroup: "Occupational group",
      mifidOccupation: "Occupation",
      mifidSector: "Sector",
      mifidCountryOfWork: "Country of work",
      mifidAccessToInsiderInfo: "Access to insider information",
      yes: "Yes",
      no: "No",
      mifidAnnualIncome: "Annual income",
      mifidLiquidAssets: "Liquid Assets",
    },
    investmentExperienceSummaryStep: {
      question: "Is your investment experience correct?",
      0: "not provided",
      1: "less than a year",
      2: "more than a year",
      3: "more than two years",
      experienceCertificatesAndOptionsWithLeverage:
        "Certificates and options with leverage",
      experienceCertificatesAndOptionsWithoutLeverage:
        "Certificates and options without leverage",
      experienceDomesticBonds: "Domestic bonds",
      experienceDomesticStocks: "Domestic stocks",
      experienceForeignCurrency:
        "Foreign currency investments (excluding futures)",
      experienceForeignStocks: "Foreign stocks",
      experienceFunds: "Investment funds (issues residing outside of the EU)",
      experienceOther: "Other futures or products with leverage",
      experienceForeignBonds:
        "Bonds emitted by foreign issuers or in foreign currency",
    },
    taxationSummaryStep: {
      question: "Is your taxation data correct",
      questionPartner: "Is your partners taxation data correct?",
      questionMinor: "Is the minors taxation data correct?",
      questionLegalGuardian1:
        "Is the first legal guardians taxation data correct?",
      questionLegalGuardian2:
        "Is the second legal guardians taxation data correct?",
      taxationCountry1: "Tax residence",
      taxationNumber1: "Tax ID",
      taxationCountry2: "Additional tax residence",
      taxationNumber2: "Additional Tax ID",
      taxationCountry3: "Additional tax residence",
      taxationNumber3: "Additional Tax ID",
      taxationUsTaxLiability: "US tax liability",
      taxationUsTaxNumber: "US tax ID",
      yes: "Yes",
      no: "No",
    },
    selectGenderStep: {
      question: "What is your gender?",
      questionPartner: "What is the gender of your partner?",
      questionMinor: "What is the gender of the minor?",
      questionLegalGuardian1: "What is the gender of the first legal guardian?",
      questionLegalGuardian2:
        "What is the gender of the second legal guardian?",
      questionCompany: "What is your salutation?",
      male: "male",
      female: "female",
      salutation: "Salutation",
    },
    hasSecondLegalGuardianStep: {
      question: "Is there a second legal guardian?",
      single: "Single parent",
      joined: "Add a second legal guardian",
    },
    firstNameStep: {
      question: "What is your first name?",
      questionPartner: "What is your partners first name?",
      questionMinor: "What is the minors first name?",
      questionLegalGuardian1: "First name of the first legal guardian",
      questionLegalGuardian2: "First name of the second legal guardian",
      questionCompany: "What is the company name",
      placeholder: "First name",
      companyplaceholder: "Company name",
      companyPlaceholder: "Company name",
    },
    lastNameStep: {
      question: "What is your last name?",
      questionPartner: "What is your partners last name?",
      questionMinor: "What is the minors last name?",
      questionLegalGuardian1: "Last name of the first legal guardian",
      questionLegalGuardian2: "Last name of the second legal guardian",
      questionCompany: "Legal form (GmbH / UG, ...)",
      placeholder: "Last name",
      companyplaceholder: "Legal form",
      companyPlaceholder: "Legal form",
    },
    countryOfBirthStep: {
      question: "In which country were you born?",
      questionPartner: "In which country was your partner born?",
      questionMinor: "In which country was the minor born?",
      questionLegalGuardian1:
        "In which country was the first legal guardian born?",
      questionLegalGuardian2:
        "In which country was the second legal guardian born?",
      placeholder: "Please select a country",
    },
    placeOfBirthStep: {
      question: "What is your place of birth?",
      questionPartner: "What is your partners place of birth?",
      questionMinor: "What is the minors place of birth?",
      questionLegalGuardian1:
        "What is the first legal guardians place of birth?",
      questionLegalGuardian2:
        "What is the second legal guardians place of birth?",
      placeholder: "Place of birth",
    },
    nameAtBirthStep: {
      question: "What is your maiden name?",
      questionPartner: "What is your partners maiden name?",
      questionMinor: "What is the minors maiden name?",
      questionLegalGuardian1: "What is the first legal guardians maiden name?",
      questionLegalGuardian2: "What is the second legal guardians maiden name?",
      placeholder: "Name of birth",
    },
    dateOfBirthStep: {
      question: "When were you born?",
      questionPartner: "When was your your partner born?",
      questionMinor: "When was the minor born?",
      questionLegalGuardian1: "When was the first legal guardian born?",
      questionLegalGuardian2: "When was the second legal guardian born?",
      placeholder: "Date of birth",
      label: "Date of birth",
    },
    addressStep: {
      question: "Address: What is your street?",
      questionPartner: "Address: What is your partners street?",
      questionMinor: "Address: what is the minors street?",
      questionLegalGuardian1:
        "Address: What is the first legal guardians street?",
      questionLegalGuardian2:
        "Address: What is the second legal guardians street?",
      questionCompany: "Registered office: street",
      placeholder: "Street",
      placeholderHouseNumber: "House number",
    },
    houseNumberStep: {
      placeholder: "House number",
    },
    zipStep: {
      question: "Address: What is your ZIP?",
      questionPartner: "Address: what is your partners ZIP?",
      questionMinor: "Address: what is the minors ZIP?",
      questionLegalGuardian1: "Address: What is the first legal guardians ZIP?",
      questionLegalGuardian2:
        "Address: What is the second legal guardians ZIP?",
      questionCompany: "Registered office: ZIP",
      placeholder: "ZIP",
    },
    cityStep: {
      question: "Address: In which city do you live?",
      questionPartner: "Address: In which city does your partner live?",
      questionMinor: "Address: In which city does the minor live?",
      questionLegalGuardian1:
        "Address: In which city does the first legal guardians live?",
      questionLegalGuardian2:
        "Address: In which city does the second legal guardians live?",
      questionCompany: "Registered office: city",
      placeholder: "City",
    },
    addressCountryStep: {
      question: "Address: In which country do you live?",
      questionPartner: "Address: In which country does your partner live?",
      questionMinor: "Address: In which country does the minor live?",
      questionLegalGuardian1:
        "Address: In which country does the first legal guardian live?",
      questionLegalGuardian2:
        "Address: In which country does the second legal guardian live?",
      questionCompany: "Registered office: country",
      placeholder: "Country",
    },
    occupationalGroupStep: {
      question: "What is your occupation group?",
      questionPartner: "What is the occupation group of your partner?",
      questionMinor: "What is the minors occupation group?",
      questionLegalGuardian1:
        "What is the first legal guardians occupation group?",
      questionLegalGuardian2:
        "What is the second legal guardians occupation group?",
      placeholder: "Occupation group",
    },
    occupationStep: {
      question: "What is your occupation?",
      questionPartner: "What is your partners occupation?",
      questionMinor: "What is the minors occupation?",
      questionLegalGuardian1: "What is the first legal guardians occupation?",
      questionLegalGuardian2: "What is the second legal guardians occupation?",
      placeholder: "Occupation",
    },
    sectorStep: {
      question: "In which sector do you work?",
      questionPartner: "In which sector does your partner work?",
      questionMinor: "In which sector does the minor work?",
      questionLegalGuardian1:
        "In which sector does the first legal guardian work?",
      questionLegalGuardian2:
        "In which sector does the second legal guardian work?",
      placeholder: "Occupational sector",
    },
    countryOfWorkStep: {
      question: "In which country do you work?",
      questionPartner: "In which country does your partner work?",
      questionMinor: "In which country does the minor work?",
      questionLegalGuardian1:
        "In which country does the first legal guardian work?",
      questionLegalGuardian2:
        "In which country does the second legal guardian work?",
      placeholder: "Please select a country",
    },
    accessToInsiderInfoStep: {
      question: "Do you have access to insider information?",
      questionPartner: "Does your partner have access to insider information?",
      questionMinor: "Does the minor have access to insider information?",
      questionLegalGuardian1:
        "Does the first legal guardian have access to insider information?",
      questionLegalGuardian2:
        "Does the second legal guardian have access to insider information?",
      yes: "yes",
      no: "no",
    },
    annualIncomeStep: {
      question: "What is your annual income?",
      questionPartner: "What is the annual income of your partner?",
      questionMinor: "What is the annual income of the minor?",
      questionLegalGuardian1: "What is the first legal guardians annual income",
      questionLegalGuardian2:
        "What is the second legal guardians annual income",
      placeholder: "Income",
    },
    liquidAssetsStep: {
      question: "What is your fortune (liquid assets)?",
      questionPartner: "What is your partners fortune (liquid assets)?",
      questionMinor: "What is the minors fortune (liquid assets)?",
      questionLegalGuardian1:
        "What is the first legal guardians fortune (liquid assets)?",
      questionLegalGuardian2:
        "What is the second legal guardians fortune (liquid assets)?",
      placeholder: "Liquid assets",
    },
    countryOfNationalityStep: {
      questionPrimary: "What is your nationality?",
      questionSecondary: "What is your secondary nationality?",
      questionPartnerPrimary: "What is your partners nationality?",
      questionPartnerSecondary: "What is your partners secondary nationality?",
      questionMinorPrimary: "What is the minors nationality?",
      questionMinorSecondary: "What is the minors secondary nationality?",
      questionLegalGuardian1Primary:
        "What is the first legal guardians nationality?",
      questionLegalGuardian1Secondary:
        "What is the first legal guardians secondary nationality?",
      questionLegalGuardian2Primary:
        "What is the second legal guardians nationality?",
      questionLegalGuardian2Secondary:
        "What is the second legal guardians secondary nationality?",
      placeholder: "Please select a country",
    },
    anotherNationalityStep: {
      question: "Do you have another nationality?",
      questionPartner: "Does your partner have another nationality?",
      questionMinor: "Does the minor have another nationality?",
      questionLegalGuardian1:
        "Does the first legal guardian have another nationality?",
      questionLegalGuardian2:
        "Does the second legal guardian have another nationality?",
      yes: "yes",
      no: "no",
    },
    npNationalIdentifierStep: {
      questionPrimary: "What is your national identifier?",
      questionSecondary:
        "What is your national identifier (second nationality)?",
      questionPartnerPrimary: "What is your partners national identifier?",
      questionPartnerSecondary:
        "What is your partners national identifier (second nationality)?",
      questionMinorPrimary: "What is the minors national identifier?",
      questionMinorSecondary:
        "What is the minors national identifier (second nationality)?",
      questionLegalGuardian1Primary:
        "What is the first legal guardians national identifier?",
      questionLegalGuardian1Secondary:
        "What is the first legal guardians national identifier (second nationality)?",
      questionLegalGuardian2Primary:
        "What is the second legal guardians national identifier?",
      questionLegalGuardian2Secondary:
        "What is the second legal guardians national identifier (second nationality)?",
      placeholder: "National identifier",
    },
    countryOfTaxationStep: {
      question: "What is your tax residence?",
      questionPartner: "What is your partners tax residence?",
      questionMinor: "What is the minors tax residence?",
      questionLegalGuardian1:
        "What is the first legal guardians tax residence?",
      questionLegalGuardian2:
        "What is the second legal guardians tax residence?",
      placeholder: "Select a country",
    },
    taxNumberStep: {
      question: "What is your tax number?",
      questionPartner: "What is your partners tax number?",
      questionMinor: "What is the minors tax number?",
      questionLegalGuardian1: "What is the first legal guardians tax number?",
      questionLegalGuardian2: "What is the second legal guardians tax number?",
      placeholder: "Tax number",
    },
    usTaxLiabilityStep: {
      question: "Are you liable for taxation in the US?",
      questionPartner: "Is your partner liable for taxation in the US?",
      questionMinor: "Is the minor liable for taxation in the US?",
      questionLegalGuardian1:
        "Is the first legal guardian liable for taxation in the US?",
      questionLegalGuardian2:
        "Is the second legal guardian liable for taxation in the US?",
      yes: "yes",
      no: "no",
    },
    npTaxationOneMoreStep: {
      question: "Are your liable for taxation in another country?",
      questionPartner:
        "Is your partner liable for taxation in another country?",
      questionMinor: "Is the minor liable for taxation in another country?",
      questionLegalGuardian1:
        "Is the first legal guardian liable for taxation in another country?",
      questionLegalGuardian2:
        "Is the second legal guardian liable for taxation in another country?",
      yes: "yes",
      no: "no",
    },
    investmentExperienceStep: {
      pleaseSelectOption: "please select",
      lessThanYearOption: "less than a year",
      moreThanYearOption: "more than a year",
      moreThanTwoYearsOption: "more than two years",
    },
    experienceCertificatesAndOptionsWithLeverageStep: {
      question:
        "What is your experience with certificates and options with leverage",
    },
    experienceCertificatesAndOptionsWithoutLeverageStep: {
      question:
        "What is your experience with certificates and options without leverage",
    },
    experienceDomesticBondsStep: {
      question: "What is your experience with domestic bonds",
    },
    experienceDomesticStocksStep: {
      question: "What is your experience with domestic stocks",
    },
    experienceForeignCurrencyStep: {
      question: "What is your experience with foreign currency",
    },
    experienceForeignStocksStep: {
      question: "What is your experience with foreign stocks",
    },
    experienceFundsStep: {
      question: "What is your experience with funds",
    },
    experienceOtherStep: {
      question: "What is your experience with other investments",
    },
    experienceForeignBondsStep: {
      question: "What is your experience with foreign bonds",
    },
    comdirectConditionModelStep: {
      question: "Which conditions model do you prefer?",
      subtitle: "Hint: you may change your conditions model at any time.",
      conditionModel3: 'Model "Flatfee"',
      conditionModel3Description:
        "The conditions model for large depots <1>from 8.000 €</1> <2>per Order</2>",
      conditionModel3DescriptionDetails:
        "Flat-fee of 19,95 € for orders / XETRA / bonds and sells",
      conditionModel5: 'Model "Standard"',
      conditionModel5Description:
        "The standard conditions model for depots <1>up to 8.000 €</1> <2>per Order</2>",
      conditionModel5DescriptionDetails:
        "0,25% of the order volume (min. 10,00 €, max. 90,00 €)",
    },
    dabConditionModelStep: {
      question: "Which conditions model do you prefer?",
      subtitle: "Hint: you may change your conditions model at any time.",
      conditionModel1228: 'Model "Flatfee"',
      conditionModel1228Description:
        "The conditions model for large depots <1>from 6.000 €</1> <2>per Order</2>",
      conditionModel1228DescriptionDetails:
        "Flat-fee of 15,00 € for orders / XETRA / bonds and sells",
      conditionModel1139: 'Model "Standard"',
      conditionModel1139Description:
        "The standard conditions model for depots <1>up to 6.000 €</1> <2>per Order</2>",
      conditionModel1139DescriptionDetails:
        "0,25% of the order volume (min. 10,00 €, max. 75,00 €)",
    },
    dwsDepotTypeStep: {
      question:
        "Which of your DWS products would you like to benefit from Rentablo Cashback",
      fundDepot: "My funds depot",
      retirementPlan: "My DWS retirement plans (Riester / Rürup / Basisrente)",
    },
    payoutIbanStep: {
      question: "Where should we pay your cashback to?",
      placeholder: "IBAN",
    },
    payoutAccountHolderLastNameStep: {
      question: "Payout account: What is the account holders last name?",
      placeholder: "Last Name",
    },
    payoutAccountHolderFirstNameStep: {
      question: "Payout account: What is the account holders first name?",
      placeholder: "First Name",
    },
    promotionCodeStep: {
      question: "Do you have a promotion code?",
      placeholder: "Promotion code",
      validationSuccess: "Discount",
    },
    phoneNumberStep: {
      question: "Und which phone number may we reach out to you?",
      placeholder: "Phone number",
    },
    usTaxNumberStep: {
      question: "What is your US-TIN/-SSN?",
      questionPartner: "What is your partners US-TIN/-SSN?",
      questionMinor: "What is the minors US-TIN/-SSN?",
      questionLegalGuardian1: "What is the first legal guardians US-TIN/-SSN?",
      questionLegalGuardian2: "What is the second legal guardians US-TIN/-SSN?",
      placeholder: "US-TIN/-SSN",
    },
    dabMobileForTanStep: {
      question: "To which number should DAB send your TAN?",
      placeholder: "Mobile number for TAN",
    },
    fondsdepotSelectDepotTypeStep: {
      question: "Would you like to open a normal or a VL Depot?",
      normal: "Normal",
      vl: "VL-Depot",
    },
    accountIdentifierStep: {
      question: "What is the identifier of your existing depot",
      questions: {
        COBADEHDXXX: "What is your comdirect customer number",
        DABBDEMMXXX: "What is your DAB account base number",
      },
      placeholders: {
        AUGBDE77XXX: "10 digits (0-9)",
        COBADEHDXXX: "10 digits (0-9)",
        DABBDEMMXXX: "7 digits (0-9)",
        DEUTDEFFXXX: "8 symbols; starting with a letter and then 7 digits",
        COBADEMXXXX: "10 or 11 digits (0-9)",
        FFBKDEFFTHK: "10 digits (0-9)",
        FODBDE77XXX: "10 digits (0-9)",
        METZDEFFXXX: "10 digits (0-9)",
      },
      accountIdentifierIsUsedMessage:
        "This depot / customer identifier has already been used in another cashback subscription.",
    },
    comdirectCustomerHelpStep: {
      helpText: "Where can I find my customer number?",
      question: "Where can I find my comdirect customer number?",
      description:
        'You will find your customer number in section "Persönlicher Bereich" using menu item, "Verwaltung" -> "Meine Daten"',
    },
    startDateStep: {
      question: "When subscription can be started?",
      label: "Start Date",
    },
    selectAccountHolderStep: {
      question: "Would you like to add a depot to an existing account holder?",
      subheading:
        "Adding a depot to an account holder is for free. Our cashback fees apply only once per account holder, including joined depots.",
      onvistaSubheading:
        "Each account holder can manage any number of their own or joint custody accounts free of charge.",
      orAddNew: "or",
      newAccountHolder: "Add an account holder",
      newAccountHolderNote:
        "Rentablo-Cashback fees apply on a per-account holder basis. By klicking here, you create a new account holder which will be billed separately.",
      onvistaNewAccountHolderNote:
        "Billing and payment are made per account holder. If you click here, you will create a new account holder who will be billed and paid out separately. Use this function e.g. for partners or your children.",
    },
    // BREAKPOINT FOR GENERATORS DO NOT REMOVE
    helpStep: { close: "Close" },
    nextButton: {
      next: "Next",
      skip: "Skip",
    },
    orEnter: "or press ENTER",
    header: {
      phone: {
        title: "Questions?",
      },
    },
    userCreatedNotification:
      "User already created. You can not change this step anymore.",
  },
  banks: {
    COBADEHDXXX: "comdirect",
    DABBDEMMXXX: "DAB BNP Paribas",
    AUGBDE77XXX: "Augsburger Aktienbank",
    DEUTDEFFXXX: "DWS",
    DEUTLU2DXXX: "MorgenFund",
    COBADEMXXXX: "FNZ",
    FFBKDEFFTHK: "FIL Fondsbank (FFB)",
    FODBDE77XXX: "Fondsdepot Bank",
    METZDEFFXXX: "Metzler (MFX)",
  },
  countryAutocomplete: {
    mostUsed: "Most used",
    others: "Others",
  },
  bankFacts: {
    rating: {
      description: "Our Rating",
    },
    allBanksLink: "show me a comparison of all banks",
    comdirect: {
      depotFee: "0 € Depot-fee",
      numberOfFunds: "more then 23.000 funds",
      fundSavingsPlan: "0.95 € for fund savings plan",
      allInOne: "Trade Funds, Stocks and ETF",
    },
  },
  cashbackCalculator: {
    cashback: {
      50: "Cashback-50",
      100: "Cashback-100",
    },
    detailed: {
      cashbackAreaChart: {
        rentabloFee: "Max. {{fee}} for Rentablo per month",
        rentabloFeeXs: "Max. {{fee}} for Rentablo",
        rentabloFeeCB50: "For Rentablo",
        cashbackLabel: "Your funds-cashback",
        depotVolume: "Depot volume",
        portfolioCommission: "Portfolio Commission",
        fee: "For Rentablo",
        yourCashback: "Your Cashback",
        perMonth: "monthly",
      },
      inputSlider: {
        label: "Your wealth",
      },
    },
  },
  products: {
    free: {
      subheader: "Basis Funktionen mit Rentablo-Konto",
      features: [
        "1 Bankverbindung",
        "3 Jahre Hitorische Daten",
        "Support nur über das Nutzerforum",
      ],
    },
    plus: {
      subheader: "für Investoren im Vermögensaufbau",
      features: [
        "alle <strong>Basis-Funktionen inklusive</strong>",
        "<strong>5</strong> Bankverbindungen",
        "<strong>6 Jahre</strong> Historische Daten",
        "E-Mail Support innerhalb von 5 Tagen",
        "Umsatzlisten hochladen",
        "Crypto",
        "Dividenden",
      ],
    },
    pro: {
      subheader:
        "für Investoren, die ihr Vermögen selbst professionell verwalten",
      features: [
        "alle <strong>PLUS Funktionen inklusive</strong>",
        "<strong>unbegrenzt</strong> viele Bankverbindungen",
        "<strong>10 Jahre</strong> Historische Daten",
        "<strong>Telefon-Support</strong>,",
        "<strong>unbegrenzt</strong> Umsatzlisten hochladen",
        "Data Enrichment",
        "Reports and Export-optionen",
        "Simulatoren",
      ],
    },
  },
  fundamentals: {
    topHoldings: "Top 10 Holdings",
    chartMenu: { hide: "Hide" },
    comparisonChart: {
      quote: "Quote",
      to: "to",
      noData: "No data. Please request missing data by email",
      remove: "Remove comparison",
    },
    metrics: {
      fScore: {
        normal: "RScore",
        short: "RScore",
        desc: "<strong class='bold'>The RScore</strong> reduces the inner value of a stock into a simple indicator. A companies fundamentals are weighted against each other and then relative to the current market value. The RScore has a maximum of 100 points (optimal) and minus -57 points.",
      },
      eps: {
        normal: "Earnings per share (EPS)",
        short: "EPS",
        desc: "<strong class='bold'>Earnings per share (EPS)</strong> is calculated as a company's profit divided by the outstanding shares of its common stock. The resulting number serves as an indicator of a company's profitability. It is common for a company to report EPS that is adjusted for extraordinary items and potential share dilution. The higher a company's EPS, the more profitable it is considered.",
      },
      totalLiabilities: {
        normal: "Total liabilities",
        short: "Total liabilities",
        desc: "<strong class='bold'>Total liabilities</strong> are the aggregate debt and financial obligations owed by a business to individuals and organizations at any specific period of time. Total liabilities are reported on a company's balance sheet and are a component of the general accounting equation: Assets = Liabilities + Equity.",
      },
      operatingCashflow: {
        normal: "Operating cash flow (OCF)",
        short: "OCF",
        desc: "<strong class='bold'>Operating cash flow (OCF)</strong> is a measure of the amount of cash generated by a company's normal business operations. Operating cash flow indicates whether a company can generate sufficient positive cash flow to maintain and grow its operations, otherwise, it may require external financing for capital expansion",
      },
      capEx: {
        normal: "Capital expenditures (CapEx)",
        short: "CapEx",
        desc: "<strong class='bold'>Capital expenditures (CapEx)</strong> are funds used by a company to acquire, upgrade, and maintain physical assets such as property, plants, buildings, technology, or equipment. CapEx is often used to undertake new projects or investments by a company. Making capital expenditures on fixed assets can include repairing a roof, purchasing a piece of equipment, or building a new factory. This type of financial outlay is also made by companies to maintain or increase the scope of their operations.",
      },
      freeCashflow: {
        normal: "Free cash flow (FCF)",
        short: "FCF",
        desc: "<strong class='bold'>Free cash flow (FCF)</strong> represents the cash a company generates after accounting for cash outflows to support operations and maintain its capital assets. Unlike earnings or net income, free cash flow is a measure of profitability that excludes the non-cash expenses of the income statement and includes spending on equipment and assets as well as changes in working capital from the balance sheet.",
      },
      totalEquity: {
        normal: "Total equity",
        short: "Total equity",
        desc: "<strong class='bold'>Total equity (or total capital)</strong> is all interest-bearing debt plus shareholders' equity, which may include items such as common stock, preferred stock, and minority interest.",
      },
      netIncome: {
        normal: "Net income",
        short: "Net income",
        desc: "<strong class='bold'>Net income</strong>, also called net earnings, is calculated as sales minus cost of goods sold, selling, general and administrative expenses, operating expenses, depreciation, interest, taxes, and other expenses. It is a useful number for investors to assess how much revenue exceeds the expenses of an organization. This number appears on a company's income statement and is also an indicator of a company's profitability.",
      },
      netRevenue: {
        normal: "Net revenue",
        short: "Net revenue",
        desc: "<strong class='bold'>Net revenue</strong> is the sales of a company from which returns, discounts, and other items are subtracted from. In accounting, Net refers to adjustments made to the original and therefore, it can be calculated after adjusting gross revenue with the discounts, returned products or any other direct selling expenses.",
      },
      outstandingShares: {
        normal: "Outstanding shares",
        short: "Outstanding shares",
        desc: "<strong class='bold'>Outstanding shares</strong> refer to a company's stock currently held by all its shareholders, including share blocks held by institutional investors and restricted shares owned by the company's officers and insiders. A company's number of shares outstanding is not static and may fluctuate wildly over time.",
      },
      returnOnAssets: {
        normal: "Return on assets (ROA)",
        short: "ROA",
        desc: "<strong class='bold'>Return on assets (ROA)</strong> is a financial ratio that shows the percentage of profit a company earns in relation to its overall resources. It is commonly defined as net income divided by total assets. Net income is derived from the income statement of the company and is the profit after taxes.",
      },
      returnOnEquity: {
        normal: "Return on equity (ROE)",
        short: "ROE",
        desc: "<strong class='bold'>Return on equity (ROE)</strong> is a measure of financial performance calculated by dividing net income by shareholders' equity. Because shareholders' equity is equal to a company's assets minus its debt, ROE is considered the return on net assets.",
      },
      priceToBook: {
        normal: "Price To Book",
        short: "P/B",
        desc: "Companies use the <strong class='bold'>price-to-book ratio (P/B ratio)</strong> to compare a firm's market capitalization to its book value. It's calculated by dividing the company's stock price per share by its book value per share (BVPS). An asset's book value is equal to its carrying value on the balance sheet, and companies calculate it netting the asset against its accumulated depreciation.",
      },
      priceToCashflow: {
        normal: "Price To Cashflow",
        short: "P/CF",
        desc: "<strong class='bold'>The price-to-cash flow (P/CF) ratio</strong> is a stock valuation indicator or multiple that measures the value of a stock's price relative to its operating cash flow per share. The ratio uses operating cash flow which adds back non-cash expenses such as depreciation and amortization to net income. It is especially useful for valuing stocks that have positive cash flow but are not profitable because of large non-cash charges.",
      },
      priceToFreeCashflow: {
        normal: "Price To Free Cashflow",
        short: "P/FCF",
        desc: "<strong class='bold'>Price to free cash flow</strong> is an equity valuation metric used to compare a company's per-share market price to its per-share amount of free cash flow (FCF). This metric is very similar to the valuation metric of price to cash flow but is considered a more exact measure, owing to the fact that it uses free cash flow, which subtracts capital expenditures (CAPEX) from a company's total operating cash flow, thereby reflecting the actual cash flow available to fund non-asset-related growth. Companies use this metric when they need to expand their asset bases either in order to grow their businesses or simply to maintain acceptable levels of free cash flow.",
      },
      priceToSales: {
        normal: "Price To Sales",
        short: "P/S",
        desc: "<strong class='bold'>The price-to-sales (P/S) ratio</strong> is a valuation ratio that compares a company's stock price to its revenues. It is an indicator of the value placed on each euro of a company's sales or revenues.",
      },
      dividendsPerYear: {
        normal: "Historic dividends",
        short: "Dividends",
        desc: "The companies dividend payment history. All values are aggregated for full years.",
      },
      historicQuotesPercent: {
        normal: "Historic market return up to now",
        short: "Market return",
        desc: "This is the market or share-price return from N years up to now.",
        xAxisLabel: "{{value}}Y",
      },
      priceToEarnings: {
        normal: "Price to Earnings Ratio (P/E)",
        short: "P/E",
        desc: "<strong class='bold'>The price-to-earnings ratio (P/E ratio)</strong> is the ratio for valuing a company that measures its current share price relative to its per-share earnings (EPS). The price-to-earnings ratio is also sometimes known as the price multiple or the earnings multiple.",
      },
    },
    metricsAutocomplete: {
      placeholder: "Compare to",
    },
    addMenu: {
      title: "Add Chart",
      noItems: "All available charts added",
    },
    dividends: {
      kpi: {
        latestDividend: "Last dividend ({{year}})",
        averageAndSum: "Ø yearly · Sum ({{count}} yrs)",
      },
    },
    detailInformation: {
      title: "Detailed information",
      marketCap: "Market capitalization",
      indexes: "Indexes",
      sector: "Sectors",
      lastUpdate: "Financials updated at",
      country: "Country",
    },
    year_one: "{{count}} Year",
    year_other: "{{count}} Years",
    onlyForProBlock: {
      updateToPro: "Upgrade now",
      title: "Only for Rentablo PRO members",
    },
    upgradeBlock: {
      title: "Up to 10 Years for Rentablo PRO Members",
      button: "Upgrade",
    },
    ranksAndRisks: {
      fwwFundStars: "FFW FundStars®",
      fwwFundStarsInfo:
        "Die FWW FundStars® basieren auf der Risikoadjustierten Performance (RAP). Diese zweidimensionale Kennzahl errechnet sich aus der erzielten Wertentwicklung (Performance) und dem dabei eingegangenen Risiko (Volatilität). Für die FWW FundStars® werden die Fonds in 5 Ranking-Stufen à 20 Prozent klassifiziert, aus denen die Auszeichnung mit 5 bis 1 Sternen hervorgeht. Dabei erhalten die besten 20 Prozent der Fonds fünf Sterne.",
      srri: "SRRI",
      srriInfo:
        "Der Synthetic Risk and Reward Indicator (SRRI) bezeichnet den synthetischen Risiko- und Ertragsindikator. Der SRRI ist eine Kennzahl für die Höhe der mit der Veranlagung in einem Fonds verbundenen Wertschwankungen. Der SRRI wird mit einer EU-weit einheitlichen Methodik ermittelt und kann die Werte 1 bis 7 annehmen, wobei höhere Werte für höhere Wertschwankungen stehen. In der Regel sind mit höheren Wertschwankungen auch höhere Renditechancen verbunden. Ein SRRI von 1 bedeutet aber nicht, dass es sich um eine risikofreie Anlage handelt.",
      title: "Ratings and risks",
    },
  },
  investment: {
    title: "Security",
    isinMissing: {
      title: "Missing ISIN",
      subtitle:
        "There is currently no valid ISIN for this security. Please add the ISIN so that the security can be correctly reported in the KICS report.",
    },
    header: {
      chart: {
        subheader: "Current worth",
      },
      actions: {
        addBookingButton: "Add booking",
        create: "Create",
        uploadPdf: "Upload PDF",
        selectDepots: "Select Depots",
        moreButton: "More",
        editInvestmentButton: "Edit investment",
        deleteInvestmentButton: "Delete investment",
      },
      deleteModal: {
        question: "Delete this investment?",
      },
    },
    details: {
      gainLossStatistics: {
        title: "My Performance",
        gainAndLoss: "P/L (Unrealized + realized)",
        returnOnInvestment: "Unrealized profit/loss",
        realizedGains: "Realized profit/loss",
        irr: "Yield (IRR) p. a. during {{years}} years",
        twror: "Performance",
        purchasePrice: "Purchase price",
        investedAmount: "Invested amount",
        marketValue: "Market value",
        tradingGains: "Trading gains",
        dividends: "Dividends",
        commission: "Commission",
        tax: "Taxes",
        fromMarketReturns: "from market returns",
        fromMarketAndCurrencyReturns: "from market and exchange rate returns",
        fromDividendsAndKupons: "from dividends/kupons",
      },
    },
    performance: "Performance",
    tabs: {
      fundamentals: "Fundamentals",
      news: "News",
      protocol: "Protocol",
      dividends: "Dividends",
    },
    protocolTable: {
      bookingType: "Type",
      overallValue: "Total value",
      period: "Period",
      amount: "Amount",
      expenses: "Expenses",
      totalSum: "Sum",
      noBookings: "No bookings for the time range",
      comment: "Comment",
      cancelled: "Cancelled",
      gainersAndLosersLabel: "P/L",
      actions: {
        title: "Actions",
        edit: "Edit",
        delete: "Delete",
      },
      deleteDialog: {
        title: "Deleting a booking",
        questionMessage: "Are you sure you want to delete this booking?",
        actions: {
          close: "Close",
          delete: "Delete",
        },
      },
    },
    dividends: {
      noDividends: "No dividends. Would you like to add manually?",
      noDividendsAddLink: "Add",
      addDividends: "Add manually",
      splitAdjust: "Split adjusted",
      mobile: {
        count_one: "{{count}} dividend",
        count_other: "{{count}} dividends",
        missing: "Not recorded",
      },
      missingDividends: {
        header_one: "There is {{value}} missing dividend.",
        header_other: "There are {{value}} missing dividends.",
        addBatchButton: "Add now",
      },
      dividendsTableHeaders: {
        date: "Date",
        dividend: "Dividend",
        lots: "Lots",
        total: "Total",
        actions: "Actions",
      },
      tableActions: {
        addDividends: "Add",
        editDividends: "Edit",
      },
    },
    newsBlock: {
      noNews: "No news",
    },
    recommendation: {
      title: "Product suggestions",
      description:
        "We have found products that better match your portfolio and preferences. The product can be added to the chart using the checkbox.",
      showAll: "View all suggestions",
    },
  },
  singleAccountPage: {
    breadcrumbs: {
      home: "Home",
      accounts: "Accounts",
    },
    header: {
      account: "Account",
      update: "Update",
      addTransaction: "Add transaction",
      edit: "Edit",
      manageBankConnection: "Manage Bank Connection",
      hide: "Hide",
      show: "Show",
      delete: "Delete account",
      deleteModal: {
        question: "Delete this account?",
      },
    },
    protocolTable: {
      title: "Transactions",
      headers: {
        valueDate: "Value Date",
        bookingDate: "Booking Date",
        bookingInformation: "Booking information",
        value: "Amount",
      },
      mobile: {
        count_one: "{{count}} transaction",
        count_other: "{{count}} transactions",
        search: "Search",
        loadingMore: "Loading more transactions…",
        allLoaded: "All transactions loaded",
      },
      details: {
        counterpart: "Counterpart",
        purpose: "Purpose",
        type: "Type",
        investment: "Investment",
      },
      search: {
        placeholder: "Search",
      },
      noPurpose: "Not available",
      export: "Export CSV",
      noItems: "No transactions for the time range",
      transfer: "Transfer",
      adjustingEntry: "Adjustment entry",
      adjustingEntryText:
        "If the account balance falls below zero due to a purchase, it will be automatically adjusted.",
      interval: {
        everyMonth: "Every Month",
        biMonthly: "Bi-Monthly",
        quarterly: "Quarterly",
        biAnnual: "Bi-Annual",
        annual: "Annual",
      },
    },
  },
  addManuallyPage: {
    addManuallyBreadcrumb: "Add transaction manually",
    header: {
      title: "Cash transaction",
      subtitle: "Create a new cash transaction",
    },
    form: {
      additionalInformation: {
        summary: "Additional information",
        interestTitle: "Interest / Fees:",
        interestBody:
          "Interest or fees such as custody account fees. Debit interest and fees have a negative sign, credit interest a positive sign.",
        otherGainsTitle: "Other profits:",
        otherGainsBody:
          "Profits from (unrecognized) securities transactions. This could be a refund or some other profit, for example.",
        taxRefundTitle: "Taxes / Refunds:",
        taxRefundBody:
          "Taxes paid or tax refunds received. Taxes paid have a negative sign, refunds received have a positive sign.",
      },
      type: "Type of transaction:",
      types: {
        withdrawal: "Withdrawal",
        deposit: "Deposit",
        interest: "Interest / Fees",
        tax_refund: "Taxes / Refunds",
        other_gains: "Other profits",
      },
      netAmount: "Net amount:",
      taxAmount: "Taxes:",
      totalAmount: "Total amount:",
      date: "Paid on:",
      datepickerCancelButton: "Cancel",
      purpose: "Comment:",
      hints: {
        other_gains:
          "Other gains can have a strong impact on performance. Please only mark this transaction as Other Profits if it was actually a trading profit, a tax refund or similar.",
      },
      submit: "Save",
      messages: {
        success: "Saved successfully",
      },
    },
  },
  createAndEditAccount: {
    editBreadcumb: "Edit",
    header: {
      title: "Edit: {{value}}",
    },
    actions: {
      save: "Save",
      delete: "Delete",
      deleteAllInvestments: "You also can delete all investments",
      deleteAllCashTransactions: "You also can delete all cash transactions",
    },
    deleteDialog: {
      titleInvestments: "Deleting all investments",
      titleAllCashTransactions: "Deleting all cash transactions",
      questionInvestments: "Are you sure you want to delete all investments?",
      questionCashTransaction:
        "Are you sure you want to delete all cash transactions?",
      close: "Decline",
      delete: "Delete",
    },
    details: {
      title: "Account details",
      description: "Basic information about this account.",
    },
    additionalContraAccounts: {
      cardTitle: "Additional clearing accounts",
      description:
        "Link further accounts used to settle this depot's buys and sells.",
      manageButton: "Manage",
      setAsPrimary: "Set as primary",
      removeButton: "Remove link",
      title: "Select additional clearing accounts",
      subtitle: "Multiple selection possible",
      primaryLabel: "Primary clearing account",
      additionalLabel: "Additional accounts",
      otherBank: "Other",
      noOptions: "No accounts available",
    },
    linkedDepots: {
      title: "Clearing account for",
      description:
        "This account settles the buys and sells of the following depots.",
    },
    dangerZone: {
      depotTitle: "Delete depot and investments",
      accountTitle: "Delete account and transactions",
      deleteAccount: {
        depot: {
          title: "Delete depot",
          description:
            "Permanently deletes this depot including all investments, transactions and linked clearing accounts. This step cannot be undone.",
          button: "Delete depot",
          confirmTitle: "Delete this depot?",
        },
        account: {
          title: "Delete account",
          description:
            "Permanently deletes this account including all transactions. This step cannot be undone.",
          button: "Delete account",
          confirmTitle: "Delete this account?",
        },
        referenceAccountsLabel:
          "Which clearing accounts should also be deleted?",
        referenceBoundMessage:
          "Still linked to other depots – cannot be deleted",
        deleteContraAccount: "Also delete the clearing account",
        boundMessage:
          "This account is used as a clearing account by a depot and cannot be deleted.",
      },
    },
  },
  watchlistEntry: {
    details: {
      gainLossStatistics: {
        title: "Market returns",
        gainAndLoss: "Market returns",
        entryQuote: "Entry quote",
        currentQuote: "Current quote",
        historicReturns: "Historic performance",
      },
    },
  },
  depotTransfer: {
    title: "Depot transfer",
    header: { backButton: "Back", title: "Depot transfer" },
    selectTransferTypeStep: {
      question: "Do you want to transfer your depot in full or partially?",
      full: "In full",
      partial: "Partially",
    },
    depotAutocompleteStep: {
      question: "To which depot do you want to transfer to?",
      placeholder: "Select depot",
    },
    dateOfTransferStep: {
      question: "When did the transfer happen?",
      label: "Date of transfer",
    },
    investmentsTable: {
      investments: "Investments",
      totalNumberOfLots: "Total",
      transferNumberOfLots: "Transferred Amount",
    },
    validation: {
      destinationAccountIdIsEmpty: "Destination depot must be selected",
      investmentsToTransferIsEmpty: "Please select investments to transfer",
      investmentsToTransferIsIncorrect:
        "The number of lots is incorrect for some investments",
      numberOfLotsCanNotBeLessThanZero: "can not be less than zero",
      numberOfLotsCanNotBeMoreThanOriginal:
        "can not be more than original value",
      dateOfTransferCanNotBeInFuture: "Date of transfer can not be in future",
      dateOfTransferCanNotBeEmpty: "Date of transfer must not be empty",
    },
    successStep: {
      message: "Investments were successfully transferred",
      finishButton: "Back to depot",
    },
    fullLotsStep: {
      question: "Did your bank transfer everything or only full lots?",
      onlyFullLots: "Only full lots",
      fullLotsAndPartials: "Everything",
    },
    selectInvestmentsStep: {
      question: "Which investments do you want to transfer?",
      noInvestments: "You have no investments",
    },
  },
  bankConnections: {
    success: {
      message: "Import completed",
      toDepots: "To the depot overview",
    },
  },
  selectContraAccount: {
    accountTypeFromBank: {
      CHECKING: "Checking Account",
      SAVINGS: "Savings Account",
      CREDIT_CARD: "Credit Card",
      DEPOT: "Depot",
      LOAN: "Loan",
      MEMBERSHIP: "Membership",
      HOME_PURCHASE_SAVINGS: "Home Purchase Savings",
      REFERENCE_ACCOUNT: "Reference Account",
      FOREIGN_CURRENCY_ACCOUNT: "Foreign Currency Account",
    },
    title: " Select clearing account",
    nextButton: "Continue",
    depotIndex: "{{index}} of {{total}}",
    noAccount: "Without clearing account",
    noAccountWarning:
      "Without clearing account only limited functionality! No transfer of dividends and exact data from transactions",
    showAllAccounts: "Show all bank accounts",
    showAccountsForSameBank: "Show only bank accounts",
  },
  synchronizationLog: {
    title: "Last Updates",
    noUpdateRequired: "Positions are current",
    new: "NEW",
    rollback: "Discard changes",
    rolledBack: "DROPPED",
    checkRequired: "CHECK",
  },
  depotsSelector: {
    allDepots: "All Portfolios",
    amountDepots: "{{ selected }} of {{ total }} Portfolios",
    noDepots: "No Portfolios",
    allAccounts: "All Accounts",
    amountAccounts: "{{ selected }} von {{ total }} Konten",
    noAccounts: "No Accounts",
  },
  regionSelector: {
    label: "Select a region",
  },
  industrySelector: {
    label: "Select an industry",
  },
  tagSelector: {
    label: "Select or create a tag",
    addNewOption: 'Create "{{name}}" tag',
  },
  classifications: {
    title: "Classification",
    breadcrumbs: {
      home: "Home",
      classifications: "Depot-Classification",
    },
    tabs: {
      investments: "Investments",
      investmentType: "Asset class",
      region: "Region",
      industry: "Industry",
      risk: "Volatility",
      currency: "Currency",
      yield: "Yield",
      tag: "Custom groups",
    },
    empty: {
      title: "No data for this view",
    },
    assignTagToInvestment: "Assign tag to Investment",
    assignRegionToInvestment: "Assign region to Investment",
    assignIndustryToInvestment: "Assign industry to Investment",
    risk: {
      title: "Investments by risk",
      tooltip:
        'High: The risk of securities is classified as "high" if the volatility is above 25 percent. <br><br>Moderate: The risk of securities is classified as "moderate" if the volatility is between 15 and 25 percent.<br><br>Low: The risk of securities is classified as "low" if the volatility is below 15 percent.',
      unclassified: "Not classified",
      numberToWord: {
        0: "Low",
        1: "Moderate",
        2: "High",
      },
    },
    yield: {
      title: "Investments by yield",
      tooltip:
        'High: The yield on securities is classified as "high" if the return per year is over 12 percent. <br><br>Moderate: The return on securities is classified as "moderate" if the return per year is between 6 and 12 percent.<br><br>Low: The return on securities is classified as "low" if the return per year is less than 6 percent',
      unclassified: "Not classified",
      numberToWord: {
        0: "Low",
        1: "Moderate",
        2: "High",
      },
    },
    tag: {
      assignTitle: "Assign a tag",
      title: "Your groups",
      unclassified: "Unclassified",
    },
    investmentType: {
      title: "Investments by type",
      types: {
        "11_stock": "Stocks",
        "21_fund": "Funds",
        "31_bond": "Bonds",
        "41_cash": "Cash",
        "51_certos": "Certificates / OS",
        "52_future": "Futures",
        "61_pmetals": "Precious Metals",
        "71_massets": "Material Assets",
        "81_fcurr": "Foreign Currencies",
        "82_crypto": "Crypto",
        "22_etf": "ETF",
        "91_managed": "Robo / Crowd",
      },
    },
    currency: {
      title: "Investments by currency",
    },
    region: {
      assignTitle: "Assign region",
      title: "Investments by region",
    },
    industry: {
      assignTitle: "Assign industry",
      title: "Investments by industry",
    },
  },
  investmentTypeClassification: {
    types: {
      "11_stock": "Stocks",
      "21_fund": "Funds",
      "31_bond": "Bonds",
      "41_cash": "Cash",
      "51_certos": "Certificates / OS",
      "52_future": "Futures",
      "61_pmetals": "Precious Metals",
      "71_massets": "Material Assets",
      "81_fcurr": "Foreign Currencies",
      "82_crypto": "Crypto",
      "22_etf": "ETF",
      "91_managed": "Robo / Crowd",
    },
  },
  dividendPlannerPage: {
    title: "Revenues",
    portfolio: "Portfolio value",
    addButton: "Add",
    statistics: {
      portfolioValue: "Portfolio Value",
      received: "Received Dividends",
      yield: "Dividend Yield",
      predicted: "Prediction {{year}}",
      predictedYield: "Div. Yield {{year}}",
      cagr: "CAGR",
      currentYear: "Current Year",
      year: "Year {{year}}",
      years_one: "{{count}} year",
      years_other: "{{count}} years",
    },
    chart: {
      title: "Dividends Current Year",
      dividendYield: "Dividend Yield",
      lastYear: "last year",
      total: "Total",
      tooltipReceived: "rec. Div",
      tooltipPredicted: "pred. Div",
    },
    myDividends: "My Dividends",
    exportPdfBtn: "Export as PDF",
    predictDropdown: {
      predictYears: "Predict Years",
      hideForecast: "Hide Forecast",
      list: {
        nextYear: "Simulate next year",
        twoYears: "Simulate 2 years",
        fiveYears: "Simulate 5 years",
        tenYears: "Simulate 10 years",
      },
      lists: {
        nextYear: "Simulate next year",
        twoYears: "Simulate 2 years",
        fiveYears: "Simulate 5 years",
        tenYears: "Simulate 10 years",
      },
    },
    tabs: {
      overview: "Overview",
      calendar: "Dividend Calendar",
    },
    chips: {
      table: "InvestmentsTable View",
      calendar: "Calendar view",
    },
    forecast: "Forecast",
    showAll: "Show all",
    showLess: "Show less",
    showMore: "show more",
    calendar: {
      noData: "No dividends",
    },
    dividendContains_one: "Contains {{count}} dividend",
    dividendContains_other: "Contains {{count}} dividends",
    searchPlaceholder: "Name / Month",
    quote: "Course",
    table: {
      name: "Name",
      dueIn: "Due in",
      dividendAmount: "Dividend /\nAmount",
      yieldPrice: "Personal yield /\npurchase price",
      currentYP: "Current Yield /\nCurrent Price",
      dividend: "Dividend",
      amount: "Amount",
      personalYield: "Personal Yield",
      purchasePrice: "Purchase Price",
      currentYield: "Current Yield",
      currentPrice: "Current Price",
      sharesShort: "St.",
      groupByMonth: "Group by month",
      expected: "Probably",
      notRecorded: "Dividend not recorded",
      noFound: "No data is found",
      mobile: {
        count_one: "{{count}} position",
        count_other: "{{count}} positions",
        payments_one: "{{count}} payment",
        payments_other: "{{count}} payments",
        paymentsTitle: "Payments",
        yieldValue: "Yield {{value}}",
        sort: {
          dividend: "Dividend",
          currentYield: "Current yield",
          personalYield: "Pers. yield",
        },
      },
      dividendPerShare: "Dividend per share",
      shares: "Shares",
      tax: "Tax & fees",
      paymentDate: "Payment date",
      banners: {
        title: "No tax data entered",
        text: "We can calculate your net amounts and display them here if you provide your tax information",
        supplementBtn: "Supplement tax data",
        notNowBtn: "Not now",
      },
      expand: {
        dividends: "Dividends",
        amount: "Amount",
        currentYield: "Current Yield",
        personalReturns: "Personal Return",
        gross: "(Gross)",
        net: "(Net)",
        grossTooltip: "Gross amount (before taxes)",
        netTooltip: "Net amount (after taxes)",
      },
    },
  },
  csvImport: {
    title: "Import CSV",
    formatSelector: { label: "Select CSV format" },
    csvUpload: {
      text: "Drag or select CSV here",
      error:
        "Error uploading. Please check whether the uploaded File corresponds to the format, or try a different file.",
      genericHint:
        "Please import the CSV file with your transaction data here. You can download a generic CSV template <linkText>here</linkText>. In addition, the following formats are supported:",
      currencyWarning:
        "Important: The CSV import does not support the conversion of foreign currencies. Please ensure that all entries and transactions are specified in euros.",
      incompatible: {
        "01_depot":
          "The import of cash transactions into a depot is not possible. Please select an account to import the cash transactions from the CSV file.",
        "02_cash":
          "The import of security bookings into an account is not possible. Please select a depot to import the security bookings from the CSV file.",
      },
    },
    banksTable: {
      depot: "Portfolio bookings",
      account: "Account transactions",
      portfolioPerformanceDepot: "Portfolio Performance (Depot)",
      portfolioPerformanceAccount: "Portfolio Performance (Account)",
      emptyText: "No booking or transaction banks found.",
      loading: "Loading booking or transaction banks...",
    },
    edit: "Edit",
    delete: "Delete",
    parsingResults: {
      date: "Date",
      name: "Name",
      number_of_lots: "Number",
      number_of_lots_bond: "Amount",
      security_price: "Deposit Price",
      commission: "Fees",
      isin: "ISIN",
      tax_amount: "Taxes",
      transaction_type: "Transaction type",
      asset_type: "Investment type",
      currency: "Currency",
      exchange_rate: "Exchange rate",
      tax_and_commission_in_eur: "Taxes and fees in EUR",
      error: "Entry for {{name}} is missing",
      saveSuccess: "Transactions were imported successfully",
      savePending: "Import is being processed, please wait...",
      saveError: "An error occurred while saving transactions",
      correctionHint:
        "Please correct all erroneous transactions before importing them.",
      allCorrected:
        "All erroneous transactions have been successfully corrected.",
    },
    cashParsingResults: {
      bank_booking_date: "Date",
      counterpart_name: "Name",
      counterpart_iban: "IBAN",
      purpose: "Booking information",
      amount: "Amount",
      error: "Entry for {{name}} is missing",
    },
  },
  transactionUpload: {
    title: "Import transactions",
    transactionTypes: {
      buy: "Buy",
      sell: "Sell",
      dividend: "Dividend",
      book_in: "Book-In",
      book_out: "Book-Out",
    },
    dropOrSelectFile: "Drop PDFs here or select files",
    dropOrSelectFileHint: "No more than 10 files up to 2MB each",
    newInvestment: "New",
    newTransaction: "New",
    updateTransaction: "Update",
    tax: "Tax",
    fee: "Commission",
    persistData: "Import data",
    depot: "Depot",
    ignoreErrors: "Ignore errors",
    success: {
      importSuccess: "Successfully imported",
      importDetails: "Imported positions",
      toDepot: "Back to depot",
      toInvestments: "Back to investments",
    },
    somethingWrong:
      "An error occurred and we were unable to parse the file properly. Please check your file details.",
    placeholder: "Select depot",
  },
  authContext: {
    loginTitle: "Login",
    emailConfirmationTitle: "Please confirm your email",
  },
  emailConfirmation: {
    line1:
      "We have sent you an email to confirm your account. Please complete the registration by clicking on the confirmation link contained in the email.",
    line2:
      "If you have not received an email, please also check your spam folder if necessary.",
    success: "We have sent you an email to confirm your account.",
    button: "Resend email",
    confirmationExpiredError:
      "Registration could not be confirmed. Most likely your confirmation link has already expired.",
    logout: "Cancel registration",
  },
  netfondsConsent: {
    title: "Cashback: One-Click Import",
    heading: "New: One-Click Data import",
    teaser:
      "We proudly announce our seamless depot import - exclusively for Rentablo Cashback customers.",
    description:
      "Import your Cashback-Depots with a single click into the Rentablo finance manager and improve your investment returns.",
    activateDataImport: "Activate data import",
    doNotActivateDataImport: "Do not activate data import",
    deactivated: "One-click import is deactivated",
    howToActivate:
      "You may activate the one-click import in your <1>Cashback-Dashboard</1> at any time.",
    done: "Back to dashboard",
    changedYourMind: "Changed your mind?",
    selectAccountHolders: "Select account holder",
    selectAccountHoldersDescription:
      "One-Click import will be enabled for the selected account holders.",
    importingData: "Importing depots...",
    importingDataDescription:
      "We are now importing your investment and transaction data. If you have a lot of (historic) transaction data, this may take up to several minutes.",
    somethingWrong: {
      title: "Import failed",
      contactSupport:
        "Please contact our support using {{supportEmail}} if this problem persist.",
    },
    deleteAccounts: {
      heading: "Delete already imported depots?",
      teaser:
        "Depots and accounts were already imported via the Cashback interface. Would you like to delete them now?",
      delete: "Delete depots",
      keep: "Keep data",
    },
    breadcrumbs: {
      title: "One-Click Import",
    },
  },
  addDividendWizard: {
    title: "Dividends",
    addManualDividendStep: {
      title: "Enter the dividend information",
      date: "Date",
      currency: "Currency",
      securityPrice: "Price",
      exchangeRate: "Exchange rate",
      taxAmount: "Tax amount",
      commission: "Commission",
      taxAndCommissionInEur: "Tax and commission in EUR?",
      amount: "Amount",
      amountAC: "Amount (EUR)",
      errors: {
        title: "Validation errors",
      },
    },
    confirmManualDividendStep: {
      title: "Summary of your dividend information",
      amount: "Amount:",
      date: "Date:",
      tax: "Tax:",
      commission: "Commission:",
      exchangeRate: "Exchange rate:",
      total: "Total:",
      totalAC: "Total (€):",
      saveButtonLabel: "Save",
    },
    breadcrumbs: {
      create: "Create a dividend",
    },
  },
  batchDividendsWizard: {
    title: "Dividends",
    listDividendsStep: {
      title: "Select the outstanding dividends",
      subtitle:
        "The selected dividends are automatically imported into your portfolio",
      splitAdjust: "Split adjusted",
    },
    dividendsTable: {
      headers: {
        date: "Date",
        amount: "Amount",
        lots: "Lots",
      },
    },
    taxRequestStep: {
      taxQuestion: "Would you like to apply a tax rate?",
      acceptTax: "Yes",
      declineTax: "No",
    },
    taxInputStep: {
      title: "Enter your tax rate",
      customTaxLabel: "Tax rate",
    },
    summaryStep: {
      title: "Summary of your dividend and tax data",
      saveButtonLabel: "Save",
      dividendsTable: {
        headers: {
          date: "Date",
          amount: "Received",
          tax: "Tax",
          total: "Total",
        },
      },
    },
  },
  editDividendWizard: {
    title: "Edit dividend",
  },
  transactionWizard: {
    new: {
      title: "Add investment",
    },
    manual: {
      title: "Add investment manually",
    },
    add: {
      title: "Add transaction",
    },
    edit: {
      title: "Edit transaction",
    },
    searchSymbolsStep: {
      title: "Find securities",
      noQuoteModal: {
        title: "No Automatic Quote Feed",
        text: "Unfortunately, we cannot provide an automatic quote feed for the selected security. Please create the investment entry manually and update the quotes yourself when needed.",
        confirm: "Create Manual Investment",
      },
    },
    selectCurrencyStep: {
      title: "Select investment currency",
      currency: "Currency",
      tryPlusMessage: "Foreign currencies are a PLUS Feature.",
    },
    investmentTypeStep: {
      title: "Type of the investment",
    },
    bookingTypeStep: {
      title: "What would you like to enter?",
      mostUsed: "Most used",
      specials: "Special transaction types",
      buy: "Buy",
      sell: "Sell",
      book_in: "Book-in",
      book_out: "Book-out",
      switch: "Switch / fusion",
      retained_dividend: "Retained dividend / free shares",
      carve_out: "Carve-out",
      split: "Split",
      disabledInformation:
        "This transaction type is only available for existing investments. Select this type from your investment options.",
    },
    priceAndDateStep: {
      title: "Order data",
      date: "Date",
      numberOfLots: "Lots",
      numberOfLotsPercent: "Value",
      numberOfLotsGram: "g",
      numberOfLotsOunces: "Ounces",
      securityPrice: "(Historic) entry price",
      bookOutPrice: "Booked out for",
      entryQuote: "Price",
      currency: "Currency",
      exchangeRate: "Exchange Rate",
      commission: "Commission",
      taxAmount: "Taxes",
      taxAndCommissionInEur: "Tax and commission in EUR?",
      totalAmount: "Total",
      totalAmountAC: "Total (EUR)",
      depotValuationAfterBooking: "Depot valuation after this booking",
      gram: "Gram",
      ounces: "oz",
      lots: "Pc.",
    },
    ratioAndDateStep: {
      title: "Split",
      date: "Date",
      ratio: "Ratio",
      isReverse: "Reverse split?",
    },
    nameAndDepotStep: {
      title: "Select name and depot",
      name: "Name",
      selectDepot: "Select depot",
      newDepot: "New Depot",
      comment: "My trading diary:",
      investmentExists: "You already have {{lots}} lots in this depot",
    },
    newDepotStep: {
      title: "Create a new depot",
      name: "Depot name",
      currency: "Currency",
    },
    inputFieldWithRevert: {
      revert: "Reset",
      revertDescription: "Reset to original value of {{value}}",
    },
    summaryStep: {
      title: "Order summary",
      date: "Date",
      securityPrice: "(Historic) entry price",
      entryQuote: "Price",
      exchangeRate: "Exchange Rate",
      expenses: "Expenses",
      currency: "Currency",
      totalAmount: "Total",
      totalAmountAC: "Total (€)",
      persist: "Save data",
    },
    splitPreviewStep: {
      title: "Split applied to:",
      titleReverse: "Reverse split applied to:",
      persist: "Save data",
    },
    persistedStep: {
      title: "Data saved",
      showInvestments: "Go to investments",
    },
    somethingWrong: {
      title: "Internal error",
      contactSupport:
        "Please contact our support using {{supportEmail}} if this problem persist.",
      done: "Back to Investments",
    },
  },
  symbolSearch: {
    loading: "Loading...",
    title: "Search securities",
    searchLabel: "Name, ISIN, WKN",
    searchPlaceholder: "Name, ISIN, WKN",
    noData: "Sorry, no results",
    examples: "Examples",
    example1: "Daimler or DE0007100000",
    example2: "Bitcoin or BTC",
    example3: "Gold or Silver",
    example4: "Dollar or USD",
    manualInvestmentLabel: "Security not available?",
    manualInvestment: "Create manual investment",
  },
  sidebar: {
    header: { title: "Finance Manager", testPremium: "Test premium" },
    footer: {
      imprint: "Imprint",
      privacy: "Privacy",
      terms: "Terms",
      disclaimer: "Disclaimer",
      wealthApi: "wealthAPI GmbH",
      phoneInfo: "Available Monday to Friday from 9 a.m. to 7 p.m.",
    },
  },
  appSidebar: {
    searchField: "Search",
    menu: {
      accounts: "Accounts",
      admin: "Administration",
      capitalMeasure: "Capital Measure",
      cashbackBookings: "Cashback Bookings",
      securitiesAdmin: "Securities Admin.",
      bankAdmin: "Bank Admin. & Reports",
      other: "Other Admin.",
      isinChanges: "ISIN Changes",
      securityType: "Security Type Changes",
      assetReport: "Asset Report",
      apiRefresh: "Historic Quotes Refresh",
      cryptoRefresh: "Crypto Currencies",
      mergers: "Mergers",
      spinOffs: "Spin-Offs",
      purchaseRight: "Purchase Rights",
      backToLegacy: "Zurück zu v1",
      bankEvents: "Connection Events",
      bankLogs: "Bank Logs",
      bankMessages: "Bank Messages",
      bankHealth: "Bank Health Reports",
      cashback: "Cashback",
      analyse: "Analyse",
      goals: "Goals",
      names: "Preferred names",
      cashflowAnalyzer: "Cashflow-Analyzer",
      contractAnalyzer: "Contract-Analyzer",
      providerName: "Provider name",
      etfs: "ETFETC Classifications",
      logos: "Company Logo",
      classification: "Classification",
      contracts: "Contracts",
      depots: "Portfolios",
      depotsAndAccounts: "Portfolios & Accounts",
      dividendPlanner: "Revenues",
      dividends: "Dividends Management",
      helpdesk: "Helpdesk",
      home: "Home",
      interfaces: "Schnittstellen Verwaltung",
      investments: "Investments",
      logout: "Logout",
      newCashback: "Neue Buchung",
      oneClickImport: "One-Click Import",
      overview: "Overview",
      performance: "Depot Analysis",
      portfolio: "Portfolio",
      profile: "Profil",
      risk: "Return and risk",
      settings: "Settings",
      splits: "Split Management",
      watchlists: "Watchlists",
      depotCheck: {
        main: "Depot Optimization",
        questionnaire: "Questionnaire",
      },
    },
  },
  premium: {
    tryPlusMessage:
      "Do better investment decisions and try Rentablo <1>PLUS</1> for free today!",
    tryProMessage:
      "Do better investment decisions and try Rentablo <1>PRO</1> for free today!",
    tryPlus: "Try Rentablo PLUS",
    tryPro: "Try Rentablo PRO",
  },
  loggedAs: "Logged in as {{username}}",
  intervalSelector: {
    compact: {
      oneWeek: "1W",
      oneMonth: "1M",
      sixMonths: "6M",
      oneYear: "1Y",
      sinceBeginning: "Since the beginning",
    },
    oneWeek: "1 week",
    oneMonth: "1 month",
    oneYear: "1 year",
    sinceBeginning: "Since the beginning",
  },
  dateRangePickerDialog: { submitButton: "Set", cancelButton: "Cancel" },
  aggregatedChart: {
    legend: {
      overview: "Overview",
      securities: "Securities",
      accountsAndCards: "Accounts & Cards",
    },
  },
  customTooltip: {
    securitiesLabel: "Securities",
    cardsAndAccountsLabel: "Accounts & Cards",
  },
  userDetails: {
    lastLogin: "Last login:",
    hello: "Hello",
  },
  sideBarMenu: {
    title: "Whitebox Analyze",
    allAssets: "All assets",
    securities: "Securities",
    cardsAndAccounts: "Accounts & Cards",
    settings: "Settings",
    help: "Help & Support",
    logout: "Log out",
    myWhiteboxSecurities: "My Whitebox securities",
    mySecurities: "My securities",
  },
  securitiesChart: {
    legend: {
      overview: "Overview",
      holdings: "Securities",
      etfs: "ETF",
      bonds: "Bonds",
      funds: "Funds",
      derivative: "Derivative",
      crypto: "Crypto",
    },
    typeSwitcher: {
      performance: "Performance",
      valuation: "Valuation",
      disabledTooltip: "Comparison is only supported in mode ‘performance’",
    },
  },
  promotionTeaser: {
    title: "Improve your chances of return!",
    desc: "This depot could do a lot better as a whitebox system and generate up to 5% more return/year.",
    disclaimer:
      "This is a disclaimer and/or risk information, if we need to show one here, when we advertise a higher roi with a Whitebox Investment.",
    buttonMore: "More info",
    buttonNo: "No, thanks",
    percent: "+5%",
    percentSubtitle: "up to 5% more a year",
  },
  investmentsPage: {
    isinMissing: "ISIN missing. Please add!",
    isinInvalid: "The ISIN you entered is invalid. Please try again.",
    overview: "Overview",
    header: {
      title: "Investments",
      actions: {
        addTitle: "Add",
        newDepot: "New Depot",
        newPortfolio: "New Portfolio",
        newTransaction: "New Transaction",
        main: "Create new",
        create: "Create",
        uploadPdf: "Upload PDF",
        uploadCsv: "Upload CSV",
      },
    },
  },
  portfolioShare: {
    share: "Share",
    privatePortfolio: {
      noAccess: "You do not have access to this portfolio.",
      close: "Create account",
    },
    banner: {
      portfolio: 'You are currently viewing the dashboard "{{portfolio}}".',
      createYourOwn: "Create your own dashboard now",
      toMyDashboard: "To my dashboard",
      register: "Log in",
    },
    modal: {
      title: "Set view",
      secondTitle: "Share dashboard",
      table: { selectAll: "Select all", name: "Name", bank: "Bank" },
      selectButton: "Show portfolio",
      shareButton: "Share dashboard",
      acceptButton: "Take over",
      goToPortfolio: "To dashboard",
      publishButton: "Publish dashboard",
      closeButton: "Close",
      cashPositionsShared:
        "The cash position of your clearing accounts will also be shared if your dashboard is public.",
      private: "Private",
      privateTooltip:
        "With this selection, your portfolios remain visible only to you. If you have already shared your portfolios publicly, you can block visibility again here. The public view is then deactivated again.",
      public: "Public",
      publicTooltip:
        "This selection allows you to share your portfolio with others. You can display absolute or percentage values. If you display percentage values, others will not know how much capital you have invested.",
      onlyPercentage: "Show only percentage values",
      dashboardName: "Public dashboard name",
      dashboardName_placeholder: "e.g. 7030 Portfolio",
      linkWasCopied: "The link to your dashboard has been copied.",
      linkToDashboard: "Link to the dashboard",
      copyLink: "Copy link ",
    },
  },
  investmentEditPage: {
    header: "Edit",
    breadcrumbs: {
      edit: "Edit",
    },
    noInvestment: "Failed to load investment",
    tabs: {
      basic: "Basic",
      quoteData: "Quote data",
      advanced: "Advanced",
    },
    basicTab: {
      name: "Name",
      depot: "Depot",
      industry: "Industry / Sector",
      region: "Region / Country",
      customGroup: "Custom group",
      saveButton: "Save",
      saved: "Data saved",
    },
    quoteDataTab: {
      selectedText: "Selected: ",
      nothingSelectedText: "Nothing selected",
      saveButton: "Save",
    },
    advancedTab: {
      investmentType: "Investment type:",
      investmentCurrency: "Investment currency:",
      isin: "ISIN",
      wkn: "WKN",
      saveButton: "Save",
    },
  },
  itCardsMiniCard: {
    lastTransaction: "Last Transaction",
    noTransactions: "No transactions",
  },
  dashboardPage: {
    allYourAssets: "Your asset allocation",
    portfolio: "Portfolio",
    allAssets: "Your assets",
    modeBanner: {
      text: "New: The Rentablo finance manager is now also available in dark mode. <linkText>Try Dark Mode now</linkText>",
    },
    oneClick: {
      title: "One-click Import",
      text: "Import your cashback deposits with just one click.",
      buttonText: "Use now",
    },
    investmentsLink: "Go to Investments",
    depot: {
      title_one: "{{count}} Portfolio",
      title_other: "{{count}} Portfolios",
      noAccountsTitle: "No portfolios",
      noAccountsSubtitle:
        "You do not have any portfolios, do you want to add them now?",
      noAccountsButtonText: "Add now",
    },
    currentAssetsBlock: {
      chart: "Chart",
      gainersLosers: "Gainers & Losers",
      gainersLosersShort: "G&L",
      statistic: {
        returnOnInvestment: "Price gain",
        cash: "Cash",
        dividends: "Dividends",
        realizedGain: "Realized gain",
      },
    },
    investments: {
      title_one: "{{count}} Investment",
      title_other: "{{count}} Investments",
      noAccountsTitle: "No investments",
      noAccountsSubtitle:
        "You do not have any investments, do you want to add them now?",
      noAccountsButtonText: "Add now",
    },
    account: {
      title_one: "{{count}} Account",
      title_other: "{{count}} Accounts",
      noAccountsTitle: "No accounts",
      noAccountsSubtitle:
        "You do not have any accounts, do you want to add them now?",
      noAccountsButtonText: "Add now",
    },
    whitebox: {
      title_one: "{{count}} Whitebox-Anlage",
      title_other: "{{count}} Whitebox-Anlagen",
      noAccountsTitle: "No whitebox accounts",
      noAccountsSubtitle:
        "You do not have any whitebox accounts, do you want to add them now?",
      noAccountsButtonText: "Add now",
    },
    cashbackCard: {
      withSubscriptions: {
        title: "Cashback booking",
        text: "For your booking we need a few things:",
        text_processed: "Your booking is being processed:",
        text_active: "You can now import your cashback depots",
      },
      noSubscriptions: {
        title: "Get bonus",
        subtitle: "Recruit a friend",
        text: "Bring a friend to Rentablo and get €15 as a reward.",
      },
      statusMessage: {
        processed: "Active",
        incomplete: "Draft; please complete wizard",
        in_progress: "Please submit documents",
        internal_processing: "Documents received - In progress",
        processing_at_bank: "Forwarded to bank",
        processing_at_bank_reduced: "Opening process forwarded to bank",
        contract_terminated: "Terminated",
      },
    },
    netfondsImportCard: {
      consentRequired: {
        title: "Your consent is required",
        body: "We need your consent to import your Netfonds data",
      },
      importAvailable: {
        title: "One-Click Import available",
        body: "Activate seamless import of your cashback depots now",
      },
      detailsButton: "Details",
    },
    header: {
      title: "Dashboard",
      welcomePhrases: {
        morning: "Good Morning",
        afternoon: "Good Afternoon",
        evening: "Good Evening",
      },
    },
    dashboard: {
      addPortfolio: "Add portfolio",
      header: {
        subheader: "Current assets",
        add: "Add portfolio",
      },
      noDataFirstLine: "There is currently no data available.",
      noDataSecondLine:
        "<linkText>Please import</linkText> your portfolios and accounts.",
      mainDataSection: {
        cash: "Cash",
        holdings: "Holdings",
        assets: "Assets",
        returnOnInvestment: "Price Gain",
        rateOfReturn: "Internal Rate of Return",
        dividends: "Dividends",
        realizedGain: "Realized Gains",
      },
      includeDividends: "Including dividends",
      cashTable: {
        header: "Cash",
      },
      investmentsTable: {
        header: "Holdings",
        columns: {
          name: "Name",
          totalValue: "Total Value",
          change: "Change",
          allocation: "Allocation",
        },
        types: {
          "11_stock_one": "Stock",
          "11_stock_other": "Stocks",
          "21_fund": "Fund",
          "21_fund_one": "Fund",
          "21_fund_other": "Funds",
          "31_bond_one": "Bond",
          "31_bond_other": "Bonds",
          "41_cash": "Cash",
          "51_certos_one": "Certificate / OS",
          "51_certos_one ": "Certificate / OS",
          "51_certos_other": "Certificates / OS",
          "52_future_one": "Future",
          "52_future_other": "Futures",
          "61_pmetals_one": "Precious metal",
          "61_pmetals_other": "Precious metals",
          "61_pmetals_othere": "Precious metals",
          "71_massets_one": "Material asset",
          "71_massets_other": "Material assets",
          "81_fcurr_one": "Foreign Currency",
          "81_fcurr_other": "Foreign Currencies",
          "82_crypto_one": "Cryptocurrency",
          "82_crypto_other": "Cryptocurrencies",
          "22_etf": "ETF",
          "91_managed": "Robo Crowd",
        },
      },
      performance: {
        tabs: {
          value: {
            title: "Valuation",
            portfolio: "Portfolio",
            investedCapitol: "Invested Capital",
          },
          performance: {
            title: "Performance",
            portfolio: "Portfolio",
            dividends: "Portfolio incl. Dividends",
          },
          dividend: {
            title: "Dividend",
            total: "Total",
            predicted: "Predicted",
            investedCapitol: "Invested Capital",
          },
        },
        rangeName: {
          today: "Today",
          YTD: "YTD",
          oneYear: "1 year",
        },
        viewInvestedCapital: "View invested capital",
        compare: "Comparison",
        compareWith: "Compare with",
        compareTooltip: "Compare performance with a security or index.",
        includeDividends: "Including dividends",
        selectCompare: {
          placeholder: "Enter name, ISIN or WKN",
        },
      },
      gainersAndLosers: {
        gainers: "Gainers",
        losers: "Losers",
        more: "Learn more",
        period: "1 Day",
        noData:
          "No winners & losers available. Please change the portfolio selection or add further investments.",
      },
      newsBlock: {
        title: "News & Knowledge",
        allArticles: "See all articles",
        item: {
          type: "Rentablo blog",
        },
      },
      cashbackBanner: {
        title: "Cashback: Get your money back now!",
        text: "You are currently paying <strongText>{{amount}} trailer fee</strongText>, with {{name}} Cashback you can easily get it back.",
        button: "Request cashback",
        cancel: "Not now",
      },
    },
    cashbackSuggestionCard: {
      subtitle: "Profit even more!",
      title: "{{amount}} fund commission p.a.",
      discount: "Including 100% premium discount",
      button: "Get money back now",
    },
  },
  watchlistsPage: {
    header: {
      title: "Watchlists",
    },
    watchlists: {
      title: "Watchlist",
      create: "Create a new watchlist",
      newWatchlist: "Add Watchlist",
    },
    createAndEditForm: {
      label: "Watchlist name",
      placeholder: "Watchlist name",
    },
  },
  watchlistsCreatePage: {
    breadcrumbs: {
      home: "Home",
      watchlists: "Watchlists",
      create: "Create",
    },
    header: {
      title: "Create watchlist",
    },
  },
  watchlistsEditPage: {
    breadcrumbs: {
      home: "Home",
      watchlists: "Watchlists",
      edit: "Edit",
    },
    header: {
      title: "Edit",
    },
  },
  watchlistSinglePage: {
    header: {
      totalItems_one: "{{count}} security",
      totalItems_other: "{{count}} securities",
      actions: {
        editWatchlist: "Edit watchlist",
        deleteWatchlist: "Delete watchlist",
        addNewItem: "Add new security",
      },
      deleteDialog: {
        title: "Delete watchlist",
      },
    },
    table: {
      noItems: "There are no securities",
      mobile: {
        sinceWatching: "Since watching",
        metrics: {
          today: "Today",
          oneYear: "1 Y",
          threeYears: "3 Y",
          fiveYears: "5 Y",
        },
        sort: {
          watchPrice: "Since watching",
          today: "Today",
          oneYear: "1 year",
          threeYears: "3 years",
          fiveYears: "5 years",
        },
      },
      headers: {
        name: "Name",
        watchPrice: "Watch price",
        currentPrice: "Current price",
        changeToday: "Change Today",
        oneYear: "1 Year %",
        threeYear: "3 Years %",
        fiveYear: "5 Years %",
      },
    },
    chart: {
      noData: "Please add more watchlist entries",
      moreEntries: "+{{count}} more",
      maxNotice: "A maximum of 15 securities can be displayed in the chart",
    },
    empty: {
      noEntriesTitle: "Nothing added yet",
      noEntriesSubtitle: "Add items to stay up to date",
      addFirstSecurity: "Add first security",
      noWatchlistsTitle: "No watchlists yet",
      noWatchlistsSubtitle:
        "Create your first watchlist to start tracking securities",
    },
    detailModal: {
      currentValue: "Current value",
      performanceToday: "Performance today",
      edit: "Edit",
      delete: "Delete",
      noFundamentalsData: "No fundamentals data available for this security",
      noPriceData: "No price data available",
      editTitle: "Edit security",
      deleteDialog: {
        title: "Remove security",
        description:
          "Are you sure you want to remove this security from your watchlist?",
        confirm: "Remove",
      },
    },
  },
  securitiesAddPage: {
    title: "Add security",
    breadcrumbs: {
      securities: "Watchlists",
      add: "Add security",
    },
    description: "Just search for the investment you want to add.",
    securitiesTextFields: {
      date: "Date",
      price: "Price",
      close: "Close",
    },
    chartHint:
      "Tip: Simply select the purchase price and purchase date via the graph",
    chartNoData: "No data is currently available",
    saveButton: "Add",
    editButton: "Takeover changes",
  },
  securitiesEditPage: {
    breadcrumbs: {
      home: "Home",
      securities: "Watchlists",
      edit: "Edit",
    },
  },
  securitiesSinglePage: {
    breadcrumbs: {
      home: "Home",
      watchlists: "Watchlists",
    },
    mobileHeaderMenuActions: {
      editSecurity: "Edit security",
      deleteSecurity: "Delete security",
    },
    deleteDialog: {
      title: "Delete security",
    },
    chart: {
      subheader: "Current value",
    },
    tabs: {
      fundamentals: "Fundamentals",
      news: "News",
    },
  },
  searchSecurityPage: {
    title: "Search for security",
  },
  singleSecurityPage: {
    breadcrumbs: {
      home: "Home",
      quotes: "Quotes",
    },
    tabs: {
      fundamentals: "Fundamentals",
      news: "News",
    },
  },
  depots: {
    title: "Portfolios",
    depotsTitle_one: "{{count}} Portfolio",
    depotsTitle_other: "{{count}} Portfolios",
    noAccountsTitle: "No portfolios",
    noAccountsSubtitle:
      "You do not have any depots, do you want to add them now?",
    noAccountsButtonText: "Add now",
    addManuallyButton: "Manually",
    deleteModal: {
      question: "Delete this depot?",
    },
  },
  depotPage: {
    breadcrumbs: {
      home: "Home",
      depots: "Portfolios",
    },
    header: {
      title: {
        mobile: "Depot",
      },
    },
    headerMenu: {
      moreActions: "More actions",
      upload: "Upload PDF",
      uploadCsv: "Upload CSV",
      addButton: "Add investment",
      edit: "Edit",
      showUpdateHistory: "Show update history",
      manageBankConnection: "Manage bank connection",
      transfer: "Transfer depot",
      editReferenceAccount: "Edit reference account",
      hide: "Hide",
      show: "Show",
      delete: "Delete Depot",
      update: "Update",
      reconnect: "Reconnect",
    },
    deleteModal: {
      question: "Delete this depot?",
      deleteContraAccount: "Delete contra account",
    },
    chart: {
      performanceYTD: "{{changeYTD}} performance",
      performanceToday: "Today:{{changeToday}}",
      noData: "No data is currently available",
    },
    tabs: {
      transactions: "Transactions",
      investments: "Investments",
    },
    showHistoricSwitch: "Show historic",
    since: "Since",
    subcategories: {
      depots: "Portfolios & Clearing Accounts",
      cash: "Accounts & Credit Cards",
      assets: "Precious Metals & Tangible Assets",
      insurance: "Insurance",
      crypto: "Crypto",
    },
    addOptions: {
      depots: "Portfolios",
      cash: "Accounts & Credit Cards",
      assets: "Precious Metals & Tangible Assets",
      insurance: "Insurance",
    },
  },
  depotsSelect: {
    title: "Select items",
    saveButton: "Create list",
    table: {
      headers: {
        name: "Name",
        bank: "Bank",
      },
    },
  },
  loginPage: {
    header: {
      title: "Log in to Rentablo",
      subtitle: "Enter your login details.",
    },
    form: {
      emailField: "Your email address",
      emailFieldPlaceholder: "name@email.com",
      passwordField: "Password",
      passwordFieldPlaceholder: "Enter password",
      submitButton: "Log in",
      twoFACodeLabel: "Enter 2FA code",
      twoFASubmitButton: "Confirm 2FA and log in",
      rememberMe: "Stay signed in",
      requestErrors: {
        loginFailed:
          "Login failed. <passwordRestoreLink>Did you forget your password?</passwordRestoreLink>",
        somethingWrongWithoutStatus:
          "Sorry, something went wrong. Try again. Please contact our support using <supportEmailLink>{{email}}</supportEmailLink> if this problem persist.",
      },
    },
    signupMessage: {
      link: "Register",
      question: "No account yet?",
    },
    resetPassword: {
      question: "Forgot your password?",
      link: "Click here",
    },
    twoFACodeError:
      "Invalid or expired code. Please try again and <linkText>log in</linkText>.",
  },
  signupPage: {
    header: {
      title: "Get an overview & Cash back for your finances",
      subtitle: "Rentablo is free & without obligation",
    },
    form: {
      firstName: "Name",
      lastName: "Surname",
      email: "Your email address",
      password: "Password",
      acceptedAgb:
        "I agree to the <agb>Rentablo terms</agb> and <privacy>privacy agreements</privacy>.",
      news: "Yes, I would like to receive updates about products and deals.",
      submitButton: "Singup to Rentablo",
      rememberMe: "Stay signed in",
      gender: {
        title: "Salutation",
        male: "Mr",
        female: "Mrs",
      },
      errors: {
        agb: "Terms & Privacy Policy: Must be specified",
      },
      requestErrors: {
        somethingWrongWithoutStatus:
          "Sorry, something went wrong. Try again. Please contact our support using <supportEmailLink>{{email}}</supportEmailLink> if this problem persist.",
      },
    },
    loginMessage: {
      linkText: "Login now",
      question: "Already registered?",
    },
  },
  resetPasswordPage: {
    header: {
      title: "Forgot your password",
      subtitle:
        "Please enter your e-mail address; below you will receive a link to reset your password by e-mail.",
    },
    form: {
      email: "Email:",
      submitButton: "Send Email",
      successfulMessage:
        "We have sent you an email to reset your password ({{email}}).",
    },
  },
  assignPasswordPage: {
    header: { title: "Assign new password" },
    form: { password: "Password", submit: "Change password" },
    success: "Your password was successfully changed",
    error: "Something went wrong. Please try again",
  },
  depotsAccountsPage: {
    noResults: "No suitable results found",
    showHiddenItems: "Show hidden elements",
    mobile: {
      search: "Search",
      category: "Category",
      allCategories: "All categories",
      categoriesSelected: "{{count}} categories",
      showHidden: "Show hidden ({{count}})",
    },
    chips: {
      all: "All",
      "01_depot": "Deposits & Clearing Accounts",
      "02_cash": "Accounts & Credit Card",
      "04_insurance": "Insurance",
      "05_material_assets": "Precious metals and tangible assets",
    },
    accountChips: {
      userGenerated: "User-generated",
      userGeneratedTooltip:
        "Please check and update changes/details based on the depot statement yourself.",
      manual: "Manual",
      manualTooltip:
        "Manual update required. The last bank connection check was performed on {{lastSyncDate}}. The last activity in the portfolio was detected on {{lastChange}}. Please update the bank connection by clicking “Update” here or in the portfolio view.",
      automatic: "Automatic",
      automaticTooltip:
        "Automatic update. The last bank connection check was performed on {{lastSyncDate}}. The last activity in the portfolio was detected on {{lastChange}}. Your bank connection is updated automatically, i.e. there is currently no action required.",
      lastActivity: "Last activity {{date}}",
    },
  },
  accounts: {
    title: "Accounts",
    addButton: "Add",
    primaryReferenceBadge: "Primary account",
    breadcrumbs: {
      home: "Home",
      add: "Add",
      addManually: "Manually",
    },
    updateAccount: "Update financial data",
    addMobileTitle: "Add account",
    addManuallyButton: "Manually",
    noAccountsTitle: "No accounts",
    noAccountsSubtitle:
      "You do not have any accounts, do you want to add them now?",
    noAccountsButtonText: "Add now",
    fillForm: "Create manually managed account",
    chooseType: "Choose type",
    fillFormDepots: "Create manually managed portfolio",
    name: "Name",
    create: "Create",
    addManually: {
      chooseType: "Account Type",
      type: "Type",
      name: "Name",
      namePlaceholder: "E.g. My Depot",
      bank: "Bank",
      bankPlaceholder: "Bank Name, BIC or IBAN",
      currency: "Currencies",
      create: "Create",
      back: "Back",
    },
    add: {
      title: "Import or manually enter?",
      subtitle: "You have various options to import your data",
      titleBank: "Import Portfolios/Accounts",
      subtitleBank: "Please select your bank",
      titleManual: "Create manually maintained portfolio",
      importBank: "Automated Import",
      importManual: "Manual Import",
      importBankDescription:
        "Connect depots and accounts straight to your bank",
      importManualDescription: "Create a portfolio and enter bookings yourself",
      iWantTo: "I want to import this way:",
      bank: "Bank Import",
      importManualDepot: "Create Manual Portfolio",
    },
    sort: {
      name: "Name",
      bankName: "Bank name",
      performance: "Course/Change",
      totalValue: "Total value",
    },
    showHiddenItems: "Show hidden items",
  },
  transactionDetails: {
    productName: "Product name",
    numberOfLots: "Number of lots",
    entryQuote: "Quote",
    assetType: "Asset type",
    isin: "ISIN",
  },
  transactionsTable: {
    depotValue: "Depot value",
    period: "Period",
    valueDate: "Value date",
    bookingDate: "Booking date",
    bookingInformation: "Booking information",
    value: "Value",
    noPurpose: "Not available",
    noTransactions: "No transactions for the time range",
    status: {
      edit: {
        title: "Manual data",
        text: "No action required. The data was entered manually by the user.",
      },
      link: {
        title: "Bank import data",
        text: "No action required. The bank or broker has transmitted the exact amount and the exact number of items for this transaction. This is the best case and provides precise data.",
      },
      returned: {
        title: "Estimated Data",
        text: "Please check data. The bank or broker provided the exact amount, but NOT the number of pieces. The number of pieces was therefore estimated based on historical price data. This generally works well if there are not too many transactions.",
      },
      warning: {
        title: "Virtual balancing booking (quantity below zero)",
        text: "Needs action: Please correct data. A virtual booking had to be created to prevent the number of items from falling below zero at any time. Such a case can occur if data is missing or an estimate is incorrect.",
      },
      warningDelta: {
        title: "Virtual booking (deviation in quantity)",
        text: "Need for action: Please correct data. There was a deviation (also called tracking error) between the number of units calculated from the order history and the number of units reported by the bank. Such tracking errors can be due to data inconsistencies or due to corporate measures such as carve-out. Outs, portfolio transfers or splits occur.",
      },
      csv: {
        title: "CSV Import Data",
        text: "No action required. The exact amount and quantity for this transaction were transmitted via CSV import. This is the best-case scenario and provides precise data.",
      },
    },
  },
  investmentsTable: {
    noAccountNumber: "No number",
    noLastSyncDate: "No date",
    summary: {
      priceGains: "Price gains",
      today: "Today",
      purchaseValue: "Purchase value",
      marketValue: "Market value",
      totalReturn: "Total return",
      showDetails: "Show details",
      hideDetails: "Hide details",
    },
  },
  bookingsTable: {
    overallValue: "Depot value",
    period: "Period",
    valueDate: "Value date",
    investment: "Investment",
    price: "Price",
    value: "Value",
    noBookings: "No bookings for the time range",
    exchangeRate: "Exchange rate: ",
  },
  assetClassName: {
    "11_stock": "Stock",
    "71_massets": "Material Assets",
    "91_managed": "Managed",
    "21_fund": "Fund",
    "22_etf": "ETF",
    "51_certos": "Certificates/OS",
  },
  accountView: {
    noBank: "No bank",
  },
  accountBox: {
    noBank: "No bank",
  },
  bitpandaV1Banner:
    "The Bitpanda v1 API is no longer supported. Please migrate to v2 by selecting Bitpanda (v2) in the bank search.",
  mainChartLayout: {
    timeBrushClose: "Close",
    timeBrushOpen: "Time brush",
  },
  viewLayout: { close: "Close" },
  performanceOverview: {
    performance: "Performance",
    gainAndLoss: "P/L (Unrealized + realized)",
    returnOnInvestment: "Market returns",
    realizedGains: "Realized gains",
  },

  dividendsChart: {
    title: "Historic dividends",
    subtitle: "The dividend payout history",
    tooltip:
      "The companies dividend payment history. All values are aggregated for full years.",
  },
  historicalQuotesChart: {
    title: "Historic market return up to now",
    subtitle:
      "This is the market or share-price return from N years up to now.",
    tooltip: "This is the market or share-price return from N years up to now.",
    year_one: "{{count}} Year",
    year_other: "{{count}} Years",
  },
  investmentChartTooltip: {
    buy: "Buy",
    sell: "Sell",
    dividend: "Dividend",
    book_in: "Book in",
    book_out: "Book out",
    retained_dividend: "Retained dividend",
    purchase_right: "Purchase right",
    carve_out: "Carve out",
    split: "Split",
    expected_dividend: "Expected dividend",
    reverse_split: "Reverse split",
    switch: "Switch",
    fees: "Fees",
    cap_gains_tax: "Withholding tax",
    cap_gains_tax_refund: "Withholding refund",
    pre_tax_allowance: "Tax-free allowance",
  },
  assetTypeBreakdown: {
    allHoldings: { title: "Holdings", noData: "No holdings" },
    funds: { title: "Funds", noData: "No funds" },
    etfs: { title: "ETF", noData: "No ETF" },
    derivative: { title: "Derivative", noData: "No derivative" },
    bonds: { title: "Bonds", noData: "No bonds" },
    crypto: { title: "Crypto", noData: "No crypto" },
    currencies: { title: "Currencies", noData: "No currencies" },
    preciousMetals: { title: "Precious metals", noData: "No precious metals" },
    filter: {
      clear: "{{classes}}: show all asset classes",
      label: "Asset class",
      all: "All asset classes",
      selected: "{{count}} asset classes",
      empty: "No investments in the selected asset classes.",
      share: "{{percent}} % of the portfolio",
    },
  },
  breadcrumbs: {
    home: "Home",
    investments: "Investments",
    cashback: "Cashback",
    depotsAccounts: "Portfolios & Accounts",
    accounts: "Accounts",
    addDividends: "Add dividends",
    recommend: "Recommendation",
    cashflow: "Cashflow Analyzer",
    contract: "Contract Analyzer",
    goals: "Goals",
  },
  tradeRepublic: {
    connectFrom: {
      phone: {
        label: "Phone",
        helperText: "International format, ex.: +4915753345623",
      },
      pin: { label: "PIN", helperText: "four digits, ex.: 1234" },
      submit: "Send",
    },
    codeFrom: {
      code: {
        label: "Code from app",
        helperText: "four digits, ex.: 1234",
      },
      submit: "Sync Data",
    },
    error: {
      title: "Error",
      message: "Please contact Rentablo support.",
    },
    success: {
      title: "Success",
      message: "Data is synced. Thanks for help.",
    },
  },
  accountChart: {
    subtitle: "Current account balance",
  },
  impersonation: {
    banner: "You are impersonating {{user}}.",
    end: "End impersonation",
  },
  admin: {
    userManagement: {
      title: "User Management",
      searchTab: "Search Users",
      search: {
        label: "Search users",
        placeholder: "Search by ID, name or email",
        fullWildcard: "Full wildcard search",
        fullWildcardHint: "(slower)",
        noMatch: 'No users match "{{term}}".',
        prompt: "Search to list users.",
      },
      table: {
        id: "ID",
        name: "Name",
        email: "Email",
        status: "Status",
      },
      status: {
        active: "active",
        inactive: "inactive",
      },
      recentlyViewed: {
        title: "Recently viewed",
        subtitle: "ID {{id}} · {{email}}",
      },
      detail: {
        title: "User details",
        fallbackTitle: "User",
        loadError: "This user could not be loaded.",
        impersonate: "Impersonate",
        lastLoginLine:
          "Last login {{lastLogin}} · Member since {{memberSince}}",
      },
      account: {
        title: "Account",
        email: "Email",
        name: "Name",
        finApi: "FinAPI account",
        emailDeliveryStatus: "Email delivery status",
        resetStatus: "Reset status",
        acceptedAgb: "Accepted AGB",
        acceptedAgbOn: "Yes · {{date}}",
        notAccepted: "Not accepted",
        mandator: "Mandator",
        yes: "Yes",
        no: "No",
        readOnly: "(read-only)",
        mandatorChanged: "Mandator changed to {{mandator}}.",
        saveEmail: "Save email",
      },
      flags: {
        title: "Status flags",
        emailConfirmed: "Email confirmed",
        enabled: "Account enabled",
        locked: "Account locked",
        clientCredentialsDisabled: "Client credentials disabled (admin)",
        accountExpired: "Account expired (read-only)",
        passwordExpired: "Password expired (read-only)",
        lockedSuccess: "Account locked.",
        unlockedSuccess: "Account unlocked.",
      },
      roles: {
        title: "Roles",
        none: "No roles assigned.",
        showAll: "Show all ({{count}} more)",
        showLess: "Show less",
        addPlaceholder: "Search roles, e.g. ROLE_IMPERSONATE",
        assignRole: "Assign role",
        removeTitle: "Remove role",
        removeConfirm: "Remove the role {{role}} from {{user}}?",
        removeConfirmLabel: "Remove",
      },
      common: {
        cancel: "Cancel",
      },
      roleManagementTab: "Role Management",
      roleManagement: {
        title: "All roles",
        addTitle: "Add a role",
        addLabel: "Role authority",
        addPlaceholder: "e.g. ROLE_SUPPORT_AGENT",
        addButton: "Add role",
        deleteTitle: "Delete role",
        deleteConfirm: "Delete the role {{role}}? This cannot be undone.",
        deleteConfirmLabel: "Delete",
        noRoles: "No roles found.",
        column: {
          authority: "Authority",
          actions: "",
        },
      },
    },
    grants: {
      title: "User Tokens",
      receivingUser: {
        title: "Receiving user",
        subtitle:
          "The user whose API token will receive the right to impersonate others.",
      },
      userSearch: {
        placeholder: "Search by email, name, or ID",
        loading: "Searching…",
        noOptions: "No matching users.",
      },
      tokenPicker: {
        title: "Receiving token",
        subtitle:
          "Choose which of this user's API tokens will receive impersonation rights.",
        loadError: "This user's API tokens could not be loaded.",
      },
      empty: {
        title: "This user has no API tokens.",
        hint: "The dev must create a token from their own profile — admins cannot create one on their behalf.",
      },
      table: {
        id: "ID",
        name: "Name",
        prefix: "Prefix",
        created: "Created",
        permissions: "Permissions",
        lastUsed: "Last used",
        expires: "Expires",
      },
      control: {
        grants: {
          title: "Existing grants",
          subtitle: "Users this token can currently impersonate.",
          loadError: "The existing grants could not be loaded.",
          target: "Target user",
          grantedBy: "Granted by",
          expires: "Expires",
          status: "Status",
          statusActive: "Active",
          statusExpired: "Expired",
          revoke: "Revoke",
          cancel: "Cancel",
          empty: "No impersonation grants on this token yet.",
          revokeTitle: "Revoke grant",
          revokeText:
            "Revoke this impersonation grant? The developer's token immediately loses access to that user.",
        },
        add: {
          title: "Add grants",
          subtitle: "Grant this token the right to impersonate more users.",
          targetsLabel: "Target user IDs",
          targetsPlaceholder: "e.g. 113414, 643213, 43143",
          targetsHelper:
            "Comma-separated user IDs of the users to impersonate. Spaces are ignored.",
          targetsError: "Enter at least one valid user ID.",
          modeSearch: "Search users",
          modePaste: "Paste user IDs",
          searchLabel: "Target users",
          searchHelper: "Pick a user to add them to the list below.",
          selectedEmpty: "No users picked yet.",
          remove: "Remove",
          expiryLabel: "Expiration",
          expiryOption_one: "In {{count}} day",
          expiryOption_other: "In {{count}} days",
          expiryHint: "Maximum 7 days.",
          mfaLabel: "MFA code",
          mfaHint: "6-digit code from your authenticator app.",
          mfaRequired: "Enter your MFA code.",
          mfaExpired:
            "Your MFA code expired mid-request — please enter a fresh one to continue.",
          submit: "Grant permissions",
          continue: "Continue",
          progress: {
            pending: "Pending",
            granted: "Granted",
            failed: "Failed",
          },
        },
        errors: {
          forbidden:
            "Your account does not have the impersonation-grant permission.",
          notFound:
            "The token or grant does not exist. It may have been deleted — reload the page.",
          mfaDisabled:
            "You must enable 2FA on your account before you can grant impersonation.",
          mandatorScope:
            "Both the token owner and the impersonated user must be in your mandator.",
          expiryRange: "Expiration must be within the next 7 days.",
          generic: "Something went wrong.",
        },
      },
    },
    logos: {
      title: "Company or emitter logo",
      breadrcumb: "Company logo",
      add: "Add logo",
      searchButton: "Logo",
      isin: "ISIN",
      name: "Name",
      logo: "Logo",
      date: "Date",
      addTitle: "Add logo",
      logoUpload: "Drag or select logo here",
      bannerTitle: "Change current logo",
      bannerDescription:
        "The current logo will be replaced by the new logo once you upload and save the new logo",
      bannerButton: "Okay",
      noLogos: "No logos found",
      deleteThisLogo: "Delete this logo?",
      succesUpload: "The logo was uploaded successfully",
    },
    etfs: {
      title: "ETF/ETC Classification",
      add: "Add classification",
      deleteThisClassification: "Delete this classification?",
      isin: "ISIN",
      name: "Name",
      type: "Classification",
      date: "Date",
      apply: "Search",
      noEtfs: "No ETFs/ETCs found",
    },
    names: {
      title: "Preferred names",
      add: "Add preferred name",
      edit: "Edit preferred name",
      isin: "ISIN",
      deleteThisName: "Delete this name?",
      standardName: "Standard name",
      preferredName: "Preferred name",
      date: "Date",
      search: "Search",
      apply: "Save",
      noNames: "Nothing found",
    },
    assetReport: {
      title: "Asset Report",
      emitters: {
        label: "Fund ETF Issuer",
        all: "All",
        funds: "Fund Issuer",
        etfs: "ETF Issuer",
      },
      issuer: { label: "Select issuer", placeholder: "Enter name" },
      emitter: { label: "Select issuer", placeholder: "Enter name" },
      isins: {
        label:
          "Insert ISINs (Please enter the individual ISINs separated by commas without spaces)",
        placeholder: "Insert ISINs",
      },
      startDate: { label: "Date from (Optional)" },
      endDate: { label: "Date to (Optional)" },
      button: "Generate report",
      table: {
        tabTitle: "Table",
        emitters: "Issuers",
        isins: "ISINs",
        from: "Date from",
        startVolume: "Start volume",
        to: "Date to",
        endVolume: "End volume",
        delta: "Delta",
        total: "Total amount:",
      },
    },
    isinChanges: {
      mainPage: {
        applyConfirmTitle:
          "Apply this ISIN change down to all investments with this ISIN?",
        applyConfirmText: "This action cannot be undone",
        applyButton: "Apply",
        applySuccess: "ISIN change applied successfully",
        applyError: "Failed to apply ISIN change",
      },
    },
    splits: {
      mainPage: {
        breadcrumbs: {
          splits: "Splits Management",
        },
        title: "Splits Management",
        addButton: "Split",
        noSplits: "No splits found",
        apply: "Apply",
        deleteThisSplit: "Delete this split?",
      },
      actions: {
        showActions: "Show actions",
        addToAll: "add to all",
        updateAll: "update all",
        deleteAll: "delete all",
        addToAllConfirmTitle: "Add this split to all positions?",
        addToAllConfirmText:
          "The split of {{isin}} on {{date}} is booked on every position that was held before the split date and has no split close to it. The job runs in the background.",
        updateAllConfirmTitle: "Update this split on all positions?",
        updateAllConfirmText:
          "Every position holding {{isin}} gets exactly this split on {{date}}: missing splits are added and splits that differ are replaced. The job runs in the background.",
        deleteAllConfirmTitle: "Delete this split from all positions?",
        deleteAllConfirmText:
          "The split bookings created from this deleted split are rolled back on every position holding {{isin}}. The job runs in the background.",
        started_one: "Started for {{count}} depot",
        started_other: "Started for {{count}} depots",
        error: "The split could not be processed",
      },
      editPage: {
        submit: "Submit",
        breadcrumbs: {
          edit: "Edit split",
          add: "Add split",
        },
      },
    },
    dividends: {
      save: "Save",
      close: "Cancel",
      clone: "Copy dividends",
      mainPage: {
        title: "Manage dividends",
        breadcrumbs: { dividends: "Manage dividends" },
        noDividends: "No dividends found ",
        apply: "Apply",
        deleteThisDividend: "Delete this dividend?",
        noIsin: "No ISIN specified. Please provide an ISIN",
      },
      cloneModal: {
        title: "Copy dividends",
        success: "Dividends copied successfully ",
      },
      addPage: {
        title: "Add dividend",
      },
      editPage: {
        title: "Edit dividend",
        fields: {
          isin: "ISIN",
          amount: "Amount",
          currency: "Currency",
          exDate: "Execution Date",
          paymentDate: "Payment date",
          splitAdjustedAmount: "Split adjusted amount",
          amountInCurrency: "Amount in currency",
          splitAdjustedAmountInCurrency: "Split adjusted amount in currency",
          markedAsDeleted: "Marked as deleted",
          wasCurated: "Was curated",
          isSpecial: "Special",
        },
      },
    },
    interfaces: {
      mainPage: {
        title: "Manage Interfaces",
        breadcrumbs: {
          interfaces: "Manage Interfaces",
        },
      },
      editPage: {
        submit: "Save",
        breadcrumbs: {
          edit: "Edit Interface",
          add: "Add Interface",
        },
      },
    },
    bankMessages: {
      title: "Bank message overview",
      createNew: "Create message",
      breadcrumbs: { bankMessages: "Message overview" },
      filterBy: "Filter by",
      createSuccess: "Message created successfully",
      createError: "Message could not created",
      deleteSuccess: "Message deleted successfully",
      deleteError: "Message could not be deleted",
      updateSuccess: "Message updated successfully",
      updateError: "Message could not be updated",
      copySuccess: "Message copied successfully",
      copyError: "Message could not be copied",
      table: {
        severity: "Message type",
        bic: "BIC",
        message_text: "Message text",
        valid_until: "Due date",
        unlimited: "Perpetual",
        expired: "Expired",
        expiresToday: " Expires today",
        expiresIn_one: "Due in {{amount}} day",
        expiresIn_other: "Due in {{amount}} days",
        expiresInHours_one: "Due in {{amount}} hour",
        expiresInHours_other: "Due in { {amount}} hours",
        INFO: "Info",
        WARNING: "Warning",
        ERROR: "Error",
        edit: "Edit",
        copy: "Copy",
        delete: "Delete",
        noData: "No data",
      },
      form: {
        limited: "Limited message",
        message_text: "Message text",
        message_text_placeholder: "Enter text",
        severity: "Severity",
        bic: "BIC",
        start_date: "Date from",
        start_date_tooltip:
          'Please select the start date for displaying the message. If you select today as the start date, the message will be displayed immediately after clicking the "Update message" button. If you select a future date, the message will be displayed from midnight on the selected day.',
        end_date: "Date until",
        end_date_tooltip:
          "Please select the end date for displaying the message. The message will be displayed until midnight on the selected day.",
      },
      newModal: { title: "Create message", submit: "Create message" },
      editModal: { title: "Use message again", submit: "Update message" },
    },
    bankEvents: {
      title: "Bank Connection Events",
      userId: "User ID",
      userId_placeholder: "Enter User ID",
      table: {
        date: "Date",
        bankName: "Bank Name",
        faq: "FAQ",
        copyCode: "Copy code",
        warning: "Warning",
        error: "Error",
        info: "Info",
        faqTooltip:
          'The link takes you to our wealthAPI Help Center. You must be logged in to Zendesk with your login details to access our FAQ. It\'s best to remember the "message" from the code. Enter the relevant keywords in the FAQ search so that the relevant entry is displayed.',
        noData: "No data",
      },
    },
    cashbackBookings: {
      title: "Cashback Bookings",
      mandatorLabel: "Filter by mandator (default: all mandators)",
      absByMonth: "Cashback subscriptions absolute by month",
      mailReturnByMonth: "Subscription mail return rate in percent by month",
      averageMailReturn: "Average mail return rate is {{value}}",
      churnByMonth: "Subscription churn rate in percent by month",
      avgChurnRate: "Average churn rate is {{value}}",
      currentAssetsByBank: "Current assets by bank",
      totalManagedByMonth: "Total managed assets by month",
    },
    apiRefresh: {
      title: "Historic Quotes Refresh",
      hqIsin: {
        isinLabel: "ISIN",
      },
      hqTicker: {
        tickerLabel: "Ticker symbol",
        quoteLabel: "Quote provider",
      },
      button: "Refresh",
      successMessage: "Refreshed succesfully",
      errorMessage: "Refresh failed",
    },
    bankLogs: {
      title: "Bank Sync Logs",
      subtitle:
        "Using a user ID, you can display the import data for a selected bank for a certain period of time. The log files are made available to you as a code when you click on an entry in the table.",
      form: {
        start_date: "Date from",
        start_date_tooltip:
          "Please select the start date for the desired period",
        end_date: "Date to",
        end_date_tooltip: "Please select the end date for the desired period ",
        userId: "User ID",
        bank: "Bank",
      },
      table: {
        date: "Time",
        logId: "Log ID",
        userId: "User ID",
        noData: "No data",
      },
    },
    bankHealth: {
      title: "Bank Health Reports",
      tabs: { table: "Table", chart: "Chart view", errors: "Tracking error" },
      form: {
        start_date: "Date from",
        start_date_tooltip:
          "Please select the start date for the desired period off",
        end_date: "Date to",
        end_date_tooltip: "Please select the end date for the desired period",
        bank: "Bank",
        interval: "Interval",
        interval_tooltip:
          "Please select the desired time interval for the analysis. You can choose between 15 minute, 1 hour, daily and weekly intervals. Please note that the availability of certain intervals depends on the preset period (from... to).",
        day: "Day",
        week: "Week",
        quarter: "15 minutes",
        hour: "Hour",
      },
      table: {
        date: "Date",
        interval: "Time",
        includeUserErrors: "User-based errors",
        successRate: "Success rate",
        failureRate: "Error rate",
        totalImports: "Total imports",
        noData: "No data",
      },
      errors: {
        isin: "ISIN",
        count: "Number of tracking errors",
        noIsin: "No ISIN",
        details: {
          button: "Details",
          title: "Tracking errors for {{isin}}",
          total: "{{total}} tracking errors in total",
          id: "ID",
          userId: "User ID",
          depotId: "Depot ID",
          investmentName: "Investment",
          delta: "Delta",
          createdAt: "Created at",
        },
      },
    },
    cryptoRefresh: {
      title: "Crypto Currencies",
      form: {
        coinGeckoId: "CoinGecko ID",
      },
      addButton: "Add",
      successMessage: "Crypto currency added successfully",
      errorMessage: "Failed to add crypto currency",
      refreshButton: "Refresh",
      refreshSuccessMessage: "Crypto currency refreshed successfully",
      refreshErrorMessage: "Failed to refresh crypto currency",
    },
    finApi: {
      validity: {
        expired: "Expired",
        expiresToday: "Expires today",
        expiresIn_one: "Expires in {{count}} day",
        expiresIn_other: "Expires in {{count}} days",
        unlimited: "Unlimited",
      },
      clientConfiguration: {
        loadError: "The finAPI client configuration could not be loaded.",
        form: {
          title: "Editable settings",
          userNotificationCallbackUrl: "User notification callback URL",
          finTSProductRegistrationNumber: "FinTS product registration number",
          finTSProductRegistrationNumberHint:
            "A stored number is shown as XXXXX. Leave it unchanged to keep it.",
          refreshTokensValidityPeriod: "Refresh token validity",
          userAccessTokensValidityPeriod: "User access token validity",
          clientAccessTokensValidityPeriod: "Client access token validity",
          validityPeriodHint: "In seconds. 0 means the tokens never expire.",
          validityPeriodError:
            "Please enter a whole number of seconds (0 or more).",
          betaBanksEnabled: "Beta banks enabled",
          saveSuccess: "finAPI client configuration saved",
          saveError: "The finAPI client configuration could not be saved",
        },
        overview: {
          hint: "These settings are managed by finAPI and can only be changed by finAPI support.",
          sections: {
            access: "License & access",
            banks: "Banks & updates",
            users: "Users",
            categorization: "Categorization",
          },
          fields: {
            isMandatorAdmin: "Mandator admin",
            mandatorLicense: "License",
            aisEnabled: "Account information (AIS)",
            paymentsEnabled: "Payment initiation (PIS)",
            isStandalonePaymentsEnabled: "Standalone payments",
            aisViaWebForm: "AIS via web form",
            pisViaWebForm: "PIS via web form",
            pisStandaloneViaWebForm: "Standalone PIS via web form",
            preferredConsentType: "Preferred consent type",
            enabledProducts: "Enabled products",
            corsAllowedOrigins: "CORS allowed origins",
            testBanksEnabled: "Test banks",
            businessBanksEnabled: "Business banks",
            isWebScrapingEnabled: "Web scraping",
            availableBankGroups: "Bank groups",
            accountTypeRestrictions: "Account type restrictions",
            nonEuroAccountHandling: "Non-euro accounts",
            transactionImportLimitation:
              "Transaction import limit (days, 0 = none)",
            isAutomaticBatchUpdateEnabled: "Automatic batch update",
            isDevelopmentModeEnabled: "Development mode",
            isUserAutoVerificationEnabled: "User auto-verification",
            maxUserLoginAttempts: "Max. login attempts (0 = unlimited)",
            userRetentionPeriod: "User retention (days, 0 = unlimited)",
            userSynchronizationCallbackUrl: "User synchronization callback URL",
            pfmServicesEnabled: "PFM services",
            isAutoCategorizationEnabled: "Auto-categorization",
            allKeywordsMustMatchForCategorization: "All keywords must match",
            categoryRestrictionsEnabled: "Category restrictions",
            categoryRestrictions: "Restricted to categories",
          },
        },
      },
      tppCertificates: {
        description:
          "QWAC certificates identify us to the banks during the TLS handshake; QSealC certificates sign our requests to the banks.",
        addButton: "Add certificate",
        noData: "No TPP certificates stored.",
        columns: {
          id: "ID",
          type: "Type",
          label: "Label",
          validFrom: "Valid from",
          validUntil: "Valid until",
        },
        create: {
          title: "Add TPP certificate",
          type: "Type",
          label: "Label",
          publicKey: "Certificate (public key)",
          privateKey: "Private key",
          privateKeyHint:
            "PKCS #8 in PEM format, starting with -----BEGIN PRIVATE KEY----- or -----BEGIN ENCRYPTED PRIVATE KEY-----",
          passphrase: "Passphrase",
          validFromDate: "Valid from",
          validUntilDate: "Valid until",
          submit: "Add certificate",
          error: "The certificate could not be added.",
        },
        createSuccess: "Certificate added",
        deleteTitle: "Delete TPP certificate",
        deleteConfirm:
          'Delete the {{type}} certificate "{{label}}"? This cannot be undone.',
        deleteSuccess: "Certificate deleted",
      },
      tppCredentials: {
        description:
          "Credentials the banks issued to us when we registered as a TPP, per TPP authentication group.",
        addButton: "Add credentials",
        noData: "No TPP credentials stored.",
        columns: {
          id: "ID",
          authenticationGroup: "Authentication group",
          label: "Label",
          validFrom: "Valid from",
          validUntil: "Valid until",
        },
        create: {
          title: "Add TPP credentials",
          authenticationGroup: "Authentication group",
          authenticationGroupPlaceholder: "Search by name",
          noAuthenticationGroups: "No authentication groups found",
          label: "Label",
          tppClientId: "Client ID",
          tppClientSecret: "Client secret",
          tppApiKey: "API key",
          tppName: "TPP name",
          tppNameHint: "Only needed for a few banks, e.g. Revolut.",
          validFromDate: "Valid from",
          validUntilDate: "Valid until",
          submit: "Add credentials",
          error: "The credentials could not be added.",
        },
        createSuccess: "Credentials added",
        deleteTitle: "Delete TPP credentials",
        deleteConfirm:
          'Delete the credentials "{{label}}"? This cannot be undone.',
        deleteSuccess: "Credentials deleted",
      },
      inactiveUsers: {
        description:
          "finAPI users that no longer belong to an active user here, for example because the user was deleted. The numbers come from the last rebuild of the statistics.",
        reloadButton: "Reload",
        rebuildButton: "Rebuild statistics",
        rebuildStarted:
          "Rebuilding the statistics. This reads every user from finAPI and takes a few minutes; reload to see the numbers fill up.",
        rebuildError: "The statistics could not be rebuilt.",
        deleteButton: "Delete inactive users",
        loadError: "The statistics could not be loaded.",
        noData: "No statistics yet.",
        noDataHint: "They appear here after a rebuild.",
        summary: {
          inactive: "Inactive users",
          active: "Active users",
        },
        columns: {
          mandator: "Mandator",
          inactive: "Inactive users",
          active: "Active users",
        },
        delete: {
          title: "Delete inactive finAPI users",
          text_one:
            "This deletes {{formattedCount}} inactive user in finAPI, across all mandators. It cannot be undone.",
          text_other:
            "This deletes {{formattedCount}} inactive users in finAPI, across all mandators. It cannot be undone.",
          confirmationLabel: "Type {{word}} to confirm",
          submit: "Delete inactive users",
          error: "The inactive users could not be deleted.",
          started_one:
            "Deleting {{formattedCount}} inactive user in the background.",
          started_other:
            "Deleting {{formattedCount}} inactive users in the background.",
        },
        trialRun: {
          button: "Trial run",
          result_one:
            "Trial run: {{formattedCount}} inactive user would be deleted. {{formattedActive}} active users are not affected.",
          result_other:
            "Trial run: {{formattedCount}} inactive users would be deleted. {{formattedActive}} active users are not affected.",
          error: "The trial run failed.",
        },
      },
    },
    mandators: {
      searchPlaceholder: "Search by public ID, ID or client ID",
      addButton: "Add mandator",
      totalCount_one: "{{count}} mandator",
      totalCount_other: "{{count}} mandators",
      matchCount: "{{count}} of {{total}} mandators",
      noData: "No mandators found.",
      noSearchResults: "No mandator matches “{{search}}”.",
      loadError: "The mandators could not be loaded.",
      columns: {
        publicId: "Public ID",
        id: "ID",
        clientId: "Client ID",
      },
      edit: {
        createTitle: "Add mandator",
        title: "Edit mandator",
        publicId: "Public ID",
        clientId: "Client ID",
        clientSecret: "Client secret",
        keepHint: "Leave empty to keep the current client ID.",
        clientSecretHint: "Leave empty to keep the current secret.",
        error: "The mandator could not be saved.",
        saveSuccess: "Mandator {{publicId}} saved",
      },
      configuration: {
        fallbackTitle: "Mandator",
        hint: "Each card saves on its own and sends only the values you changed. Secrets are never shown; enter a value to replace one.",
        loadError: "The configuration could not be loaded.",
        saveSuccess: "{{section}} saved",
        saveError: "The configuration could not be saved.",
        secretStored: "Stored. Enter a value to replace it.",
        secretNotSet: "Not set.",
        wholeNumber: "Enter a whole number.",
        sections: {
          access: "Registration and login",
          licenses: "Licenses and features",
          bankConnections: "Bank connections",
          finApi: "finAPI",
          zendesk: "Zendesk",
        },
        fields: {
          supportsNewUserRegistration: "New users can register",
          oauthClientCredentialsEnabled: "OAuth requires client credentials",
          refreshTokenExpirationInSeconds: "Refresh token lifetime",
          supportsSubscriptions: "Subscriptions",
          stockFundamentalsLicense: "Stock fundamentals",
          fundFundamentalsLicense: "Fund fundamentals",
          cryptoLicense: "Crypto",
          publicPortfoliosLicense: "Public portfolios",
          dividendPlannerLicense: "Dividend planner",
          brokerizeLicense: "Brokerize",
          userStatusManagementLicense: "User status management",
          complianceLicense: "Compliance",
          investmentReportEnabled: "Investment report",
          anonymousCommentsEnabled: "Anonymous comments",
          commentChallengeTokenEnabled: "Challenge token for comments",
          isTppWebFormRequired: "TPP web form required",
          isEarlyWebFormRedirectSupported: "Early redirect from the web form",
          batchSyncCallbackUrl: "Batch sync callback URL",
          finApiClientId: "Client ID",
          finApiClientSecret: "Client secret",
          finApiAdminClientId: "Admin client ID",
          finApiAdminClientSecret: "Admin client secret",
          finApiDataDecryptionKey: "Data decryption key",
          zendeskSupportLicense: "Zendesk support",
          zendeskApiEmail: "API email",
          zendeskApiToken: "API token",
          zendeskRequesterEmail: "Requester email",
          zendeskRequesterName: "Requester name",
          zendeskTicketTags: "Ticket tags",
        },
        hints: {
          refreshTokenExpirationInSeconds: "In seconds.",
          batchSyncCallbackUrl: "A public HTTPS URL.",
          zendeskRequesterEmail:
            "Can be changed but not removed. Leave empty to keep the current email.",
          zendeskRequesterName:
            "Can be changed but not removed. Leave empty to keep the current name.",
          zendeskTicketTags:
            "Comma-separated, no spaces within a tag. Leave empty to remove the tags.",
        },
      },
    },
    currencies: {
      searchPlaceholder: "Search by code or name",
      addButton: "Add currency",
      noData: "No currency found.",
      loadError: "The currencies could not be loaded.",
      columns: {
        code: "Code",
        name: "Name",
        toEUR: "To EUR",
        deletedAt: "Deleted on",
      },
      edit: {
        createTitle: "Add currency",
        title: "Edit currency",
        code: "Code",
        codeHint: "3 to 10 letters or digits, e.g. CHF.",
        codeError: "Use 3 to 10 letters or digits.",
        codeExists:
          "This currency already exists. Edit it in the list instead.",
        name: "Name",
        error: "The currency could not be saved.",
        saveSuccess: "Currency {{code}} saved",
      },
      delete: {
        title: "Delete currency",
        text: "Delete {{code}} ({{name}})? The currency is only marked as deleted: it stays in the list with its deletion date, and accounts and investments keep using it.",
        success: "Currency {{code}} marked as deleted",
      },
    },
    invoicing: {
      mandator: "Mandator",
      mandatorPlaceholder: "Search by public ID or ID",
      noMandators: "No mandator found",
      month: "Month",
      includeBankConnections:
        "Count the users with bank connections (takes up to a minute)",
      chooseMandator: "Choose a mandator to see its invoicing data.",
      loadError: "The invoicing data could not be loaded.",
      noData: "No data.",
      columns: {
        figure: "Figure",
        value: "Value",
      },
      fields: {
        customerId: "Customer ID",
        invoiceId: "Invoice ID",
        period: "Month",
        activeUsers: "Active users",
        finApiUsers: "finAPI users",
        brokerizeUsers: "brokerize users",
        usersWithBankConnections: "Users with bank connections",
        lastLogin0to6: "Last login 0 to 6 months ago",
        lastLogin6to12: "Last login 6 to 12 months ago",
        lastLogin12to18: "Last login 12 to 18 months ago",
        lastLoginMoreThan18: "Last login more than 18 months ago",
      },
      wazag: {
        description: "Counted now, across all mandators.",
        loadError: "The WAZAG figures could not be loaded.",
        users: "Enabled users with a finAPI user",
        cashAccounts: "Their finAPI checking and credit card accounts",
      },
    },
    kpis: {
      allMandators: "All mandators",
      loadError: "The KPIs could not be loaded.",
      userGrowth: {
        description:
          "Counted now. Registered users are all users not marked as deleted, churned users all users marked as deleted. A registered user is active if they logged in within the chosen time. The charts and the table count every user in the month they signed up.",
        activeWithin: "Active within",
        months_one: "{{count}} month",
        months_other: "{{count}} months",
        registeredUsers: "Registered users",
        activeUsers: "Active users",
        churnedUsers: "Churned users",
        perMonth: "Users by sign-up month",
        cumulated: "Users by sign-up month, cumulated",
        signUpMonth: "Sign-up month",
        view: "View",
        chart: "Chart",
        table: "Table",
      },
    },
  },
  interfaceSelectionOptions: {
    "checking.accounts": "Checking Accounts",
    "depots.and.reference.accounts": "Portfolios and reference accounts",
    "depots.and.other.accounts": "Portfolios and other accounts",
    "other.accounts": "Other accounts",
    "credit.cards": "Credit Cards",
    "depots.and.savings.and.credit.cards":
      "Portfolios, savings accounts & credit cards",
  },
  cashbackWizard: {
    yes: "Yes",
    no: "No",
    start: {
      title: "Cashback is free of charge and easy to apply for",
      subtitle:
        "It takes about 5 minutes. If you are already a customer of a Rentablo partner bank (e.g. comdirect), please have your deposit or customer number ready.",
      steps: {
        first: { title: "Step 1", description: "Enter data" },
        second: { title: "Step 2", description: "Print" },
        third: { title: "Step 3", description: "Send to us" },
      },
      cards: {
        title: "That's what customers say",
        subtitle: "See for yourself",
        vincentWillkomm: {
          name: "Vincent Willkomm",
          profession: "Finanzblogger, Hamburg",
          text: "“I use cashback to push the costs of active investment funds towards ETF levels. This guarantees the highest reimbursement of commissions.”",
        },
        ingeborgK: {
          name: "Ingeborg K.",
          profession: "Pensionärin, Nürnberg",
          text: "“I've been using Rentablo Cashback since January 2018 and I've been happy about punctual since then Payouts of more than 1,200 euros per quarter.”",
        },
        konetzke: {
          name: "Toralf Konetzke",
          profession: "Entrepreneur and professional athlete, Cottbus",
          text: "“With the cashback you converted a penalty for me. Costs down and returns up - perfect! Thank you and keep it up!””",
        },
        siebers: {
          name: "Torsten Siebers",
          profession: "Management Consultant, Hamburg",
          text: "“As a user, I am always amazed at the enthusiasm with which the Rentablo team devotes itself to consumer protection and implements it with fund cashback.”",
        },
      },
    },
    sidebar: {
      main: "Cashback",
      personalInformation: "Personal information",
      depotSelection: "Depot selection",
      depotFacility: {
        newUser: "Depot setup",
        existingUser: "Change of agent",
        commonTitle: "Depot opening/transfer",
      },
      experience: "Investment experience",
      payout: "Tariff & reference account",
      summary: "Completion",
      cashback: "Request cashback",
      you: "Your data",
      partner: "Your partner",
      minor: "Minor",
      legalGuardian1: "First legal guardian",
      legalGuardian2: "Second legal guardian",
    },
    workflow: {
      accountType: {
        title: "Are you a private or business customer?",
        subtitle: "Please specify what type of customer you are",
        PRIVATE: "Private customer",
        COMPANY: "Legal entity",
        COMPANY_subtitle: "LLC, Corp, AG, Foundation, Association",
      },
      newOrExistingDepot: {
        title: "Have you already opened an account?",
        subtitle: "Add existing accounts or open a new account",
        newDepot: "No, I would like to open a new Portfolio",
        existingDepot: "Yes, I already have a Portfolio",
      },
    },
    selectBank: {
      title: {
        default:
          "Which bank would you like to open your cashback account with?",
        onvista:
          "With which partner bank would you like to open your onvista cashback depot?",
        existingUser:
          "Which Rentablo partner bank do you keep your account with?",
        existingUser_onvista:
          "Which partner bank do you keep your account with?",
      },
      subtitle: "We work with the following partners",
      bestService: "Best customer service",
      bestPrice: "Price-performance winner",
      tooltip: {
        rating: "Our rating",
        AUGBDE77XXX:
          "As a former AAB customer, FNZ grants a maximum discount on the issue premium of 95%. To receive a 100% discount, FNZ recommends that you transfer your securities from your former AAB depot to a “pure” FNZ depot.",
        COBADEHDXXX: {
          depotFee: "0€ custody account management",
          numberOfFunds: "over 24,000 tradable funds",
          fundSavingsPlan: "0.95€ costs for fund savings plan",
          allInOne: "Trade funds, shares and ETF",
          rating: 5,
        },
        DABBDEMMXXX: {
          depotFee: "0€ depot management",
          numberOfFunds: "over 13,000 tradable funds",
          fundSavingsPlan: "2€ costs for fund savings plan",
          allInOne: "Trade funds, shares and ETF",
          rating: 3,
        },
        COBADEMXXXX: {
          depotFee: "45€ custody account management",
          numberOfFunds: "over 6,900 tradable funds",
          fundSavingsPlan: "0€ costs for fund savings plan",
          allInOne: "Trade funds and ETFs",
          rating: 3,
        },
        FODBDE77XXX: {
          depotFee: "0€ to 30€ custody account",
          numberOfFunds: "over 7,000 tradable funds",
          fundSavingsPlan: "0€ costs for fund savings plan",
          allInOne: "Funds only",
          rating: 4,
        },
        FFBKDEFFTHK: {
          depotFee: "45€ custody account management",
          numberOfFunds: "Over 7,000 tradable funds",
          fundSavingsPlan: "0€ costs for fund savings plan",
          allInOne: "Only funds",
          rating: 2,
        },
      },
      morgenFundNote: {
        title: "Opening a cashback account at MorgenFund",
        text: "Dear customers, to open an investment portfolio with MorgenFund, please write us an email to: <supportEmailLink>{{supportEmail}}</supportEmailLink>. We will send you the necessary information as well Opening documents by email.",
      },
    },
    accountHolder: {
      selectExistingHolder: {
        title: "Select the account holder",
        subtitle: {
          default:
            "Each account holder can manage any number of their own or joint accounts for free. Rentablo receives a maximum of €15 per month per account holder",
          onvista:
            "Each account holder can manage any number of their own or joint accounts free of charge.",
        },
        label: "Saved",
        newAccount: "Create a new account holder",
        info: "Rentablo bills per account holder. If you create a new one, it will be billed separately. Use this function for partners or your children, for example.",
        info_onvista:
          "Billing and payment are made per account holder. If you click here, you will create a new account holder who will be billed and paid out separately. Use this function e.g. for partners or your children.",
      },
      accountHolderType: {
        title: {
          default: "What type of deposit do you want open?",
          existingUser: "What type of depot is it?",
        },
        subtitle: {
          default: "We have the right depot for your needs",
        },
        single: {
          title: "Single account",
          subtitle: "Your personal account with you as the only account holder",
        },
        joined: {
          title: "Joined account",
          subtitle: "A account for you and e.g. your spouse or equal holder",
        },
        minor: {
          title: "Minor custody account",
          subtitle:
            "The custody account for the child with the legal guardian as the authorized representative",
        },
        select: "Open now",
        select_existingUser: "Select",
      },
    },
    auth: {
      signup: {
        title: "Register now and save immediately when investing in funds",
        subtitle: "Rentablo is free and non-binding",
        email: "Your email address",
        email_placeholder: "e.g. markus@mustermann.de",
        password: "Password",
        password_placeholder: "Please set a password...",
        acceptedAgb:
          "I agree to the <link1>Rentablo terms</link1> and <link2>privacy agreements</link2>.",
        receiveNewsletter:
          "I would like to be informed about product updates and special offers",
        next: "Register with Rentablo",
        emailTaken:
          "The email you entered is already taken. If you have used the email before, ",
        emailTakenLink: "please log in",
        rememberMe: "Stay signed in",
      },
    },
    naturalPerson: {
      personalData: {
        title: {
          default: "Please enter your personal information",
          partner: "Please enter your partner's personal information",
          legalGuardian1:
            "Please enter the personal information of the first legal guardian",
          legalGuardian2:
            " Please enter the personal data of the second legal guardian",
          minor: "Please enter the personal data of the minor",
        },
        subtitle: {
          default:
            "The information is required by your bank to open a securities account",
          existingUser: "The Information is required from your bank",
        },
        gender: "Salutation",
        academicTitle: "Academic title",
        firstName: "First name",
        lastName: "Last name",
        countryOfBirth: "Country of birth",
        placeOfBirth: "Place of birth",
        dateOfBirth: " Date of birth",
        nameAtBirth: "Name at birth",
        areAccountHoldersMarried: "Are you married to your partner?",
        reduced: {
          title: {
            default: "Please enter your personal data",
            partner: "Please enter your partner's personal data",
            legalguardian1:
              "Please enter the personal data of the first legal guardian",
            legalGuardian1:
              "Please enter the personal data of the first legal guardian",
            legalguardian2:
              "Please enter the personal data of the second legal guardian",
            legalGuardian2:
              "Please enter the personal data of the second legal guardian",
            Minor: "Please enter the personal data of the minor",
            minor: "Please enter the personal data of the minor",
          },
          subtitle:
            "The information is needed to open your bank for the opening of your bank",
          gender: "Salutation",
          academicTitle: "Academic title",
          firstName: "First name",
          lastName: "Last name",
          phoneNumber: "Telephone number for queries",
          phoneNumber_placeholder: "+49",
        },
      },
      addressData: {
        title: {
          default: "Please enter your address",
          partner: "Please enter your partner's address",
          legalGuardian1:
            "Please enter the address of the first legal guardian",
          legalGuardian2:
            "Please enter the address of the second legal guardian",
          minor: "Please enter the address of the minor",
        },
        subtitle: {
          default:
            "The information is required by your bank to open a securities account",
          existingUser: "The information is required by your bank",
        },
        street: "Street",
        houseNumber: "House number",
        houseNumber_placeholder: "No.",
        zip: "Zip code",
        city: "City",
        city_placeholder: "Your Place of residence",
        addressCountry: "Country",
        phoneNumber: "Phone number for inquiries",
        phoneNumber_placeholder: "+49",
      },
      hasSecondLegalGuardian: {
        title: "Is there a second legal guardian?",
        subtitle:
          "If there is a second legal guardian, please indicate this as well.",
      },
      companyData: {
        title: "Please enter your company data",
        subtitle: {
          default:
            "The information is required by your bank to open a securities account",
          existingUser: "The information is required by your bank",
        },
        firstName: "company name",
        firstName_placeholder: "Your company name",
        lastName: "Legal form",
        lastName_placeholder: "Your legal form",
      },
      companyAddressData: {
        title: "Please enter your company address",
        subtitle: {
          default:
            "The information for opening a securities account is taken from your Bank required",
          existingUser: "The information is required by your bank",
        },
        street: "Street",
        houseNumber: "House number",
        houseNumber_placeholder: "No.",
        zip: "Zip code",
        city: "Company city",
        city_placeholder: "Your company location",
        addressCountry: "Country",
        phoneNumber: "Phone number for inquiries",
        phoneNumber_placeholder: "+49",
      },
    },
    turnover: {
      title: "How high are your expected account turnovers?",
      regularIncomePerMonth: "Regular expected cash receipts per month*",
      regularCashTransfersPerMonth:
        "Regular expected cash deposits and cash withdrawals per month*",
      transfersAbroad:
        "I regularly transfer money abroad or receive regular money transfers from abroad.*",
      country1: "Country 1",
      country2: "Country 2",
      country3: "Country 3",
      country4: "Country 4",
      country5: "Country 5",
      country6: "Country 6",
      countryPlaceholder: "Select country",
    },
    bankOnboardingRedirect: {
      title: "Very good choice! Open a depot now.",
      text: "To open your account, we will redirect you to the website of our partner {{bankName}}. Immediately after entering your data, you will receive access to your new account.",
      btn: "Open a depot with {{bankName}} now",
      fnzBanner:
        "<boldText>Note:</boldText> For processing reasons on the part of the FNZ, it is always mandatory to provide an ISIN for investment portfolios. That is why we automatically enter this in the application form for you. Providing an ISIN does not trigger a purchase as long as no information is provided be made into the amount.",
    },
    mifid: {
      mifidData: {
        title: {
          default: "Please enter your MiFID details",
          partner: "Please enter your partner's MiFID details",
          legalGuardian1: "Please enter first guardian's MiFID details",
          legalGuardian2:
            "Please enter enter the MiFID data of the second legal guardian",
          minor: "Please enter the MiFID data of the minor",
        },
        banner: {
          title:
            'MiFID stands for "Markets in Financial Instruments Directive"',
          text: "The EU directive regulates securities trading across Europe and sets high standards for investor protection. In order to meet the regulatory requirements, we are obliged to provide certain information to ask you.",
        },
        mifidOccupationGroup: "Occupation group",
        mifidOccupation: "Occupation",
        mifidSector: "Sector",
        mifidCountryOfWork: "Country of work",
        mifidAccessToInsiderInfo: "Do you have access to insider information?",
      },
      mifidAdditionalData: {
        DAB: {
          title:
            "Further mandatory information for opening a securities account with DAB",
        },
        FNZ: {
          title:
            "Further mandatory information for opening a securities account with FNZ",
        },
        ebase: {
          title:
            "Further mandatory information for opening a securities account with ebase",
        },
        comdirect: {
          title: "Please enter your expected account turnover (data for MiFID)",
        },
        banner: {
          title: "Why this information?",
          text: "To open a securities account, your bank requires additional information, such as detailed information on the origin of the funds. This information is collected within the framework of the Money Laundering Act (AMLA) and is used to prevent money laundering To meet requirements, we are obliged to request this information from you.",
        },
        mifidAnnualIncome: "Annual income",
        mifidLiquidAssets: "Liquid assets",
        pep: "Are you a politically exposed person?",
        mifidOriginOfIncome: "Origin of income",
        mifidOriginOfAssets: "Origin of assets",
        mifidPlannedAssets: "Planned assets",
        regularIncomePerMonth: "Regular expected cash receipts per month",
        regularIncomePerMonth_placeholder: "No regular cash receipts",
        optionsForRegularIncomePerMonth: {
          0: "No regular cash receipts",
          1: "1 - 1000 Euro",
          1001: "1001 - 2000 Euro",
          2001: "2001 - 3000 Euro",
          3001: "3001 - 4000 Euro",
          4001: "4001 - 5000 Euro",
          5001: "5001 - 6000 Euro",
          6001: "6001 - 8000 Euro",
          8001: "8001 - 13000 Euro",
          13001: "13001 - 25000 Euro",
          25001: "25001 - 80000 Euro",
          80001: "mehr als 80000 Euro",
        },
        regularCashTransfersPerMonth:
          "Regular expected cash deposit and cash withdrawal per month",
        regularCashTransfersPerMonth_placeholder: "No",
        optionsForRegularCashTransfersPerMonth: {
          0: "No",
          1: "1 - 100 Euro",
          101: "101 - 500 Euro",
          501: "501 - 800 Euro",
          801: "801 - 1200 Euro",
          1201: "1201 - 1600 Euro",
          1601: "1601 - 2100 Euro",
          2101: "2101 - 3000 Euro",
          3001: "3001 - 4000 Euro",
          4001: "4001 - 8000 Euro",
          8001: "mehr als 8000 Euro",
        },
        hasRegularInternationalTransfers:
          "I regularly transfer money abroad or receive regular money transfers from abroad",
        internationalTransfersCountry1: "Select country",
        internationalTransfersCountry2: "Select country",
      },
    },
    nationality: {
      title: {
        default: "Please provide your nationality",
        partner: "Please provide your partner's nationality",
        minor: "Please provide the minor's nationality",
        legalGuardian1:
          "Please provide the nationality of the first legal guardian",
        legalGuardian2:
          "Please provide the nationality of the second legal guardian",
      },
      nationalityCountry: "Nationality",
      nationalIdentifier: "National identifier",
      nationalityAnother: "Do you have another nationality?",
      nationalitySecondaryCountry: "Secondary nationality",
      nationalitySecondaryIdentifier:
        "National identifier (secondary nationality)",
    },
    taxation: {
      title: {
        default: "Please enter your tax information",
        partner: "Please enter your partner's tax information",
        minor: "Please enter the minor's tax information",
        legalGuardian1: "Please enter the first guardian's tax information",
        legalGuardian2: "Please enter second guardian's tax information",
      },
      taxationData: {
        taxationCountry1: "Select country",
        taxationCountry2: "Select country",
        taxationNumber1: "Taxation Number",
        taxationOneMore: "Are you liable to pay taxes in another country?",
        taxationNumber2: "Taxation Number",
        taxationUsTaxLiability: "Are you subject to US tax liability?",
        taxationUsTaxNumber: "US TIN /-SSN",
      },
    },
    finalTaxUsNote: {
      title: "Please contact our customer support for further action",
      subtitle:
        "The comdirect bank does not offer a standardized account opening for US taxpayers. We will be happy to support you and show you how to open an account. Please contact us contact our customer support for further action.",
      card: {
        caption: "I am responsible for you",
        title: "Patrick Rujan",
        subtitle: "Customer Support Rentablo",
        subtitle_onvista: "Customer support onvista cashback",
        email: "{{supportEmail}}",
        chat: "chat",
      },
    },
    experience: {
      title: "How experienced are you with investments?",
      subtitle:
        "Please indicate how much investment experience you have in the listed securities. This information is optional",
      lessThanYear: "Less than a year",
      moreThanYear: "More than a year",
      moreThanTwoYears: "More than two years",
      experienceData: {
        experienceCertificatesAndOptionsWithLeverage:
          "Your experience with investment funds (investment company outside the EU)",
        experienceCertificatesAndOptionsWithoutLeverage:
          "Your experience with shares in foreign companies",
        experienceDomesticBonds:
          "Your experience with fixed-income securities from domestic issuers",
        experienceDomesticStocks:
          "Your experience with shares in domestic companies",
        experienceForeignCurrency:
          "Your experience with foreign exchange transactions (not forward)",
        experienceForeignStocks:
          "Your experience with shares in foreign companies",
        experienceFunds:
          "Your experience with investment funds (investment company outside the EU)",
        experienceForeignBonds:
          "Your experience with foreign-issued or foreign-currency fixed-income securities",
        experienceOther:
          "Your experience with other futures transactions, transactions with deferred settlement dates and/or leverage",
      },
    },
    bankSpecificDetails: {
      conditionModel: {
        title: "Please select your fee model",
        subtitle:
          "The fee model applies to transactions <span>on the exchange.</span> <br/> For transactions <span>on the exchange</span>, we recommend:",
        table: {
          description:
            "For transactions <span>through the fund company</span> (referred to as fixed-price business at comdirect), the following order commissions apply:",
          orderVolumeFrom: "Order volume from",
          orderVolumeTo: "Order volume up to",
          orderCommision: "Order commission",
          over: "over",
          bottomText:
            "For more information (e.g., ETF conditions), please refer to our condition table and the price/performance directory of comdirect: <link1>https://www.comdirect.de/faq/preisverzeichnis</link1>.",
        },
        comdirect: {
          standard: {
            subtitle: "For deposits with a volume of up to €8,000 per order",
            title: "Standard",
            feeLabel: "Transaction fee",
            fee: "0.25%",
            feeLimits: "Min. €10, but Max. €90",
          },
          flatfee: {
            subtitle: "For depots with a volume of €8,000 or more per order",
            title: "Flatfee",
            feeLabel: "Transaction fee",
            fee: "€19.95",
            feeLimits: "Flat rate independent on the order size",
          },
        },
        DAB: {
          standard: {
            subtitle: "For securities accounts up to €6,000 volume per order",
            title: "Standard",
            feeLabel: "Percentage transaction fee",
            fee: "0.25%",
            feeLimits: "Min. €10, Max. €75",
          },
          flatfee: {
            subtitle: "For large accounts from €6,000 volume per order",
            title: "Flatfee",
            feeLabel: "Flat transaction fee",
            fee: " €15.00 (plus any commission)",
            feeLimits: "regardless of the order size",
          },
        },
      },
      fondsdepotDepotType: {
        title: "Would you like to open a standard depot or a VL depot?",
        subtitle: "There are following options for you",
        normal: {
          subtitle: "Fondsdepotbank product",
          title: "Standard",
          description: "Multi-fund capable depot",
        },
        vl: {
          subtitle: "Fondsdepotbank product 2",
          title: "VL depot",
          description: "Deposit for capital-forming benefits",
        },
      },
      dabMobileForTan: {
        title: "To which mobile phone number should DAB send its TAN?",
        dabMobileForTan: "Mobile phone number",
      },
      accountIdentifier: {
        comdirectInfo: "Where can I find my customer number?",
        comdirectModalTitle: "Where can I find my comdirect customer number?",
        comdirectModalSubtitle:
          'You can find your customer number in the "Personal area" under the menu item "Administration" -> "My data".',
        dabHint:
          "Note: Your DAB master number consists of the first 7 digits of your account number",
        COBADEHDXXX: {
          title: "Please enter your comdirect customer number",
          accountIdentifier: "Comdirect customer number",
          accountIdentifier_placeholder: "10 digits (0-9)",
          error: "Must consist of 10 digits (0-9)",
        },
        COBADEMXXXX: {
          title: "Number of your existing account",
          accountIdentifier: "Account number",
          accountIdentifier_placeholder: "10-11 digits (0-9)",
          error: "Must consist of 10 or 11 numbers (0-9)",
        },
        DABBDEMMXXX: {
          title: "Your DAB account base number",
          accountIdentifier: "Account base number",
          accountIdentifier_placeholder: "7 digits (0-9)",
          error: "Must consist of 7 digits (0-9)",
        },
        AUGBDE77XXX: {
          title: "Number of your existing account",
          accountIdentifier: "Account number",
          accountIdentifier_placeholder: "10 digits (0-9)",
          error: "Must consist of 10 digits exist (0-9)",
        },
        DEUTDEFFXXX: {
          title: "Number of your existing account",
          accountIdentifier: "Account number",
          accountIdentifier_placeholder: "Letter (A-Z) and 7 digits (0- 9)",
          error: "A letter followed by 7 numbers",
        },
        DEUTLU2DXXX: {
          title: "Number of your existing depot",
          accountIdentifier: "Depot number",
          accountIdentifier_placeholder: "Letter (A-Z) and 7 digits (0-9)",
          error: "A letter followed by 7 numbers",
        },
        FFBKDEFFTHK: {
          title: "Your existing account number",
          accountIdentifier: "Account number",
          accountIdentifier_placeholder: "10 digits (0-9)",
          error: "Must be 10 digits (0-9)",
        },
        FODBDE77XXX: {
          title: "Your existing account number",
          accountIdentifier: "Account number",
          accountIdentifier_placeholder: "9-10 digits (0-9)",
          error: " Must consist of 9 or 10 digits (0-9)",
        },
        METZDEFFXXX: {
          title: "Your existing account number",
          accountIdentifier: "Account number",
          accountIdentifier_placeholder: "10 digits (0-9)",
          error: "Must consist of 10 numbers (0-9)",
        },
        isUsed:
          "This depot or customer number has already been used in another booking.",
      },
    },
    payout: {
      ibanNotFound:
        "Unfortunately we couldn't find a bank for your IBAN. Currently we only support accounts from German, Austrian and Swiss banks.",
      contraAccount: {
        title: "Please enter your reference account for cash transactions",
        banner: {
          title: "Why do we need this?",
          text: "A reference account is a checking account at your bank that is used to process payment transactions. When you buy securities, you transfer money from your reference account to the clearing account in your custody account. Your reference account must be SEPA-enabled and managed in euros.",
        },
        iban: "IBAN",
        formSectionLabel: "Account holder of the reference account",
        contraAccountHolderFirstName: "First name",
        contraAccountHolderFirstName_placeholder:
          "First name of the account holder",
        contraAccountHolderLastName: "Last name",
        contraAccountHolderLastName_placeholder:
          "Last name of the account holder",
      },
      payoutData: {
        title: "Please enter your account for cashback payments",
        banner:
          "Your individual fund cashback will be paid out to the cashback payment account. Billing and payment takes place on a quarterly basis. Due to the billing cycles of the custodian banks, we can only give you two months Pay out your fund cashback after the end of the respective quarter.",
        iban: "IBAN",
        formSectionLabel: "Account holder of the cashback payment account",
        payoutAccountHolderFirstName: "First name",
        payoutAccountHolderFirstName_placeholder:
          "First name of the account holder",
        payoutAccountHolderLastName: "Last name",
        payoutAccountHolderLastName_placeholder:
          "Last name of the account holder",
        company: {
          payoutAccountHolderFirstName: "Company name",
          payoutAccountHolderFirstName_placeholder: "Your company name",
          payoutAccountHolderLastName: "Legal form",
          payoutAccountHolderLastName_placeholder: "Your legal form",
        },
      },
    },
    summary: {
      title: "Summary",
      personalDataTitle: "Personal Data",
      depotManagement: "Depot Management",
      assetManagement: "Authorized Asset Manager",
      portfolioPurchase: "Portfolio Purchase",
      savingsPlan: "Monthly Savings Plan",
      managementFee: "Ongoing Management Fee",
      riskClass: "Risk Class",
      documents: "Documents",
      apply: "Apply for a fee",
      riskClassB: "B",
      riskClassC: "C",
      riskClassD: "D",
      fields: {
        academicTitle: "Title",
        education: "Education",
        salutation: "Salutation",
        occupation: "Occupation",
        fullName: "First and Last Name",
        sector: "Sector",
        dateOfBirth: "Date of Birth",
        placeOfBirth: "Place of Birth",
        address: "Residing in",
        taxationNumber1: "Tax Number (TIN)",
        taxationCountry1: "Tax Resident in",
        nationalityCountry: "Nationality",
        phoneNumber: "Mobile Number",
        email: "Email",
        accountHolderName: "Account Holder",
        maritalStatus: "Marital Status",
        iban: "IBAN",
        isNotPoliticallyExposed: "Not a politically exposed person",
        isOwnAccount: "Beneficial Owner",
      },
      printAndDownload: {
        title: "Complete application via PDF",
        subtitle:
          "Your cashback application has been created and is ready for download",
        editData: "Edit data",
        download: "Download & print application",
        downloadAgain: "Download application again",
        afterDownload: {
          title: "Almost done!",
          subtitle: "The following steps have to be taken",
          actions: {
            printOut: "Please sign printed documents",
            identifyViaRentablo:
              "Enclose a copy of your identity card, passport",
            identifyViaRentablo_subtitle:
              "We will legitimize you in the course of opening a depot. Our staff will contact you after receiving the documents.",
            sendBack: "Send back the documents",
            sendBank_subtitle: "A return form is enclosed",
            birthCertificate: "Enclose a birth certificate",
            birthCertificate_subtitle:
              "Please enclose a copy of the minor's birth certificate. This will be required by the bank when opening an account.",
            postIdent: "Identify via PostIdent",
            postIdent_subtitle:
              "Please identify yourself at the post office using the enclosed PostIdent form",
            allDone: "Everything's done!",
          },
          newDepot: "Add another depot",
          backToOverview: "Back to overview",
        },
        cashbackBonus: {
          title: "Have a coupon code?",
          subtitle:
            "If you have a coupon, the cashback bonus will be offset against the retained commission, increasing your cashback",
          submit: "Save code",
          code: "Voucher code",
          code_placehoder: "Enter voucher code",
          success: "The voucher code was applied successfully",
          alreadyApplied: "Applied successfully",
        },
      },
      companySummary: {
        afterDownload: {
          title: "Great, that's how it goes on!",
          subtitle: "Following schedule",
          banner:
            "If you have not received any feedback from us within the next working day, please send us an email to <strongText>{{supportEmail}}</strongText> or simply call us on <strongText>030 - 71533009.</strongText>",
          bannerForMandators:
            "If you have not received any feedback from us within the next working day, please send us an email to <strongText>{{supportEmail}}</strongText>.",
          actions: {
            dataReceived:
              "We have received your request to open a securities account",
            weWillContactYou: "We will get back to you shortly",
            weWillContactYou_subtitle:
              "Unfortunately, there are frequent changes in the processes of the respective bank when opening a company custody account. One of our employees will therefore contact you shortly with details on how to open a custody account.",
          },
        },
      },
    },
    companyNote: {
      title: "Terms for company depots",
      terms:
        "Company depots are pretty distinct from private customer depots in terms of size and administration effort. For this reason, your cashback will be <strongText>80% overall</strongText> of portfolio commission received by Rentablo.",
      oneClick:
        "On top, you will have free access to the Rentablo One-Click Import to easily manage your portfolio.",
    },
    errorMessageText: {
      title: "Unfortunately, an error occurred while processing your data.",
      subtitle: "Please contact our customer support for further action.",
    },
    rateSupport: {
      professionalism: "Professionalism",
      customerSatisfaction: "Customer Satisfaction",
      customerLoyalty: "Customer Loyalty",
      reviews: "ProvenExpert.com • Determined from {{value}} published reviews",
    },
  },
  impressumPage: {
    title: "Imprint",
    card: {
      title: "Operator of the website:",
      address: "<0>Rentablo GmbH</0>\nFanny-Zobel-Str. 9\n12435 Berlin",
      contacts:
        "Phone: <0>(0) 30 - 71 53 30 09</0>\nEmail: <1>info@rentablo.de</1>\nWeb: <2>https://www.rentablo.de</2>",
      inn: "Commercial register: Berlin Charlottenburg HRB 256105 B\nVAT ID: DE364629593",
      bottom:
        "Management and person responsible for content pursuant to § 55 para. 2 RStV:\n\n<0>Dipl. Btrw. André Rabenstein (CEO), Dr. Wolfram Stacklies (CTO)</0>\nAddress as above",
    },
    mailAddressTitle: "Mailing address",
    companyName: "WealthAPI",
    companyCustomerService: "Customer service",
    mailAddress: "Fanny-Zobel-Straße 9 \n12435 Berlin",
    sendToCustomerService:
      "Please send your Rentablo Cashback documents\n to our customer service",
    section1:
      "<0>Authorization as Account Information Service Provider (AISP)</0> wealthAPI GmbH is a payment service regulated by the Federal Financial Supervisory Authority (BaFin). The official authorization to provide account information services pursuant to §1 para. 1 sentence 2 no. 8 ZAG was granted to wealthAPI by BaFin on 23.08.2019 and can be viewed at <1>https://portal.mvp.bafin.de/database/ZahlInstInfo/zahlinst.do?id=152048</1>.",
    section1_withoutCashback:
      "<0>Authorization as Account Information Service Provider (AISP)</0> wealthAPI GmbH is a payment service regulated by the Federal Financial Supervisory Authority (BaFin). The official authorization to provide account information services pursuant to §1 para. 1 sentence 2 no. 8 ZAG was granted to wealthAPI by BaFin on 23.08.2019 and can be viewed at <1>https://portal.mvp.bafin.de/database/ZahlInstInfo/zahlinst.do?id=152048</1>.",
    section2:
      "<0>License</0> A trade license for activities pursuant to § 34c,d,f para. 1 GewO exists within the Federal Republic of Germany and Austria.",
    section3:
      "<0>Status</0>Real estate broker with license pursuant to § 34 c para. 1 GewO\nInsurance broker with license pursuant to § 34 d para. 1 GewO (Registration number § 34d: D-VXM7-AKOHU-03)\nFinancial investment broker pursuant to § 34f para. 1 GewO (Registration number § 34f: D-F-107-AWW1-16)",
    section4:
      "<0>Scope of the license</0>Units or shares in domestic open-ended investment funds, open-ended EU investment funds, or foreign open-ended investment funds that may be distributed under the Capital Investment Code (§ 34 f para. 1 no. 1 GewO)\n\nUnits or shares in domestic closed-ended investment funds, closed-ended EU investment funds, or foreign closed-ended investment funds that may be distributed under the Capital Investment Code (§ 34 f para. 1 no. 2 GewO)\n\nInvestments within the meaning of § 1 paragraph 2 of the Asset Investment Act (§ 34 f para. 1 no. 3 GewO)",
    section5:
      "<0>The license was granted by the competent licensing and supervisory authority</0><1>Bezirksamt Treptow-Köpenick von Berlin - Ordnungsamt\nZentrale Anlauf- und Beratungsstelle | Ord ZAB 1</1>Salvador-Allende-Str. 80 A/B\n12559 Berlin\n\nTel. +49 30 90297 4629",
    section6: {
      "1": "<0>Joint Registration Office</0><1>Chamber of Industry and Commerce Berlin</1>Fasanenstr. 85\n10623 Berlin\n\nTel.: 030-31510-0\nFax 030-31510-166\n<2>www.berlin.ihk.de</2>",
      "2": "Joint Registration Office within the meaning of § 11 paragraph 1 no. 4 VersVermV\n\nAssociation of German Chambers of Industry and Commerce (DIHK) e. V.\nBreite Straße 29\n10178 Berlin\n\nTel: 0180/6 00 58 50 (20 cents/min from German landlines, max. 60 cents/min from mobile networks)\nRegister lookup: <0>www.vermittlerregister.info</0>",
    },
    section7:
      "<0>Shareholdings</0>There is no direct or indirect shareholding exceeding ten percent in the voting rights or capital of an insurer by the brokerage company/insurance broker.\n\nThere is no direct or indirect shareholding exceeding ten percent in the voting rights or capital of the brokerage company/insurance broker by insurers.",
    section8:
      "<0>Information on dispute resolution</0>Online dispute resolution pursuant to Art. 14 para. 1 ODR Regulation: \nThe European Commission provides a platform for online dispute resolution (ODR), which you can find at <1>ec.europa.eu/consumers/odr</1>. \n\nConsumers have the option of using this platform to settle their disputes. We are willing to participate in out-of-court arbitration proceedings on a case-by-case basis.",
    section9:
      "<0>Arbitration bodies</0>Insurance Ombudsman e.V.\n<1>Postfach 08 06 32, 10006 Berlin</1>\n<2>www.versicherungsombudsmann.de</2>\n\nOmbudsman for Private Health and Long-term Care Insurance\n<3>Postfach 06 02 22, 10052 Berlin</3>\n<4>www.pkv-ombudsmann.de</4>\n\nOmbudsman's Office for Investment Funds of BVI member companies\n<5>Unter den Linden 42, 10052 Berlin</5>\n<6>www.ombudsstelle-investmentfonds.de</6>",
    section10:
      "<0>Complaint handling procedure</0>Complaints should be sent in writing to <1>info@rentablo.de</1>. In urgent cases, complaints can also be submitted via the Rentablo service hotline.\n\nYour complaint will generally be processed by Rentablo customer service. Depending on the type and extent of the issue, it may be forwarded internally. We aim to process your concern within five business days. For matters involving partner banks, we unfortunately have no influence over the bank's processing times.",
    section11:
      "<0>Professional regulations</0>§ 34 d Trade Regulation Act (GewO)\n§§ 59-68 Insurance Contract Act (VVG)\nInsurance Intermediation Regulation (VersVermV)\nThe professional regulations can be viewed and accessed on the website operated by the Federal Ministry of Justice and juris GmbH at <1>www.gesetze-im-internet.de</1>.\n\nMember of the Chamber of Industry and Commerce\n\n<2>Chamber of Industry and Commerce Berlin</2>Fasanenstraße 85\n10623 Berlin",
    section12:
      "<0>Other</0>For all other disputes arising in connection with our activities towards a consumer, you may contact the following officially recognized consumer arbitration body:\n\n<1>General Consumer Arbitration Board (at Zentrum für Schlichtung e.V.)</1>Straßburger Straße 8\n77694 Kehl\nInternet: <2>www.verbraucher-schlichter.de</2>",
    disclaimer: "Liability notice",
    disclaimerText:
      "Despite careful content review, we assume no liability for the content of external links. The operators of the linked pages are solely responsible for their content.",
    liability:
      "Liability for own content, limited liability for third-party content",
    liabilityText:
      "All content on our website has been created with care and to the best of our knowledge. No guarantee is given for the timeliness, completeness, and accuracy of all pages. As a service provider, we are responsible for our own content on the Rentablo pages, but are not obligated to monitor transmitted or stored third-party information. This also includes content published by Rentablo members. Nevertheless, we review all content for which a specific legal violation is brought to our attention. However, we are only liable from the point in time at which we become aware and after a reasonable review period.",
    limited: "Limited liability for external links",
    limitedText:
      'Rentablo pages contain links to third-party websites ("external links"). Rentablo has no influence over their content. For this reason, we assume no liability. The respective information provider of the linked website is responsible for the content and accuracy of the information. This also includes links published by Rentablo members. Nevertheless, we review all links for which a specific legal violation is brought to our attention. However, we are only liable from the point in time at which we become aware and after a reasonable review period.',
    copyright: "Copyright",
    copyrightText:
      "The content published on this website is subject to German copyright law. Any form of reproduction, editing, distribution, and any form of exploitation beyond the limits of copyright law requires the prior written consent of Rentablo. Please contact <0>presse@rentablo.de</0> for permission.",
    privacy: "Data protection",
    privacyText:
      "By visiting our website, information about the access (e.g., date, time, page accessed) and personal data (e.g., IP address) may be stored and processed. For further information on data processing when visiting our websites, please refer to our <0>Privacy Policy</0> \n\nFor the processing of information and personal data during the registration process, we also refer to our <1>Privacy Policy</1>\n\n",
    bottomText:
      "Should the content or presentation of our website violate the rights of third parties or legal provisions, please send us a message via our contact form without a cost note. \n\nWe guarantee that legitimately objected passages will be promptly removed without the need for you to engage a lawyer. Should you initiate a warning letter without prior contact despite this notice, we will reject it in full and, if necessary, file a counterclaim for violation of the aforementioned provisions.",
  },
  impressumPageForMandators: {
    title: "Imprint",
    card: {
      title: "Operator of the website:",
      address:
        "<0>Depotcheck.ai is a brand of wealthAPI GmbH</0>\nFanny-Zobel-Str. 9\n12435 Berlin",
      contacts:
        "Phone: <0>(0) 30 - 57 71 49 38</0> (answering machine only)\nEmail: <1>info@wealthapi.eu</1>\nWeb: <2>https://www.wealthapi.eu</2>",
      inn: "Commercial register: Berlin Charlottenburg HRB 256105 B\nVAT ID: DE364629593",
      bottom:
        "Management and person responsible for content pursuant to § 55 para. 2 RStV:\n\n<0>Dipl. Btrw. André Rabenstein (CEO), Dr. Wolfram Stacklies (CTO)</0>\nAddress as above",
    },
    mailAddressTitle: "Mailing address",
    companyName: "WealthAPI",
    companyCustomerService: "Customer service",
    mailAddress: "Fanny-Zobel-Straße 9 \n12435 Berlin",
    section1:
      "<2>The technical processing of the Rentablo Financial Manager and Cashback is handled by wealthAPI GmbH:</2><0>Authorization as Account Information Service Provider (AISP)</0> wealthAPI GmbH is a payment service regulated by the Federal Financial Supervisory Authority (BaFin). The official authorization to provide account information services pursuant to §1 para. 1 sentence 2 no. 8 ZAG was granted to wealthAPI by BaFin on 23.08.2019 and can be viewed at <1>https://portal.mvp.bafin.de/database/ZahlInstInfo/zahlinst.do?id=152048</1>.",
    section1_withoutCashback:
      "<0>Authorization as Account Information Service Provider (AISP)</0> wealthAPI GmbH is a payment service regulated by the Federal Financial Supervisory Authority (BaFin). The official authorization to provide account information services pursuant to §1 para. 1 sentence 2 no. 8 ZAG was granted to wealthAPI by BaFin on 23.08.2019 and can be viewed at <1>https://portal.mvp.bafin.de/database/ZahlInstInfo/zahlinst.do?id=152048</1>.",
    section2:
      "<0>License</0> A trade license for activities pursuant to § 34c,d,f para. 1 GewO exists within the Federal Republic of Germany and Austria.",
    section3:
      "<0>Status</0>Real estate broker with license pursuant to § 34 c para. 1 GewO\nInsurance broker with license pursuant to § 34 d para. 1 GewO (Registration number § 34d: D-VXM7-AKOHU-03)\nFinancial investment broker pursuant to § 34f para. 1 GewO (Registration number § 34f: D-F-107-AWW1-16)",
    section4:
      "<0>Scope of the license</0>Units or shares in domestic open-ended investment funds, open-ended EU investment funds, or foreign open-ended investment funds that may be distributed under the Capital Investment Code (§ 34 f para. 1 no. 1 GewO)\n\nUnits or shares in domestic closed-ended investment funds, closed-ended EU investment funds, or foreign closed-ended investment funds that may be distributed under the Capital Investment Code (§ 34 f para. 1 no. 2 GewO)\n\nInvestments within the meaning of § 1 paragraph 2 of the Asset Investment Act (§ 34 f para. 1 no. 3 GewO)",
    section5:
      "<0>The license was granted by the competent licensing and supervisory authority</0><1>Bezirksamt Treptow-Köpenick von Berlin - Ordnungsamt\nZentrale Anlauf- und Beratungsstelle | Ord ZAB 1</1>Salvador-Allende-Str. 80 A/B\n12559 Berlin\n\nTel. +49 30 90297 4629",
    section6: {
      "1": "<0>Joint Registration Office</0><1>Chamber of Industry and Commerce Berlin</1>Fasanenstr. 85\n10623 Berlin\n\nTel.: 030-31510-0\nFax 030-31510-166\n<2>www.berlin.ihk.de</2>",
      "2": "Joint Registration Office within the meaning of § 11 paragraph 1 no. 4 VersVermV\n\nAssociation of German Chambers of Industry and Commerce (DIHK) e. V.\nBreite Straße 29\n10178 Berlin\n\nTel: 0180/6 00 58 50 (20 cents/min from German landlines, max. 60 cents/min from mobile networks)\nRegister lookup: <0>www.vermittlerregister.info</0>",
    },
    section7:
      "<0>Shareholdings</0>There is no direct or indirect shareholding exceeding ten percent in the voting rights or capital of an insurer by the brokerage company/insurance broker.\n\nThere is no direct or indirect shareholding exceeding ten percent in the voting rights or capital of the brokerage company/insurance broker by insurers.",
    section8:
      "<0>Information on dispute resolution</0>Online dispute resolution pursuant to Art. 14 para. 1 ODR Regulation: \nThe European Commission provides a platform for online dispute resolution (ODR), which you can find at <1>ec.europa.eu/consumers/odr</1>. \n\nConsumers have the option of using this platform to settle their disputes. We are willing to participate in out-of-court arbitration proceedings on a case-by-case basis.",
    section9:
      "<0>Arbitration bodies</0>Insurance Ombudsman e.V.\n<1>Postfach 08 06 32, 10006 Berlin</1>\n<2>www.versicherungsombudsmann.de</2>\n\nOmbudsman for Private Health and Long-term Care Insurance\n<3>Postfach 06 02 22, 10052 Berlin</3>\n<4>www.pkv-ombudsmann.de</4>\n\nOmbudsman's Office for Investment Funds of BVI member companies\n<5>Unter den Linden 42, 10052 Berlin</5>\n<6>www.ombudsstelle-investmentfonds.de</6>",
    section10:
      "<0>Complaint handling procedure</0>Complaints should be sent in writing to <1>info@wealthapi.eu</1>. In urgent cases, complaints can also be submitted via the wealthAPI service hotline.\n\nYour complaint will generally be processed by wealthAPI customer service. Depending on the type and extent of the issue, it may be forwarded internally. We aim to process your concern within five business days. For matters involving partner banks, we unfortunately have no influence over the bank's processing times.",
    section11:
      "<0>Professional regulations</0>§ 34 d Trade Regulation Act (GewO)\n§§ 59-68 Insurance Contract Act (VVG)\nInsurance Intermediation Regulation (VersVermV)\nThe professional regulations can be viewed and accessed on the website operated by the Federal Ministry of Justice and juris GmbH at <1>www.gesetze-im-internet.de</1>.\n\nMember of the Chamber of Industry and Commerce\n\n<2>Chamber of Industry and Commerce Berlin</2>Fasanenstraße 85\n10623 Berlin",
    section12:
      "<0>Other</0>For all other disputes arising in connection with our activities towards a consumer, you may contact the following officially recognized consumer arbitration body:\n\n<1>General Consumer Arbitration Board (at Zentrum für Schlichtung e.V.)</1>Straßburger Straße 8\n77694 Kehl\nInternet: <2>www.verbraucher-schlichter.de</2>",
    disclaimer: "Liability notice",
    disclaimerText:
      "Despite careful content review, we assume no liability for the content of external links. The operators of the linked pages are solely responsible for their content.",
    liability:
      "Liability for own content, limited liability for third-party content",
    liabilityText:
      "All content on our website has been created with care and to the best of our knowledge. No guarantee is given for the timeliness, completeness, and accuracy of all pages. As a service provider, we are responsible for our own content on the wealthAPI pages, but are not obligated to monitor transmitted or stored third-party information. This also includes content published by wealthAPI members. Nevertheless, we review all content for which a specific legal violation is brought to our attention. However, we are only liable from the point in time at which we become aware and after a reasonable review period.",
    limited: "Limited liability for external links",
    limitedText:
      'wealthAPI pages contain links to third-party websites ("external links"). wealthAPI has no influence over their content. For this reason, we assume no liability. The respective information provider of the linked website is responsible for the content and accuracy of the information. This also includes links published by wealthAPI members. Nevertheless, we review all links for which a specific legal violation is brought to our attention. However, we are only liable from the point in time at which we become aware and after a reasonable review period.',
    copyright: "Copyright",
    copyrightText:
      "The content published on this website is subject to German copyright law. Any form of reproduction, editing, distribution, and any form of exploitation beyond the limits of copyright law requires the prior written consent of wealthAPI. Please contact <0>presse@wealthapi.eu</0> for permission.",
    privacy: "Data protection",
    privacyText:
      "By visiting our website, information about the access (e.g., date, time, page accessed) and personal data (e.g., IP address) may be stored and processed. For further information on data processing when visiting our websites, please refer to our <0>Privacy Policy</0> \n\nFor the processing of information and personal data during the registration process, we also refer to our <1>Privacy Policy</1>\n\n",
    bottomText:
      "Should the content or presentation of our website violate the rights of third parties or legal provisions, please send us a message via our contact form without a cost note. \n\nWe guarantee that legitimately objected passages will be promptly removed without the need for you to engage a lawyer. Should you initiate a warning letter without prior contact despite this notice, we will reject it in full and, if necessary, file a counterclaim for violation of the aforementioned provisions.",
  },
  privacyPage: {
    title: "Privacy Policy",
    subtitle: "For Rentablo GmbH (hereinafter referred to as Rentablo).",
    card: {
      "1": "Your financial data is safe with us.",
      "2": "Our privacy policy excludes the sale of your data to third parties",
    },
    "1": {
      title: "1. Data Protection",
      text: "(1) Data Protection Officer / Person Responsible for IT Security:\n\nFor data protection related inquiries, the customer may contact the appointed Data Protection Officer:\nMr. Wolfram Stacklies, <0>(0) 30 - 71 53 30 09</0> or <1>datenschutz@rentablo.de</1>\n\n(2) We attach great importance to ensuring that you feel safe and comfortable when visiting our online services. On this page, we inform you about how we handle your data. Rentablo treats your data with absolute confidentiality. No data is shared with third parties for marketing purposes.\n\n(3) Please note that our pages may also contain hyperlinks to other providers, cooperation partners, and advertisements leading to external websites, which are subject to their own privacy policies.\n\n(4) Users of Rentablo have the option to share the composition of their managed portfolios (in the form of a watchlist; without specifying amounts) or watchlists with other users of this site. Each user can decide for themselves which data they wish to share with whom. This permission can be revoked by the user at any time.\n<2>By default, this data is not visible.</2>\n\n(5) Rentablo will always respect user decisions and will never publish investment data without the explicit consent of the user.",
    },
    "2": {
      title: "2. Collection and Use of Data",
      text: "<0>a) Information collected by us</0> We collect information to provide better services to all our users.\n\nPersonal data, as defined by the Federal Data Protection Act, refers to information that can be used to draw conclusions about your person and your personal or factual circumstances.\n\nWhen you visit Rentablo's websites, data such as your IP address or the date of access is temporarily stored.\n\nAdditional personal data such as your name, address, or email address is only collected if you provide it voluntarily, for example as part of the registration process.\n\n<1>b) Use of data</1> Your data is generally only used to the extent necessary for the operation of our online services and the user relationship, or as otherwise permitted by law.\n\nRentablo uses the data collected through its services for the provision, maintenance, protection, and improvement of its services, for the development of new services, and for the protection of its users. Rentablo also uses this data to offer you tailored content. For this purpose, Rentablo aggregates data and creates anonymized analyses, e.g., to enable peer group comparisons.\n\nRentablo will only process and use your personal data for marketing purposes, such as sending emails with general information or promotional content (e.g., newsletters), if you have previously given your explicit separate consent. You have the option to unsubscribe from such information at any time.\n\nWe will log your consent to data collection and storage. If needed, we will inform you when and how you gave your consent. If you do not give your consent, we ask for your understanding that you will not be able to use our services.\n\nFurthermore, Rentablo will only collect, process, or use data insofar as this is necessary in individual cases where there are factual indications to uncover fraudulent or other unlawful or contractually prohibited behavior on Rentablo's websites. For this purpose, Rentablo may also collect, process, and use usage data, including through the use of cookies.\n\n<2>c) Disclosure of data</2> Rentablo will only transmit your name and contact details such as your email address to other users registered with Rentablo or Rentablo cooperation partners if you have initiated this yourself as part of an invitation, a request for quotation, or an order.\n\nAs a registered user, the username you have chosen is generally accessible to all visitors on all Rentablo websites.\n\nRentablo uses specialized third-party providers to deliver its services. These include, for example, email services and banking interfaces. Rentablo shares user data with these service providers solely for the purpose of service delivery. Sharing for marketing purposes is excluded.\n\nBeyond this, Rentablo will only transmit your personal data to third parties within the framework of legal provisions, in particular to law enforcement and supervisory authorities for the prevention of threats to state and public security, for the prosecution of criminal offenses, or where this is necessary to protect the legitimate interests of a third party.",
    },
    "3": {
      title: "3. External Service Providers",
      text: "Rentablo uses external service providers to fulfill its tasks. In particular, as essential processes of data processing, IT infrastructure, and specialized customer-specific applications are affected, contractual arrangements are documented in writing with the service providers.\n\nRentablo requires all external service providers to maintain data confidentiality and secrecy. The service provider serves a supporting function, providing instruction-bound support to the client in one or more phases of data collection, processing, or use. It does not assume a task in its entirety, but only its technical execution.\n\nRentablo currently uses the following service companies in connection with data processing:\n\n<0>Google Ireland Limited</0>Gordon House, Barrow Street, Dublin 4, Ireland (Hosting in the Google Datacenter Frankfurt. Buildings and infrastructure are subject to 24/7 monitoring, security areas are additionally video-monitored. Multi-factor authentication ensures highly reliable access control.)\n\n<1>Mailchimp</1>The Rocket Science Group, LLC, 675 Ponce de Leon Ave NE, Suite 5000, Atlanta, GA 30308 USA (Mailing portal for Rentablo Newsletter)\n\n<2>wildbit LLC</2>225 Chestnut St., Philadelphia, PA, 19106 (Mailing provider for transactional email communication)\n\n<3>finAPI GmbH</3>Adams-Lehmann-Straße 44, 80797 München, Deutschland (Banking interfaces and intermediate storage of account information data)\n\n<4>Netfonds AG</4><5>Heidenkampsweg 73, 20097 Hamburg, Deutschland (Management of portfolios administered via Rentablo Cashback; in this context, storage of customer and transaction data on Netfonds AG servers)</5>",
    },
    "4": {
      title: "4. Cookies",
      text: 'Rentablo stores information in the form of so-called cookies on your system. These are used to identify your current or past user session.\n\nIn addition, we use third-party web analytics tools (e.g., Google Analytics, Hotjar, and comparable web analytics services) for the demand-oriented design of web offerings. The web analytics services also use cookies for this purpose.\n\nThe evaluation and processing of this data takes place both in EU member states and in non-EU states (e.g., Google Analytics in the USA).\n\nThe web analytics services will use the transmitted information to evaluate your use of the website, to compile reports on website activities for us, and to provide further services related to website and internet use. The web analytics services may also transfer this information to third parties where required by law or where third parties process this data on behalf of the web analytics services. Under no circumstances will the web analytics services associate your IP address with other data held by the web analytics services. We only receive evaluations without personal reference. IP addresses are stored exclusively in anonymized form.\n\nFor more information about Google Inc. and Google Analytics, please visit: (<0>https://www.google.com</0>). Google\'s privacy policy can be found at: <1>https://www.google.com/intl/de/policies/privacy/</1>. To learn how to prevent tracking by Google Analytics, please click the following link: <2>https://tools.google.com/dlpage/gaoptout?hl=de</2>.\n\nIntegration and use of Facebook and Twitter plugins\nWe use technologies of the social network facebook.com (including plugins, Facebook Pixel) in certain areas of our websites. Facebook.com is a service of Facebook Inc., 1601 S. California Ave, Palo Alto, CA 94304, USA. If you visit one of our websites that has integrated a Facebook plugin, a connection to Facebook\'s servers is established. Only through the resulting notification to your browser is the plugin displayed on our respective website.\n\nWe hereby expressly inform you that through the detection of your browser, information about which of our web pages you have visited is automatically transmitted to Facebook\'s servers.\n\nIf you are also logged in as a member of Facebook at the same time, Facebook associates this information with your personal Facebook user account. The same applies to the use of plugin functions, e.g., by clicking the "Like" button. This information is also associated with your Facebook user account. You can prevent this by logging out of Facebook before using our websites.\n\nThe Facebook Pixel is JavaScript code that transmits data to Facebook (including HTTP header information such as IP address, web browser information, page storage location, document, website URL, and web browser user agent, as well as date and time of use).\n\nIn addition, pixel-specific data such as the pixel ID and Facebook cookie data, including your Facebook ID, are transmitted (this data is used to link events to a specific Facebook advertising account and to associate them with a Facebook user).\n\nIf you wish to object to the use of Facebook Pixel, you can set an opt-out cookie on Facebook or disable JavaScript in your browser.\n\nComprehensive information about the collection, storage, and use of your data by Facebook, the exercise of your rights in this regard, and the protection of your privacy can be found in Facebook\'s privacy policies <3>https://de-de.facebook.com/policy.php</3> and the privacy guide <4>https://de-de.facebook.com/privacy/explanation.php</4>.\n\nWe use functions of the Twitter service on this website, a service of Twitter Inc., 1355 Market Street, Suite 900, San Francisco, CA 94103, USA ("Twitter"). By using Twitter and the "Re-Tweet" function, the websites you visit are linked to your Twitter account and made known to other users. Data is also transferred to Twitter.\n\nWe point out that as the provider of the pages, we have no knowledge of the content of the transmitted data or its use by Twitter. For more information, please refer to Twitter\'s privacy policy: twitter.com/privacy.\n\nYou can change your privacy settings on Twitter in the account settings at twitter.com/account/settings.',
    },
    "5": {
      title: "5. Hotjar",
      text: "This website uses Hotjar. The provider is Hotjar Ltd., Level 2, St Julians Business Centre, 3, Elia Zammit Street, St Julians STJ 1000, Malta, Europe (Website: <0>https://www.hotjar.com</0>). We have concluded a data processing agreement with Hotjar to implement the strict European data protection regulations.\n\nHotjar is a tool for analyzing your user behavior on our website. With Hotjar, we can record your mouse and scroll movements and clicks, among other things. Hotjar can also determine how long you remained with the mouse pointer at a particular position. From this information, Hotjar creates so-called heatmaps that can be used to determine which areas of the website are preferred by the visitor.\n\nFurthermore, we can determine how long you stayed on a page and when you left it. We can also determine at which point you abandoned your entries in a contact form (so-called conversion funnels). In addition, direct feedback from website visitors can be obtained through Hotjar. This function serves to improve the website operator's web offerings.\n\nThe use of Hotjar and the storage of Hotjar cookies is based on Art. 6 para. 1 lit. f GDPR. The website operator has a legitimate interest in analyzing user behavior to optimize both its web offerings and its advertising.<1>Deactivating Hotjar</1>If you wish to deactivate data collection by Hotjar, please click on the following link and follow the instructions there: <2>https://www.hotjar.com/opt-out</2>.\n\nPlease note that Hotjar must be deactivated separately for each browser or end device. For more information about Hotjar and the data collected, please refer to Hotjar's privacy policy at the following link: <3>https://www.hotjar.com/privacy</3>.<4>Interest-based advertising</4>Interest-based advertising may be used on our website. For this purpose, Rentablo uses user profiles from the Google Content advertising network or its own anonymized user data.<5>Paid services</5>We offer you paid services or the paid ordering of products or services<7>; such as Rentablo Cashback</7>. For this, you may need to provide additional data depending on the respective service (e.g., a delivery address or payment details). In this case, Rentablo logs additional usage data to provide the service and to protect your interests and the interests of legitimate third parties.<6>Deletion and modification of your data</6>You can request information about your data stored with us, as well as correction, blocking, and deletion at any time. All ways to contact Rentablo can be found in the Imprint.\n\nChanges to this privacy policy\nRentablo will notify you at an appropriate place when this privacy policy is changed.",
    },
    "6": {
      title: "6. Security",
      text: "Rentablo protects your data from unauthorized access by third parties within the scope of the respective technical capabilities. The validity of this privacy policy is limited to our websites. This privacy policy does not extend to links to other companies. We employ extensive technical and organizational security measures to protect your personal data from deliberate manipulation, loss, or access by unauthorized third parties. These are continuously improved in accordance with applicable data protection laws and technological developments. Nevertheless, we would like to point out that despite our security measures, information that you voluntarily share over the internet may be used by others. We cannot assume liability for data transmission errors or unauthorized access to your data by third parties.",
    },
    "7": {
      title: "7. Consent and Revocation",
      text: "By registering with Rentablo, you consent to this privacy policy. You may revoke your declaration of consent at any time with effect for the future.",
    },
    "8": {
      title: "8. Contact & Right to Information",
      text: "For further questions or suggestions regarding data protection, please contact us. You can also obtain information about the data we have stored about you at any time. In our public register of procedures, we have summarized the information pursuant to § 4g BDSG. If needed, please write to:\n\n<0>Rentablo GmbH, Fanny-Zobel-Str. 9, 12435 Berlin or </0><1>info@rentablo.de</1>\n\nAs of: 15.09.2025",
    },
  },
  privacyPageForMandators: {
    title: "Privacy Policy",
    subtitle:
      "For Depotcheck.ai, a brand of wealthAPI GmbH (hereinafter referred to as Depotcheck)",
    card: {
      "1": "Your financial data is safe with us.",
      "2": "Our privacy policy excludes the sale of your data to third parties",
    },
    "1": {
      title: "1. Data Protection",
      text: "(1) Data Protection Officer / Person Responsible for IT Security:\n\nFor data protection related inquiries, the customer may contact the appointed Data Protection Officer:\nMr. Wolfram Stacklies, <1>datenschutz@wealthapi.eu</1>.\n\n(2) We attach great importance to ensuring that you feel safe and comfortable when visiting our online services. On this page, we inform you about how we handle your data. Depotcheck treats your data with absolute confidentiality. No data is shared with third parties for marketing purposes.\n\n(3) Please note that our pages may also contain hyperlinks to other providers, cooperation partners, and advertisements leading to external websites, which are subject to their own privacy policies.\n\n(4) Users of Depotcheck have the option to share the composition of their managed portfolios (in the form of a watchlist; without specifying amounts) or watchlists with other users of this site. Each user can decide for themselves which data they wish to share with whom. This permission can be revoked by the user at any time.\n<2>By default, this data is not visible.</2>\n\n(5) Depotcheck will always respect user decisions and will never publish investment data without the explicit consent of the user.",
    },
    "2": {
      title: "2. Collection and Use of Data",
      text: "<0>a) Information collected by us</0> We collect information to provide better services to all our users.\n\nPersonal data, as defined by the Federal Data Protection Act, refers to information that can be used to draw conclusions about your person and your personal or factual circumstances.\n\nWhen you visit Depotcheck's websites, data such as your IP address or the date of access is temporarily stored.\n\nAdditional personal data such as your name, address, or email address is only collected if you provide it voluntarily, for example as part of the registration process.\n\n<1>b) Use of data</1> Your data is generally only used to the extent necessary for the operation of our online services and the user relationship, or as otherwise permitted by law.\n\nDepotcheck uses the data collected through its services for the provision, maintenance, protection, and improvement of its services, for the development of new services, and for the protection of its users. Depotcheck also uses this data to offer you tailored content. For this purpose, Depotcheck aggregates data and creates anonymized analyses, e.g., to enable peer group comparisons.\n\nDepotcheck will only process and use your personal data for marketing purposes, such as sending emails with general information or promotional content (e.g., newsletters), if you have previously given your explicit separate consent. You have the option to unsubscribe from such information at any time.\n\nWe will log your consent to data collection and storage. If needed, we will inform you when and how you gave your consent. If you do not give your consent, we ask for your understanding that you will not be able to use our services.\n\nFurthermore, Depotcheck will only collect, process, or use data insofar as this is necessary in individual cases where there are factual indications to uncover fraudulent or other unlawful or contractually prohibited behavior on Depotcheck's websites. For this purpose, Depotcheck may also collect, process, and use usage data, including through the use of cookies.\n\n<2>c) Disclosure of data</2> Depotcheck will only transmit your name and contact details such as your email address to other users registered with Depotcheck or Depotcheck cooperation partners if you have initiated this yourself as part of an invitation, a request for quotation, or an order.\n\nAs a registered user, the username you have chosen is generally accessible to all visitors on all Depotcheck websites.\n\nDepotcheck uses specialized third-party providers to deliver its services. These include, for example, email services and banking interfaces. Depotcheck shares user data with these service providers solely for the purpose of service delivery. Sharing for marketing purposes is excluded.\n\nBeyond this, Depotcheck will only transmit your personal data to third parties within the framework of legal provisions, in particular to law enforcement and supervisory authorities for the prevention of threats to state and public security, for the prosecution of criminal offenses, or where this is necessary to protect the legitimate interests of a third party.",
    },
    "3": {
      title: "3. External Service Providers",
      text: "Depotcheck uses external service providers to fulfill its tasks. In particular, as essential processes of data processing, IT infrastructure, and specialized customer-specific applications are affected, contractual arrangements are documented in writing with the service providers.\n\nDepotcheck requires all external service providers to maintain data confidentiality and secrecy. The service provider serves a supporting function, providing instruction-bound support to the client in one or more phases of data collection, processing, or use. It does not assume a task in its entirety, but only its technical execution.\n\nDepotcheck currently uses the following service companies in connection with data processing:\n\n<0>Google Ireland Limited</0>Gordon House, Barrow Street, Dublin 4, Ireland (Hosting in the Google Datacenter Frankfurt. Buildings and infrastructure are subject to 24/7 monitoring, security areas are additionally video-monitored. Multi-factor authentication ensures highly reliable access control.)\n\n<1>Mailchimp</1>The Rocket Science Group, LLC, 675 Ponce de Leon Ave NE, Suite 5000, Atlanta, GA 30308 USA (Mailing portal for Depotcheck Newsletter)\n\n<2>wildbit LLC</2>225 Chestnut St., Philadelphia, PA, 19106 (Mailing provider for transactional email communication)\n\n<3>finAPI GmbH</3>Adams-Lehmann-Straße 44, 80797 München, Deutschland (Banking interfaces and intermediate storage of account information data)\n\n<4>Netfonds AG</4><5>Heidenkampsweg 73, 20097 Hamburg, Deutschland (Management of portfolios administered via Rentablo Cashback; in this context, storage of customer and transaction data on Netfonds AG servers)</5>",
    },
    "4": {
      title: "4. Cookies",
      text: 'Depotcheck stores information in the form of so-called cookies on your system. These are used to identify your current or past user session.\n\nIn addition, we use third-party web analytics tools (e.g., Google Analytics, Hotjar, and comparable web analytics services) for the demand-oriented design of web offerings. The web analytics services also use cookies for this purpose.\n\nThe evaluation and processing of this data takes place both in EU member states and in non-EU states (e.g., Google Analytics in the USA).\n\nThe web analytics services will use the transmitted information to evaluate your use of the website, to compile reports on website activities for us, and to provide further services related to website and internet use. The web analytics services may also transfer this information to third parties where required by law or where third parties process this data on behalf of the web analytics services. Under no circumstances will the web analytics services associate your IP address with other data held by the web analytics services. We only receive evaluations without personal reference. IP addresses are stored exclusively in anonymized form.\n\nFor more information about Google Inc. and Google Analytics, please visit: (<0>https://www.google.com</0>). Google\'s privacy policy can be found at: <1>https://www.google.com/intl/de/policies/privacy/</1>. To learn how to prevent tracking by Google Analytics, please click the following link: <2>https://tools.google.com/dlpage/gaoptout?hl=de</2>.\n\nIntegration and use of Facebook and Twitter plugins\nWe use plugins of the social network facebook.com in certain areas of our websites. Facebook.com is a service of Facebook Inc., 1601 S. California Ave, Palo Alto, CA 94304, USA. If you visit one of our websites that has integrated a Facebook plugin, a connection to Facebook\'s servers is established. Only through the resulting notification to your browser is the plugin displayed on our respective website.\n\nWe hereby expressly inform you that through the detection of your browser, information about which of our web pages you have visited is automatically transmitted to Facebook\'s servers.\n\nIf you are also logged in as a member of Facebook at the same time, Facebook associates this information with your personal Facebook user account. The same applies to the use of plugin functions, e.g., by clicking the "Like" button. This information is also associated with your Facebook user account. You can prevent this by logging out of Facebook before using our websites.\n\nComprehensive information about the collection, storage, and use of your data by Facebook, the exercise of your rights in this regard, and the protection of your privacy can be found in Facebook\'s privacy policies <3>https://de-de.facebook.com/policy.php</3> and the privacy guide <4>https://de-de.facebook.com/privacy/explanation.php</4>.\n\nWe use functions of the Twitter service on this website, a service of Twitter Inc., 1355 Market Street, Suite 900, San Francisco, CA 94103, USA ("Twitter"). By using Twitter and the "Re-Tweet" function, the websites you visit are linked to your Twitter account and made known to other users. Data is also transferred to Twitter.\n\nWe point out that as the provider of the pages, we have no knowledge of the content of the transmitted data or its use by Twitter. For more information, please refer to Twitter\'s privacy policy: twitter.com/privacy.\n\nYou can change your privacy settings on Twitter in the account settings at twitter.com/account/settings.',
    },
    "5": {
      title: "5. Hotjar",
      text: "This website uses Hotjar. The provider is Hotjar Ltd., Level 2, St Julians Business Centre, 3, Elia Zammit Street, St Julians STJ 1000, Malta, Europe (Website: <0>https://www.hotjar.com</0>). We have concluded a data processing agreement with Hotjar to implement the strict European data protection regulations.\n\nHotjar is a tool for analyzing your user behavior on our website. With Hotjar, we can record your mouse and scroll movements and clicks, among other things. Hotjar can also determine how long you remained with the mouse pointer at a particular position. From this information, Hotjar creates so-called heatmaps that can be used to determine which areas of the website are preferred by the visitor.\n\nFurthermore, we can determine how long you stayed on a page and when you left it. We can also determine at which point you abandoned your entries in a contact form (so-called conversion funnels). In addition, direct feedback from website visitors can be obtained through Hotjar. This function serves to improve the website operator's web offerings.\n\nThe use of Hotjar and the storage of Hotjar cookies is based on Art. 6 para. 1 lit. f GDPR. The website operator has a legitimate interest in analyzing user behavior to optimize both its web offerings and its advertising.<1>Deactivating Hotjar</1>If you wish to deactivate data collection by Hotjar, please click on the following link and follow the instructions there: <2>https://www.hotjar.com/opt-out</2>.\n\nPlease note that Hotjar must be deactivated separately for each browser or end device. For more information about Hotjar and the data collected, please refer to Hotjar's privacy policy at the following link: <3>https://www.hotjar.com/privacy</3>.<4>Interest-based advertising</4>Interest-based advertising may be used on our website. For this purpose, Depotcheck uses user profiles from the Google Content advertising network or its own anonymized user data.<5>Paid services</5>We offer you paid services or the paid ordering of products or services<7>; such as Rentablo Cashback</7>. For this, you may need to provide additional data depending on the respective service (e.g., a delivery address or payment details). In this case, Depotcheck logs additional usage data to provide the service and to protect your interests and the interests of legitimate third parties.<6>Deletion and modification of your data</6>You can request information about your data stored with us, as well as correction, blocking, and deletion at any time. All ways to contact Depotcheck can be found in the Imprint.\n\nChanges to this privacy policy\nDepotcheck will notify you at an appropriate place when this privacy policy is changed.",
    },
    "6": {
      title: "6. Security",
      text: "Depotcheck protects your data from unauthorized access by third parties within the scope of the respective technical capabilities. The validity of this privacy policy is limited to our websites. This privacy policy does not extend to links to other companies. We employ extensive technical and organizational security measures to protect your personal data from deliberate manipulation, loss, or access by unauthorized third parties. These are continuously improved in accordance with applicable data protection laws and technological developments. Nevertheless, we would like to point out that despite our security measures, information that you voluntarily share over the internet may be used by others. We cannot assume liability for data transmission errors or unauthorized access to your data by third parties.",
    },
    "7": {
      title: "7. Consent and Revocation",
      text: "By registering with Depotcheck, you consent to this privacy policy. You may revoke your declaration of consent at any time with effect for the future.",
    },
    "8": {
      title: "8. Contact & Right to Information",
      text: "For further questions or suggestions regarding data protection, please contact us. You can also obtain information about the data we have stored about you at any time. In our public register of procedures, we have summarized the information pursuant to § 4g BDSG. If needed, please write to:\n\n<0>wealthAPI GmbH, Fanny-Zobel-Str. 9, 12435 Berlin or </0><1>info@wealthapi.eu</1>\n\nAs of: 15.09.2025",
    },
  },
  redesign: {
    header: {
      actions: {
        fundDiscount: "Fund Discount",
        yourDiscount: "Your benefits",
        depotManagerApp: "Depot Manager App",
        aboutUs: "About us",
        knowledge: "knowledge",
        login: "login",
        becomeCustomer: "Become a customer",
        inApp: "Home",
        cashback: "Request cashback",
        faqs: "FAQs",
        forum: "forum",
        blog: "blog",
        support: "support",
      },
    },
    footer: {
      copyright: "A trademark of wealthAPI GmbH",
      column1: {
        title: "Company",
        items: [
          {
            href: "https://rentablo.de/aboutUs",
            title: "About us",
          },
          {
            href: "https://rentablo.de/jobs",
            title: "Jobs & Careers",
          },
          {
            href: "https://www.financequality.net/partnerprogramme/rentablo-fond-cashback/",
            title: "Affiliate Program",
          },
          {
            href: "https://rentablo.de/Sicherheit",
            title: "Security",
          },
          {
            href: "https://wealthapi.eu",
            title: "Business Customers",
          },
        ],
      },
      column2: {
        title: "Features",
        items: [
          {
            href: "https://rentablo.de/software-depotverwaltung",
            title: "Software Depot Management",
          },
          {
            href: "https://rentablo.de/portfolio-performance",
            title: "Portfolio Performance",
          },
          {
            href: "https://rentablo.de/portfolio-optimization",
            title: "Portfolio Optimization",
          },
          {
            href: "https://rentablo.de/kostenloser-finanzmanager-online",
            title: "Free Portfolio Manager",
          },
          {
            href: "https://rentablo.de/elektronisches-budget",
            title: "Electronic Household Book",
          },
        ],
      },
      column3: {
        title: "Knowledge & Financial Tools",
        items: [
          {
            href: "https://forum.rentablo.de/",
            title: "Forum & FAQ",
          },
          {
            href: "https://blog.rentablo.de/",
            title: "Financial Blog",
          },
          {
            href: "https://rentablo.de#cashback-calculator",
            title: "Fund Discount Calculator",
          },
          {
            href: "https://rentablo.de/investment/popularFunds",
            title: "Popular Funds",
          },
        ],
      },
      column4: {
        title: "Financial Tools & Knowledge",
        items: [
          {
            href: "https://forum.rentablo.de/",
            title: "Forum & FAQ",
          },
          {
            href: "https://blog.rentablo.de/",
            title: "Financial Blog",
          },
          {
            href: "https://rentablo.de/kostenloser-finanzmanager-online",
            title: "Free Portfolio Manager",
          },
          {
            href: "https://rentablo.de/elektronisches-budget",
            title: "Electronic Household Book",
          },
          {
            href: "https://blog.rentablo.de/vergleichsrechner-und-finanztools/",
            title: "Comparison Calculator",
          },
        ],
      },
      subFooterItems: [
        {
          href: "impressum",
          title: "Imprint",
        },
        {
          href: "privacy",
          title: "Privacy Policy",
        },
        {
          href: "agb",
          title: "Terms and Conditions",
        },
        {
          href: "disclaimer",
          title: "Disclaimer",
        },
      ],
    },
  },
  addToDepot: "Add to Depot",
  addToWatchlist: "Add to Watchlist",
  showMore: "show more",
  supportCard: {
    caption: "I am responsible for you",
    title: "Patrick Rujan",
    subtitle: "Customer Support Rentablo",
  },
  bankSelect: {
    pageTitle: "Import portfolios/accounts",
    title: "Please select your bank.",
    searchLabel: "Search: name, IBAN, bank code, BIC",
    selectBic: {
      title:
        "Please select the BIC (Bank Identifier Code). This is an 8- or 11-character code that uniquely identifies financial institutions worldwide.",
      back: "Back",
    },
    notFound: "Bank not found.",
    notSupported: "The bank is currently not supported.",
  },
  netfondsOnboarding: {
    next: "Save and continue",
    sidebar: {
      main: "Onboarding",
      preferences: "Investment goals and preferences",
      sustainability: "Sustainability",
      details: "Selection and dynamic simulation strategy",
      signup: "Registration",
      experience: "Knowledge & Experience",
      incomeAssets: "Financial Circumstances",
      personal: "Personal data",
      agreements: "Agreements",
      summary: "Summary",
    },
    investmentGoal: {
      title: "What is your investment objective?",
      valueRetention: "Maintaining value at capital market interest rates",
      longTermInvestment: "Long-term asset accumulation",
      shortTermProfit: "Short-term intention to make a profit",
      additionalIncome:
        "Achieving additional income while accepting higher risks",
    },
    investmentHorizon: {
      title: "How long do you want to invest?",
      shortTerm: "0-3 years",
      midTerm: "3-5 years",
      longTerm: "> 5 years",
    },
    preferredRiskClass: {
      title: " Please indicate your risk tolerance",
      riskClassB: "Return - risk class B",
      riskClassB_subtitle:
        "You only have a <b>low expectation of return</b>. Maintaining the value of the entire portfolio is your priority. You therefore only want <b> low risks</b> due to market fluctuations (e.g. price, interest rate and currency fluctuations) and only take a low risk of loss for the entire portfolio. <b>Risk tolerance - 5%</b> after costs.",
      riskClassC: "Balanced - Risk class C",
      riskClassC_subtitle:
        "You have a <b>moderate expected return</b>. In addition to interest income, income from price increases is also sought. In return, you accept <b>moderate risks</b> due to market fluctuations (e.g. price, interest rate and currency fluctuations) and moderate risks of loss for the entire portfolio. <b>Risk tolerance - 30%</b> after costs.",
      riskClassD: "Growth - risk class D",
      riskClassD_subtitle:
        "You expect <b>higher returns</b> that are above the capital market interest rate level for as long as possible. In return, you accept <b>higher risks</b> due to market fluctuations (e.g. price, interest rate and currency fluctuations) and higher risks of loss for the entire portfolio. <b>Risk tolerance - 50%</b> after cost.",
    },
    sustainabilityPreference: {
      title: "Choose sustainability preferences",
      important: "Yes, sustainable investments are important to me",
      notImportant: "No, sustainable investments are not important to me",
      notSure: "I am still undecided, not at the moment",
    },
    sustainabilityFactors: {
      title: "Which other sustainability factors are important to you?",
      climateProtection:
        "Climate protection, adaptation to climate change (taxonomy)",
      climateProtection_tooltipTitle: "EU taxonomy",
      climateProtection_tooltipText:
        "Classification system for sustainable economic activities within the EU with currently 6 Focus on environmental goals. Requirement: A company must make a contribution to at least one environmental goal and not violate the other environmental goals and comply with the minimum requirements in the areas of governance, human and employee rights. The proportion of ecologically sustainable investments in the sense of the taxonomy regulation is expressed in percent with values of 0 to 100. The higher the value, the more positive it is in the sense of ecologically sustainable.",
      unSustainableDevelopmentGoals:
        "UN Sustainable Development Goals (Disclosure)",
      unSustainableDevelopmentGoals_tooltipTitle:
        "UN Sustainable Development Goals (Disclosure)",
      unSustainableDevelopmentGoals_tooltipText:
        "Rating , the extent to which companies use opportunities to achieve the 17 Sustainable Development Goals (SDGs) defined by the UN. The value scale ranges from -100% (significant hindrance) to 100% (significant contribution to achieving the goal).",
      exclusionsTitle:
        "Please select which absolute exclusions are important to you for the investment",
      gasEmission: "Greenhouse gas emissions",
      gasEmission_tooltipTitle: "Greenhouse gas emissions",
      gasEmission_tooltipText:
        "Direct and indirect release of climate-damaging gases and involvement in the field of fossil fuels",
      hazardousWaste: "Hazardous waste",
      hazardousWaste_tooltipTitle: "Hazardous waste",
      hazardousWaste_tooltipText: "Hazardous waste generated by the company",
      waterPollution: "Pollution of water",
      waterPollution_tooltipTitle: "Pollution of water",
      waterPollution_tooltipText:
        "Determination of chemical oxygen demand (COD) to assess the contamination of wastewater with organic substances",
      negativeImpact: "Negative impact on biodiversity",
      negativeImpact_tooltipTitle: " Negative impact on biodiversity",
      negativeImpact_tooltipText:
        "Activities with a negative impact on biodiversity-sensitive areas",
      socialEmployment: "Social and employee issues",
      socialEmployment_tooltipTitle: "Social and employee issues",
      socialEmployment_tooltipText:
        "Violations of the UNGCOECD guidelines and unadjusted gender pay gap",
      sustainabilityClass: {
        title: "Your sustainability class",
        text: "Your sustainability class is currently 1 of 5.",
        link: "further information",
      },
      subtitle: "",
    },
    details: {
      title: "Configure the details of your investment",
      strategy: "Your investment strategy",
      chartTitle: "Expected asset performance",
      return: "Return",
      volatility: "Volatility",
      "10-years": "10 years",
      "20-years": "20 years",
      investmentAmount: "Your initial investment",
      savingsPlan: "Your monthly savings plan",
    },
    signup: {
      title: "Registration",
      email: "Your email address",
      email_placeholder: "Please enter your email address...",
      password: "Password",
      password_placeholder: "Please set a password... ",
      acceptedTerms:
        "I consent to the processing of my data. These will be sent to Musterfinanz as the asset management agent, to Netfonds AG as the processor and to the respective custodian bank for opening the custody account. You can find further information on the use of your data in the <link>Data protection declaration</link>.",
      receiveNewsletter:
        "I would like to <link1>be regularly informed</link1> about new offers. Your consent hereby can be revoked at any time (by email to <link2>max.mustermann@ musterfinanz.de</link2> or to the contact details given in the imprint).",
    },
    systemKnowledge: {
      title: "Which investments do you have knowledge of?",
      subtitle: "Multiple selection possible",
      shares: "Stocks",
      funds: "Funds",
      security3: "Security 3",
      security4: "Security 4",
      noKnowledge: "No knowledge",
    },
    investmentExperience: {
      title: "What is your experience with these investments?",
      subtitle: "Number of transactions in the last 5 years.",
      shares: "Stocks",
      funds: "Fonds",
      security3: "Security 3",
      security4: "Security 4",
      "1-5-years": "1-5 years",
      "more-than-5-years": "> 5 years",
      noExperience: "None",
    },
    netIncomePerMonth: {
      title: "Monthly net income",
      netIncomePerMonth: "How much are your monthly net income?",
    },
    expensesPerMonth: {
      title: "Monthly expenses",
      expensesPerMonth: "How much are your monthly expenses?",
    },
    assets: {
      title:
        "Do you own assets in the form of real estate or investments? If so, how much are these assets approximately?",
      "more-than-0": "> 0 €",
      "more-than-25000": "> 25,000 €",
      "more-than-50000": "> 50,000 €",
      "more-than-75000": "> 75,000 €",
      "more-than-100000": "> 100,000 €",
      other: "other information",
      realEstateAssets: "Your assets in real estate investments",
    },
    personalData: {
      title: "Please enter your personal data",
      subtitle:
        "The information is required by your bank to open a securities account",
      gender: "Salutation",
      gender_placeholder: "Choose a salutation",
      salutation: "Salutation",
      salutation_placeholder: "Choose a salutation",
      academicTitle: "Academic title ",
      academicTitle_placeholder: "Choose your title",
      firstName: "First name",
      firstName_placeholder: "Your first name",
      lastName: "Last name",
      lastName_placeholder: "Your last name",
      dateOfBirth: "Date of birth",
      placeOfBirth: "Place of birth",
      placeOfBirth_placeholder: "Please specify place of birth",
      countryOfBirth: "Country of birth",
      countryOfBirth_placeholder: "Please select your country of birth",
      maritalStatus: "Marital status",
      maritalStatus_placeholder: "Please select your marital status",
      phoneNumber: "Tel. Mobile",
      phoneNumber_placeholder: " Please enter your mobile phone number",
      email: "E-Mail",
      email_placeholder: "Please enter your email address",
      education: "Training",
      education_placeholder: "Please select your training",
      occupation: "Profession",
      occupation_placeholder: "Please select your occupation",
      sector: "Industry",
      sector_placeholder: "Please select an industry",
    },
    addressData: {
      title: "Please enter your address",
      subtitle:
        "The information is required by your bank to open a securities account",
      street: "Street",
      houseNumber: "House number",
      houseNumber_placeholder: "No.",
      zip: "Postal code",
      city: "Place of residence",
      city_placeholder: "Your place of residence",
      addressCountry: "Country",
      nationalityCountry: "Nationality",
    },
    taxationData: {
      title: "Your tax-relevant data",
      taxationCountry1: "Taxable in ",
      taxationNumber1: "Tax identification number",
      interText: "Do you have another tax residence?",
      taxationCountry2: "Taxable in ",
      taxationNumber2: "Tax identification number",
    },
    mifidData: {
      title: "Please enter your data for MiFID",
      isNotPoliticallyExposed: "I am not a politically exposed person",
      isNotPoliticallyExposed_tooltipTitle: "Politically exposed person",
      isNotPoliticallyExposed_tooltipText:
        "(PEP) are in accordance with Section 6 Paragraph 2 No. 1 Money Laundering Act Persons who hold or have held an important public office (e.g. politicians, ambassadors).\n" +
        "If you have any questions, please feel free to contact us or your advisor personally.",
      isOwnAccount: "I act on my own account ",
      isOwnAccount_tooltipTitle: "Beneficial owner",
      isOwnAccount_tooltipText:
        "If you are not trading on your own account, please contact us personally or your advisor - we will help you with the investment." +
        "For technical reasons Online strategy purchases are currently only possible for beneficial owners.",
    },
    contraAccount: {
      title: "Bank details",
      banner: {
        text: "A reference account is a checking account at your bank that is used to process payment transactions. When you buy securities, you transfer money from your reference account to the clearing account of your securities account. Your reference account must be SEPA-capable and managed in euros.",
      },
      iban: "IBAN",
      formSectionLabel: "Account holder of the reference account",
      contraAccountHolderFirstName: "First name",
      contraAccountHolderFirstName_placeholder:
        "First name of the account holder",
      contraAccountHolderLastName: "Last name",
      contraAccountHolderLastName_placeholder: "Account holder last name",
    },
    agreements: {
      title: "Agreements",
      subtitle: "Please read the following agreements carefully:",
      customerInfoAcknowlegmentAccepted:
        "I have received and acknowledged the <linkText>Customer Information</linkText>.",
      frameworkAgreementAccepted:
        "I I agree to the <linkText>framework agreement</linkText>",
      processingDataAccepted:
        "I consent to the processing of my data. This will be sent to wealthAPI Wolfram Stacklies, as a feeder to NFS Hamburger Vermögens GmbH, to Netfonds AG, as a processor and to the respective Deoptbank (FIL Fondsbank GmbH) to open the account and send investments in the selected strategies. Further information on the use of your data can be found in the <linkText>Data protection information</linkText>.",
      servicesPerfomanceAccepted:
        "I hereby declare myself in the I agree to carry out the commissioned services before the end of the cancellation period of 14 days after submitting my contractual declaration.",
    },
    consent: {
      title: "Consent to establish contact (Module A + B)",
      subtitle:
        "For reasons of better readability, the simultaneous use of the language forms male, female and diverse is avoided. All personal names apply equally to all genders. The customer agrees contact using the following means of communication:",
      sections: { 1: "Module A", 2: "Module B", 3: "Module C" },
      contactViaPhone:
        "by telephone or, if necessary, SMS (if a mobile phone number is provided",
      contactViaEmail: "via e-mail",
      contactViaFax: "via fax",
      contactViaMessengers:
        "via messenger service (Whatsapp, Signal, etc.) and/or internet telephony",
      contactViaElectronicCommunication:
        "via electronic mailbox using various authentication procedures",
      newsletterAccepted:
        "I agree to receive market information, newsletters and information on products and services via means of distance communication.",
      newsletterNotAccepted: "I do not consent",
      banner: {
        text: "Note: The declarations of consent are voluntary and can be used in whole or in part without affecting existing contractual relationships ( also for individual communication channels and modules). The conditions below apply to the individual modules A,B,C. ",
      },
      warning:
        "Please note that a combination of the individual modules is possible. ",
    },
    summary: {
      title: "Summary",
      personalDataTitle: "Personal Data",
      depotManagement: "Depot Management",
      assetManagement: "Authorized Asset Manager",
      portfolioPurchase: "Portfolio Purchase",
      savingsPlan: "Monthly Savings Plan",
      managementFee: "Ongoing Management Fee",
      riskClass: "Risk Class",
      documents: "Documents",
      apply: "Apply (subject to costs)",
      riskClassB: "B",
      riskClassC: "C",
      riskClassD: "D",
      fields: {
        academicTitle: "Title",
        education: "Education",
        salutation: "Salutation",
        occupation: "Profession",
        fullName: "First and Last Name",
        sector: "Industry",
        dateOfBirth: "Date of Birth",
        placeOfBirth: "Place of Birth",
        address: "Residing in",
        taxationNumber1: "Tax Number (TIN)",
        taxationCountry1: "Taxable in",
        nationalityCountry: "Nationality",
        phoneNumber: "Mobile Number",
        email: "E-Mail",
        accountHolderName: "Account Holder",
        maritalStatus: "Marital Status",
        iban: "IBAN",
        isNotPoliticallyExposed: "Not a Politically Exposed Person",
        isOwnAccount: "Beneficial Owner",
      },
    },
  },
  finanzfluss: {
    bankConnections: {
      bankingCredentials: {
        storeSecrets: {
          info: "Your data will be stored securely encrypted. Only if the checkbox is checked can your account be updated automatically.",
        },
      },
      bankIsBusy: {
        bannerText:
          "There are currently a lot of parallel import requests being made to {{bankName}}. This may result in a temporary interruption of the connection by the broker. We ask for your understanding that the import of your {{ bankName}} depots is currently not possible. Please try again in a few minutes.",
      },
    },
  },
  feedbackPage: {
    title: "Your feedback helps us prioritize the right things.",
    intro:
      "Your feedback is invaluable to us ❤️️ and we are continually working to improve the Copilot and make your experience with it as positive as possible. <br > <br > On this page you can see what improvements we are currently making You can also tell us your own suggestions for improvement and vote on other users' suggestions. This will help us prioritize the right things.<br > <br > If you have any questions about using the Copilot or have technical problems, please contact us via 👉 <linkText >Send the following form</linkText> 👈 to us. Thank you for your support 🙏",
    link: "following form",
  },
  securitiesSearch: {
    title: "Search asset",
    placeholder: "Enter name, ISIN or WKN",
    all: "All",
    back: "Back to search results",
    isin: "ISIN",
    type: "Class",
    showMore: "Show more",
    loading: "Loading...",
    noResults: "No results",
  },
  kpmg: {
    sidebar: {
      lastUpdated: "Last transfer to KICS on {{date}} at {{time}}.",
      lastUpdatedWarning:
        "Warning: Last transfer to KICS {{days}} days ago ({{date}} at {{time}}).",
      onboardingGuideLink: "KICS onboarding guide",
    },
    dashboard: {
      portfolio: "Portfolio",
      kicksReportingTitle: "Portfolios KICS-Reporting",
    },
    kicsOnboarding: {
      stepCounter: "Step {{step}} of {{total}}",
      buttons: {
        back: "Back",
        next: "Next",
        done: "Done",
      },
      step1: {
        title: "Navigate to KICS; on the start screen select “Search and add”",
        description:
          "In the KICS home screen, locate the “Search and add” dialogue and click the icon. You will now be redirected to the “Search and add” screen.",
      },
      step2: {
        title: "Locate broker “wealthAPI” via the search dialogue",
        description:
          "Enter “wealthapi” (casing does not matter) and click on the search icon. Leave all other settings as they are.",
      },
      step3: {
        title: "Locate the broker “wealthAPI” and locate the “Action” menu",
        description:
          "After clicking the “search” icon, you will see a record of type “Company” named “WEALTHAPI”. Proceed with selecting the correct action from the “Action” menu.",
      },
      step4: {
        title:
          "Add the broker “wealthAPI” to your KICS account by selecting the correct action",
        description:
          "Select action “Add brokerage firm account” on the company “WEALTHAPI”.",
      },
      step5: {
        title:
          "Get your brokerage account ID from the wealthAPI compliance tool",
        description:
          "You will now have to log into the wealthAPI compliance solution via {{complianceUrl}}. Once logged in, you will find your individual compliance-ID in the menu bar as indicated. Click the “copy” icon to copy your personal ID. In the shown example this is “96275”.",
      },
      step6: {
        title:
          "Complete the setup of broker “wealthAPI” by adding your account ID",
        description:
          "(1) Enter your personal compliance ID as the “Brokerage firm account number” (e.g. “96275”; your personal ID will differ).\n(2) Enter a custom description, such as “wealthAPI Compliance Tool”.\n(3) Select “Individual” if this is your individual account or “Shared” if it is a shared account (“Individual” is the typical default).\n(4) Select “Purchase” as Acquisition method.\n(5) Select your personal portfolio profile; if you have only one profile, it will be pre-selected.\n(6) Select today’s date as “Acquisition date”.",
      },
      step7: {
        title: "Complete the setup of the “wealthAPI” brokerage account",
        description:
          "You will see an acknowledgement dialogue. Select “Accept” and then click “Submit” to create broker “wealthAPI”.",
      },
      step8: {
        title: "Confirmation screen",
        description:
          "Congratulations, you are all set! You will now see “WEALTHAPI” added as a brokerage account to KICS.",
      },
      step9: {
        title: "Important notes on the KICS import:",
        description:
          "<ul><li>To ensure that the portfolio data transferred to KICS is up to date, you must regularly check that the automatic retrieval of portfolio data from the financial institution is still active. This information is shown in the email status report and under the menu item Portfolios and Accounts.</li><li>Data transfer to KICS happens once per day. Please regularly check whether the data in KICS is complete.</li><li>In the following cases there is <u>no automatic transfer to KICS</u>, so manual maintenance directly in KICS is still required:<ul><li>Crypto assets</li><li>Relevant underlyings of derivatives (e.g. options) within the meaning of KPMG-internal guidelines</li><li>Investments that were acquired and sold again between two data transfers (e.g. day-trading)</li><li>Money market funds into which neobrokers partly automatically invest your deposits/balances from overnight money (call money) accounts.</li></ul></li></ul>",
      },
    },
  },
  termsOfUsePage: {
    title: "General Terms and Conditions (GTC)",
    introText1:
      'Here you will find the General Terms and Conditions (hereinafter "GTC") of',
    introCompanyNote: "(hereinafter {{mandatorShortName}})",
    introText2:
      "which apply to the use of the services of {{mandatorShortName}}.",
    introText3:
      "For a service requiring registration with {{mandatorShortName}}, you must give your consent to the terms of use applicable to the use of this service.",
    generalTitle: "General Terms of Use",
    section1: {
      title: "Scope",
      p1: "(1) The GTC apply to all services offered to the user on the pages of {{mandatorShortName}}, including paid content & services.",
      p2: "(2) Deviations from these GTC or special terms of use for individual services shall only be deemed agreed if they have been expressly confirmed in writing by {{mandatorShortName}}. In particular, the mere failure of {{mandatorShortName}} to object to other GTC shall not result in them being deemed agreed.",
      p3: "(3) {{mandatorShortName}} is entitled to amend these GTC at any time.",
      p4: "(4) {{mandatorShortName}} is entitled, in particular within the scope of amending the GTC, to supplement or replace an ineffective condition with effect for existing contracts in the event of its ineffectiveness, to adapt the affected conditions in the event of a change in a statutory provision or supreme court ruling, if one or more conditions of the contractual relationship are affected by this change, in a manner that corresponds to the purpose of the changed legal situation, provided that the user is not worse off under the new or amended conditions than under the original condition.",
      p5: "(5) {{mandatorShortName}} is not responsible for third-party Internet services to which {{mandatorShortName}} links from its pages or which {{mandatorShortName}} facilitates. The respective terms of use of the respective providers apply to these offers. {{mandatorShortName}} assumes no liability or warranty for these.",
    },
    section2: {
      title: "Data Protection",
      text: "The security and protection of your data is very important to {{mandatorShortName}}. Therefore, we have created a separate privacy policy, which is part of our GTC and which you can <0>view here</0>.",
    },
    section3: {
      title: "Best Price Guarantee",
      p1: "(1) Upgrade and downgrade of accounts/cashback model change. In order to offer our users maximum returns, we regularly check which cashback model brings you the greatest benefit and, if necessary, automatically switch your account to the most favorable solution for you. Such a model change does not constitute a termination; your account as such remains in place and we merely adjust the remuneration and rights conditions of your account.",
      p2: "(2) Should you ever find a better public offer from another provider, we will match your conditions!",
    },
    section4: {
      title: "Access and Participation Eligibility",
      p1: "(1) In principle, all natural persons are eligible for access and participation; commercial use requires the written consent of {{mandatorShortName}}.",
      p2: "(2) {{mandatorShortName}} only concludes contracts for paid content with persons over 18 years of age or with the express consent of the legal guardian.",
      p3: "(3) Furthermore, the websites are not directed at persons in countries that prohibit the availability or access to the content posted therein. Each user is solely responsible for informing themselves about any restrictions before accessing these web pages and for complying with them.",
    },
    sectionCashbackReferral: {
      title: "Referral Bonuses - Refer a Friend",
      p1: "(1) Excluded from the bonus are referrals:",
      p1Item1:
        "where the referrer is not a Rentablo Cashback customer themselves",
      p1Item2:
        "that supplement existing contracts (e.g. adding children or spouses)",
      p1Item3: "for products that are excluded from the referral program",
      p1Item4: "that are reciprocal",
      p2: "(2) Recruiting customers, e.g. on coupon portals, forums, blog posts, social media channels or other platforms is not permitted. Customer recruitment is exclusively valid through direct contact with the recruited customer.",
      p3: "(3) Referrals that do not comply with the participation conditions will not be counted. A combination of different vouchers/bonuses is not possible.",
      p4: "(4) The cashback bonus is offset against the Rentablo commission retention and thus increases your cashback. The bonus can also be offset against other {{mandatorShortName}} services such as our fee-based advisory services.",
    },
    section5: {
      title: "Availability",
      text: "The services of {{mandatorShortName}} are offered to the user subject to availability. {{mandatorShortName}} endeavors to ensure that the services of {{mandatorShortName}} are available to the user without disruption. Due to maintenance work and/or further development and/or other disruptions (e.g. from data suppliers or other service providers), the usage possibilities may be restricted and/or temporarily interrupted. This may under certain circumstances also lead to data loss. No compensation claims arise for the affected users. {{mandatorShortName}} is further entitled to change or discontinue the offered services at any time at its own discretion without prior notice.",
    },
    sectionCashbackPayout: {
      title:
        "Obligation to Keep the Payout Account Up to Date; Returned Transfers and Forfeiture of the Cashback Balance",
      p1: "(1) Obligation to keep details current: The user is obliged to keep the payout account on file up to date at all times and to update any change of bank details in their user account without delay. {{mandatorShortName}} accepts no liability for delays or the loss of cashback payouts that are attributable to outdated or incorrect account details provided by the user.",
      p2: "(2) Processing fee and minimum payout amount for returned transfers: If a cashback payout is returned to {{mandatorShortName}} because the bank details are not up to date, the following applies:",
      p2ItemA:
        "a) {{mandatorShortName}} will only contact the user and make a further payout once the accumulated outstanding cashback balance reaches an amount of at least €25.00.",
      p2ItemB:
        "b) A processing fee of €10.00 will be withheld from the outstanding cashback amount to cover the processing effort incurred. Third-party bank charges for return transactions will likewise be deducted from the payout.",
      p3: "(3) Forfeiture of the cashback balance: The entitlement to payout of the cashback balance lapses permanently if one of the following circumstances applies:",
      p3ItemA:
        "a) the user does not update their bank details by 31 December of the year in which the payout entitlement arose through the cashback settlement (payout not possible), or",
      p3ItemB:
        "b) {{mandatorShortName}} has made three attempts to contact the user requesting that they update their bank details and the user has not responded (user does not respond).",
    },
    section6: {
      title: "Contractual Relationship, Subject Matter, Service Description",
      p1: "(1) The contractual relationship for the use of paid content from {{mandatorShortName}} is established through registration with the desired and selected payment system provider, agreement to the general terms of use and the respective acceptance by {{mandatorShortName}}. Acceptance by {{mandatorShortName}} occurs at the latest with the opening of access to the paid content.",
      p2: "(2) Regarding the use of third-party services advertised by {{mandatorShortName}} on its pages or to which {{mandatorShortName}} provides access through its pages, contractual relationships are established exclusively between the user and the offering third party. {{mandatorShortName}} assumes no liability or warranty for these.",
      p3: "(3) The subject of the contract is the – depending on the chosen account – free or paid use of {{mandatorShortName}}. {{mandatorShortName}} is an online financial manager that displays the financial data of users within the framework of an account information service.",
      p4: "(4) In addition, {{mandatorShortName}} offers users free information tools as well as advisory and brokerage services on a commission and fee basis for all types of financial services in accordance with the Trade Regulation Act §34c (real estate), §34d (insurance) and §34f 1-3 (financial investments).",
      p5: "(5) We provide all services exclusively for informational purposes. The aim is to enable the user to make independent decisions. {{mandatorShortName}} provides private users with free tools for evaluating their financial investments and performance, their personal situation, recording their goals & wishes and their needs. In particular, we do not provide automatic legal/tax or financial advice. Qualified advice in financial matters can only be provided in a personal consultation and only taking into account and weighing the individual circumstances and needs of a user. If needed, the user can book paid expertise at fixed rates and secure support in evaluation and decision-making. The user can book desired appointments bindingly online and cancel free of charge up to 24 hours before the appointment. By registering, you declare that you have taken note of this.",
      p6: '(6) The aim is to provide the user with access to commission-free or cost-effective and high-performing financial products. {{mandatorShortName}} provides on- or offline, exclusively for private users, information about tariffs and conditions of cooperating insurance / financial service companies, as well as energy and telecommunications companies (hereinafter referred to as "Providers") for a fee and without obligation.',
      p7: "{{mandatorShortName}} transmits applications to the respective provider on the basis of an offer submitted by the user online or offline. No obligations beyond the brokerage are assumed. In particular, {{mandatorShortName}} itself does not provide any insurance or financial services, does not supply energy and does not provide telecommunications services.",
      p8: "{{mandatorShortName}} acts as a platform for the brokerage of contracts and insurance in the sector(s) chosen by the user. Based on the information provided in the comparisons or offer requests, {{mandatorShortName}} offers to procure the appropriate contract or insurance coverage. In principle, this is done on the basis of an objective and balanced market analysis. {{mandatorShortName}} regularly analyzes the market and programs the corresponding comparison software or uses software products from third-party providers. Not all providers or insurance companies and not all insurance tariffs available on the market, such as special broker and coverage concepts or agency tariffs, can be listed in the comparisons. For special insurance, the user has the option of requesting written offers and advice from a qualified product expert. The user receives various proposals from providers, calculated based on the data entered by them.",
      p9: "If the user has decided on a specific proposal from {{mandatorShortName}}, they can either request an offer online through their signature or by clicking the designated button, or offline on the basis of the original proposal from {{mandatorShortName}}, or submit such an offer.",
      p10: "A brokerage relationship with {{mandatorShortName}} is established upon transmission of the proposals to the provider by {{mandatorShortName}} on the basis of the data actually transmitted by the user.",
      p11: "An insurance or financial services contract is only concluded between the user and the provider selected by them. {{mandatorShortName}} has no influence whatsoever on the conclusion or non-conclusion of such a contractual relationship. Whether a contract with the provider is concluded depends on the corresponding conditions of the respective provider.",
      p12: "The specific offers from providers may differ in individual cases with regard to individual circumstances from the individual tariffs or prerequisites that {{mandatorShortName}} calculates and makes available. The providers are solely responsible for the content and accuracy of the offers.",
      p13: "(7) {{mandatorShortName}} excludes actively buying or selling securities for customers. Customers must execute purchases and sales independently through their custodian bank.",
    },
    section7: {
      title: "Opening a User Account",
      p1: "(1) For certain services on the pages of {{mandatorShortName}}, the user must register or can open a user account.",
      p2: "(2) There is no entitlement to conclude a usage contract. We may reject your registration request at any time without giving reasons. In this case, we will of course delete all information and data you have already provided.",
      p3: "(3) {{mandatorShortName}} reserves the right to offer parts of its services only within the framework of a paid premium account. Furthermore, {{mandatorShortName}} reserves the right to offer trial periods for the premium account, during which it can be tested free of charge for the respectively specified period. The exact service description of the accounts can be accessed via our homepage. We reserve the right, at our own discretion, to make parts of the usage options of the paid account part of the free account.",
    },
    section8: {
      title: "Scope of Content Usage",
      p1: "(1) The user is only entitled to use the content provided by {{mandatorShortName}} for private/own purposes. In particular, they are not entitled to pass on content or parts thereof to third parties or to provide third parties with access to paid content. Deviating regulations, in particular commercial use, are only valid with written permission from {{mandatorShortName}}.",
      p2: "(2) All content offered by {{mandatorShortName}} is subject to commercial property rights and may only be used in the form, type and manner approved by {{mandatorShortName}}. The copyright remains with the respective rights holder. Reproduction, publication or use of the offered services in electronic form or other printed publications is not permitted without the express written consent of {{mandatorShortName}}.",
      p3: "(3) In particular, automated querying of the content provided by {{mandatorShortName}} without express written permission is not permitted in any form.",
      p4: "(4) If the user violates the granted usage rights or there is suspicion of misuse of the provided content, {{mandatorShortName}} is entitled to block the user's access without prior notice and to initiate legal proceedings against them.",
    },
    section9: {
      title: "Payment Transactions",
      p1: "(1) The fees for paid content are charged before the service is provided with a payment system provider to be selected by the user. The terms of use of the payment system provider selected by the user apply exclusively, which are indicated and appropriate assistance is provided at the relevant point. The fee claims are to be settled in accordance with the respective terms of use with the selected payment system provider.",
      p2: "(2) If the user does not meet their payment obligations or payment actions are not carried out or are charged back, {{mandatorShortName}}, without prejudice to further claims, is entitled to block the user's access. If the block occurs due to outstanding claims and the user settles these, access will be unblocked.",
      p3: "(3) {{mandatorShortName}} reserves the right to commission third parties with the collection of debts.",
      p4: "(4) If the user violates the granted usage rights under §{{usageRightsSection}} or their obligations under §{{obligationsSection}}, {{mandatorShortName}} is entitled to terminate the contract without notice, whereby the customer's payment obligation remains unaffected, i.e. already paid usage fees will not be refunded. Furthermore, {{mandatorShortName}} reserves the right to assert further legal claims such as damages.",
    },
    section10: {
      title: "User Obligations",
      p1: "(1) When booking paid offers, the user assures that the information provided about their person in the course of a booking on the pages of {{mandatorShortName}}, in particular their first name, last name and postal address as well as date of birth and email address, are truthful and correct, and that they will immediately notify {{mandatorShortName}} of any changes to the information provided. False information entitles {{mandatorShortName}} to immediately, irrevocably and, if applicable, retroactively discontinue the offer.",
      p2: "(2) The user undertakes not to violate applicable legal provisions and any contractual provisions in the course of using the services of {{mandatorShortName}}. They undertake in particular that any content they distribute does not infringe the rights of third parties (e.g. copyrights, patent and trademark rights), that applicable criminal laws and youth protection provisions are observed, and that no racist, Holocaust-denying, grossly offensive, pornographic or sexual, youth-endangering, extremist, violence-glorifying or trivializing, war-glorifying, advertising for a terrorist or extremist political association, inciting criminal offenses, containing defamatory statements, insulting or unsuitable for minors or other criminal content is distributed. The user further undertakes to take into account the recognized principles of data security for the protection of data and to observe the obligations of data protection provisions, to check emails and queries sent to {{mandatorShortName}} with the greatest possible care for viruses, to comply with legal, official and technical regulations, to keep their possible username, identification and password secret, not to pass them on, not to tolerate or enable their disclosure and to take the necessary measures to ensure confidentiality and to immediately notify {{mandatorShortName}} in the event of misuse or loss of this information or a corresponding suspicion. Indications of misuse of the content of {{mandatorShortName}} or the payment system must also be reported to {{mandatorShortName}} immediately.",
      p3: "(3) The user indemnifies {{mandatorShortName}} against any claims by third parties that they assert against {{mandatorShortName}} due to infringement of their rights by this user. This also includes the costs of reasonable legal prosecution and defense. {{mandatorShortName}} reserves the right, in the event of reasonable suspicion of misuse of the services of {{mandatorShortName}} or the payment systems, to block this user's access to its content and any existing user account, as well as to involve the investigative authorities.",
      p4: "(4) The user may only offset against claims by {{mandatorShortName}} with undisputed or legally established claims. Rights of retention are only available to the user on account of claims from the individual, specific contractual relationship of which these GTC are part.",
      p5: "(5) The user undertakes to keep the data required for login at {{mandatorShortName}} (usually email address and password) secret and not to make them accessible to any third party. In case of suspected misuse, {{mandatorShortName}} must be notified immediately.",
      p6: "(6) If the user violates any of the aforementioned obligations, {{mandatorShortName}} is entitled to block the customer's access to protected areas without prior notice.",
    },
    section11: {
      title: "Liability",
      p1: "(1) Liability of {{mandatorShortName}} and its representatives or vicarious agents for damages, in particular due to delay, non-performance, poor performance or tortious acts, exists only in the event of a breach of material contractual obligations on the fulfillment of which special reliance was placed. The exclusion of liability does not apply to intent and gross negligence. Otherwise, liability of {{mandatorShortName}} is excluded unless there are mandatory statutory provisions.",
      p2: "(2) {{mandatorShortName}} is only liable for foreseeable damages. Liability for indirect damages, in particular consequential damages resulting from defects, unforeseeable damages or atypical damages as well as lost profits is excluded. The same applies to the consequences of industrial disputes, accidental damages and force majeure.",
      p3: "(3) {{mandatorShortName}} provides its own information and data as well as information from other providers via hyperlinks (internet links) on the internet and on mobile devices.",
      p4: "This information and data serves solely for informational purposes, without the user being able to rely on the timeliness, accuracy or completeness of the information. {{mandatorShortName}} therefore assumes no warranty or liability, in particular not for direct or indirect damages arising from the use of information or data found on the {{mandatorShortName}} websites. {{mandatorShortName}} assumes in particular no responsibility for the content or functionality, error-free operation or legality of third-party websites referenced by links from the {{mandatorShortName}} websites.",
      p5: "(4) {{mandatorShortName}} strives for constant timeliness, completeness and accuracy in the treatment of data communicated by the user and the execution of comparison calculations. However, {{mandatorShortName}} is not obligated to include all insurance and financial services companies on the market in the calculations. Specifically in the insurance sector, the restriction is to available commission-free tariffs.",
      p6: "Any information about insurance and financial services or other information on the websites and blogs belonging to {{mandatorShortName}} does not constitute advice for the user, but serves to facilitate an independent investment decision by the user, over which {{mandatorShortName}} has no influence. None of the information is to be understood as a promise of a guarantee or assurance. The services of {{mandatorShortName}} do not include, in particular, legal or tax advice. The wording of the respective contract or insurance policy is binding. The user is obligated to check the exact content of the respective contract/insurance policy and to report any deviations immediately.",
      p7: "(5) In the event of intentionally false or untrue personal data being transmitted by the user, {{mandatorShortName}} shall not be liable. At the same time, {{mandatorShortName}} reserves the right to exclude them from using the offered or provided services and to demand compensation for any damages incurred.",
      p8: "(6) {{mandatorShortName}} offers discussion forums and chats. The content and information exchanged by users in these forums is not subject to any control by {{mandatorShortName}}. For this reason, {{mandatorShortName}} assumes no liability for the content and information posted in the forums. The responsibility for the content published by the user on the pages of {{mandatorShortName}} lies exclusively with the user.",
      p9: "(7) {{mandatorShortName}} excludes any liability due to technical or other disruptions.",
      p10: "(9) The above limitations of liability apply to all contractual and non-contractual claims.",
    },
    section12: {
      title: "Financial Analyses",
      p1: "(1) {{mandatorShortName}} does not act as a creator of financial analyses. Any passing on of third-party financial analyses is done without material changes to the financial analyses and without reviewing their content.",
      p2: "(2) If the product qualifies as a financial analysis, it is expressly clarified that {{mandatorShortName}} only acts as a distributor of an essentially unchanged financial analysis. The product manufacturer is the person responsible for the content of the product that may qualify as a financial analysis.",
    },
    section13: {
      title: "Disclaimer",
    },
    section14: {
      title: "Warranty",
      p1: "(1) If paid content is complained about by the user due to incomplete or defective services by {{mandatorShortName}}, the user must, in accordance with the terms of use of the payment system provider selected by the user, report the complaints to either {{mandatorShortName}} or the payment provider immediately upon becoming aware of them.",
      p2: "(2) If {{mandatorShortName}} is liable due to justified and timely complaints, {{mandatorShortName}} shall, in the case of incomplete performance, make subsequent delivery and in the case of defective performance, at its option, make subsequent improvement or deliver a replacement. The user may demand a reduction of fees if {{mandatorShortName}} refuses attempts at subsequent improvement or replacement delivery, if these are impossible or otherwise fail. There is no right of withdrawal in favor of the user.",
    },
    section15: {
      title: "Copyright",
      p1: "(1) All content, information, images, videos and databases and computer programs (e.g. widgets) published on the pages of {{mandatorShortName}} are protected by copyright.",
      p2: "(2) Use is only permitted for private personal use. Any use beyond this, in particular private and commercial reproduction, modification, distribution or storage of information or data, in particular of texts, parts of texts, image and film material, requires the prior express consent of {{mandatorShortName}}. This also applies to inclusion in electronic databases and reproduction on CD-ROM, DVD, etc.",
      p3: "Private and/or commercial reproduction, modification, distribution or other misuse of computer programs is not permitted. The user does not acquire any ownership rights by downloading or receiving the source code of a computer program. No copyrights or other intellectual property rights are transferred. If the service and/or services are discontinued, the user is obligated to immediately delete the provided source code.",
      p4: "In all other respects, the legal limits arising from copyright and other applicable statutory provisions apply.",
    },
    section16: {
      title: "User-Submitted Content",
      p1: "(1) The user who sends their own content (e.g. videos, photos, photo series, texts, etc.) to {{mandatorShortName}} (e.g. as part of competitions, reader promotions, internet contests or an SMS ticker), by submitting agrees that the submitted content may be reproduced, distributed and publicly displayed free of charge on the internet and in print. The user further declares that they possess all copyrights and other rights to the submitted content and that persons depicted in submitted graphic content (e.g. videos, photos, photo series) who are not merely incidental to a location or part of depicted gatherings, processions or similar events, consent to publication. For persons under 18 years of age, the consent of the legal guardian applies. Contributions sent by mail cannot be returned to the participant.",
      p2: "(2) Users undertake not to send any content with illegal, grossly offensive, pornographic or sexual, youth-endangering, extremist, violence-glorifying or trivializing, war-glorifying, advertising for a terrorist or extremist political association, inciting criminal offenses, containing defamatory statements, or other criminal content to {{mandatorShortName}}. The user also undertakes not to send any content containing advertising or commercial content.",
      p3: "(3) {{mandatorShortName}} reserves the right not to publish submitted content.",
      p4: "(4) The user fully indemnifies {{mandatorShortName}} against all claims by third parties arising from the user's violation of their obligations under these conditions or – contrary to this declaration – the user not possessing all rights to the submitted content or depicted persons not consenting to publication.",
      p5: "(5) The submitted content constitutes personal statements of the users and does not represent the opinion of {{mandatorShortName}}. The user has no legal right to publication of the submitted content.",
    },
    section17: {
      title: "Right of Withdrawal",
      p1: "(1) The user is entitled to withdraw their declaration of intent aimed at concluding the contract within two weeks. The period begins at the earliest upon receipt of this instruction or after receipt of your contractual documents or insurance policy. Timely sending of the withdrawal declaration is sufficient to meet the deadline. It must be in writing without stating reasons and addressed to:",
      p2: "(2) In the event of an effective withdrawal, the services received by both parties are to be returned and any benefits drawn are to be surrendered. If the user cannot return the received services in whole or in part or only in a deteriorated condition, compensation must be paid to that extent.",
      p3: "(3) Special notices: The right of withdrawal expires prematurely if the contract has been fully performed by both parties at the express request of the customer before the customer has exercised their right of withdrawal. This is the case, for example, when the purchased services are used by the customer. A single use/login is sufficient for this.",
      p4: '(4) Special notice regarding premium services: Premium services involve the provision of "Digital Content" which is made available in a password-protected customer area. Due to the nature of these digital contents, they are not suitable for return. A right of withdrawal does not exist pursuant to § 312 d para. 4 no. 1 BGB. With the first use of the personal access data, the right of withdrawal expires prematurely, as the contract has been fully performed by both parties at the express request of the customer before the customer has exercised their right of withdrawal.',
      p5: "(5) Special notice regarding the brokerage of services, products and insurance: Consequences of withdrawal in the event of an effective withdrawal, the contract/insurance cover ends, and the provider/insurer will reimburse you the portion of the premiums attributable to the period after receipt of the withdrawal, if you have agreed that the contract/insurance cover begins before the end of the withdrawal period. The withdrawal of a contract has no effect on the brokerage relationship with {{mandatorShortName}}, provided this has already been fulfilled.",
    },
    sectionCashbackBilling: {
      title: "Remuneration and Billing",
      p1Rentablo:
        "(1) The use of the {{mandatorShortName}} account or the use of the Rentablo Premium account within a trial period is free of charge. The remuneration for the use of the Rentablo Premium account and the Rentablo Cashback models is based on the billing conditions you have chosen (monthly or annual subscription) and is determined by the current price list at the time of contract conclusion and the discounts described therein, which you can access on our homepage.",
      p1: "(1) The use of the {{mandatorShortName}} account is free of charge. The remuneration for the Rentablo Cashback models is based on the billing conditions you have chosen (monthly or annual subscription) and is determined by the current price list at the time of contract conclusion and the discounts described therein, which you can access on our homepage.",
      p2: "(2) The remuneration for the Rentablo Fund Cashback is paid quarterly in arrears. The cashback costs are offset against the cashback and the difference is transferred to the account designated by the customer. Other remunerations, e.g. for premium models, are due in advance at the beginning of the respective billing period on the day of the respective booking of a period (month or year) for the respectively selected billing period. If the contract is extended through a subscription, each further payment is due at the beginning of the new billing period.",
      p3: "(3) All stated remunerations and prices include the respectively applicable statutory value-added tax.",
      p4: "(4) You may only offset against legally established or undisputed claims or assert a right of retention. You may only assign claims from this contract to third parties with our written consent.",
      p5: "(5) If you fail to make a payment despite it being due, you are in default (immediately from the first non-payment despite being due). Please note in particular our right of termination.",
      p6: "(6) With fund cashback, it should be noted that only the trailing commissions can be distributed as cashback that {{mandatorShortName}} actually receives as a broker from the banks or the distribution company.",
    },
    section18: {
      title: "Contract Duration",
      cashbackP1Title: "(1) Rentablo Cashback",
      cashbackP1Text:
        "The contract for the free use of {{mandatorShortName}} with the free account is concluded for an indefinite period.",
      p2Title:
        "({{num}}) {{mandatorShortName}} Portfolio Manager Account (free)",
      p2Text:
        "The contract for the free use of {{mandatorShortName}} with the free account is concluded for an indefinite period.",
      p3Title: "(3) {{mandatorShortName}} Portfolio Manager Account",
      p3Text:
        'The contract for the use of the {{mandatorShortName}} Portfolio Manager Account is concluded for an indefinite period. Termination is possible with 30 days notice to the end of the quarter. Contracts run until the end of the agreed period and are automatically renewed for the same duration if your account has not been terminated by you or us beforehand ("Subscription"). You can choose the respective remuneration model when concluding the contract and we will clearly point this out to you.',
      p4Title:
        "(4) Trial Period {{mandatorShortName}} Portfolio Manager Account",
      p4Text:
        "If you use the Premium Account with a trial period, the contract initially runs for the duration of the trial period. After that, the contract automatically switches to the paid model.",
    },
    section19: {
      title: "Termination",
      p1: "(1) The right to termination for good cause is reserved for each party. Good cause exists in particular if the user, despite a warning, continues to violate material provisions of these GTC and/or the user commits misconduct directed against third parties by using the offer of {{mandatorShortName}} for unlawful purposes or purposes that are harassing to third parties. Furthermore, good cause exists if you fall behind in your payment obligations by a non-insignificant amount. A non-insignificant amount is an amount equal to one monthly remuneration for the respective account. In this case, you remain obligated to pay the remunerations. We reserve the right to assert further claims due to payment default.",
      p2: "(2) All terminations under these GTC must be made by written notification to the addresses stated in Point {{addressSection}}.",
      p3: "(3) Upon the termination becoming effective, access to the services of {{mandatorShortName}} will be blocked.",
      p4: "(4) Both parties may terminate the free account at any time. You may terminate the Premium Account at any time – for contracts with a minimum term, at the end of the agreed term and for trial periods, at the end of the trial period. We may terminate the contract with two weeks' notice – for contracts with a minimum term, at the end of the agreed term and for trial periods, at the end of the trial period.",
      p5: '(5) You can terminate the {{mandatorShortName}} account by clicking on "Delete account" in your profile or by writing a short email to <0>{{supportEmail}}</0>. We may terminate the usage contract by email. In addition, we may terminate the usage contract for the free account by discontinuing the possibility of an account altogether.',
      p6: "(6) The service is very cost-effective as it is aimed exclusively at self-directed investors. To protect the community, {{mandatorShortName}} may terminate customers who misuse or excessively use the support service, or refuse cooperation. {{mandatorShortName}} will inform these customers of their misconduct.",
    },
    section20: {
      title: "Final Provisions",
      p1: "(1) The place of jurisdiction, insofar as the user is a registered merchant, for all disputes of a property nature arising directly or indirectly from the contractual relationship is Berlin. Any exclusive place of jurisdiction remains unaffected by this. The place of performance is Berlin. German law applies, excluding the UN Convention on Contracts for the International Sale of Goods.",
      p2: "(2) In connection with participation in competitions, legal recourse is excluded.",
      p3: "(3) Should individual provisions of these GTC, including these regulations, be wholly or partially invalid, the validity of the remaining provisions or parts of such provisions shall remain unaffected. The respective statutory provisions shall take the place of the invalid or missing provisions.",
      p4: "(4) These General Terms and Conditions are conclusive for the regulation of the legal relationships between the user and {{mandatorShortName}} and its vicarious agents.",
    },
    published:
      "The GTC are published on the website <0>{{rootUrl}}</0> and thus any future changes to the GTC are accessible to all users. The user is responsible for keeping themselves informed.",
    date: "Effective: 28.08.2026",
  },
  tppWebFormTermsOfUsePage: {
    title: "General Terms and Conditions (GTC)",
    agreement: {
      title:
        "Usage Agreement and Notices for End Users of wealthAPI Account Information and Payment Initiation Services",
      date: "Effective: 06.12.2021",
      section1: {
        title: "1 Content and Formation of the Contract",
        sub1: {
          title: "1.1 Contracting Parties and Subject Matter",
          text: '{{b2bName}}, {{street}} {{streetNumber}}, {{zip}} {{city}} (AG Berlin Charlottenburg HRB 256105 B), email: {{b2bEmail}} ("wealthAPI") is a payment institution supervised by the Federal Financial Supervisory Authority ("BaFin"), Graurheindorfer Str. 108, D-53117 Bonn, Fax: + 49 228 4108-1550, email: poststelle@bafin.de.',
          text2:
            'The account information service ("AIS") provided by wealthAPI as an online service allows end users to retrieve their account balances and account transactions (hereinafter "account information") from payment accounts and other accounts of credit and financial services institutions, credit card companies, and other financial data providers (hereinafter "account providers"), insofar as these accounts are respectively included in the scope of services between the end user and the service provider (as defined below).',
          text3:
            "The retrieved account information is stored at wealthAPI and made accessible to the end user via an API (Application Programming Interface) through the service provider's service.",
        },
        sub2: {
          title: "1.2 Relationship with the Service Provider",
          text: "wealthAPI and the service provider are legally and economically independent companies and provide different services to the end user (for the interplay between wealthAPI and the service, see Section 2.1.1).",
        },
        sub3: {
          title: "1.3 Path to Contract Conclusion",
          text: "The conclusion of this usage agreement is a prerequisite for the provision of account information services by wealthAPI. For this purpose, the end user is redirected from the service to a website or system of wealthAPI. On this website/system, the end user may perform the following activities:",
          p1: '1.3.1 The end user may review the privacy notices and the pre-contractual information for account information services and the terms of use. By clicking the "Continue" button, the end user agrees to the terms of use. With this consent, the contract between the end user and wealthAPI is concluded ("contract conclusion"). The terms of use are available to the end user as a link for download and printing.',
          p2: '1.3.2 Subsequently, the end user may enter their access credentials for the account provider (user ID or similar and PIN/password). In some cases, the end user additionally has the option to allow or deny the storage of the PIN by wealthAPI. By clicking the corresponding button (e.g., "Retrieve bank data"), the access credentials are transmitted to wealthAPI and the connection to the account provider is established by wealthAPI.',
          p3: "1.3.3 In the case of a wealthAPI AIS, the account provider may require strong customer authentication. In this case, the end user may enter their personalized security credentials, e.g., a TAN, in the input form and transmit them to the account provider via wealthAPI, insofar as this is required and technically possible.",
          p4: "1.3.4 wealthAPI uses services of finAPI GmbH (Adams-Lehmann-Straße 44, D-80797 Munich) for the provision of account information services under a corresponding data processing agreement. Account information of the user is stored at finAPI GmbH insofar as this is necessary for the provision of the AIS.",
          extra:
            "The integration of additional account providers and/or accounts after contract conclusion is, insofar as these are supported by the service provider, generally possible and also takes place by redirecting the end user to a website/system of wealthAPI.",
        },
        sub4: {
          title: "1.4 No Deviating Provisions/Amendments",
          text: "For the provision of account information or payment initiation services by wealthAPI, only these terms of use shall apply in the relationship between wealthAPI and the end user. Amendments to these terms of use will be communicated in writing, in electronic form, or in text form in a timely manner before they take effect; they shall be deemed approved if wealthAPI does not receive an objection from the end user within one month after notification of the amendments. Notification may be provided by wealthAPI through display within the input form or through the service provider. An objection entitles the end user to terminate this usage agreement without notice. wealthAPI will inform the end user of the deadline and the possibility to object.",
        },
      },
      section2: {
        title: "2 Description of Services",
        sub1: {
          title: "2.1 Description of Services",
          sub1: {
            title: "2.1.1 Interplay of Service and wealthAPI",
            text: "The end user may use wealthAPI AIS from within the service provider's service. The entry and management of the end user's personal access credentials at the respective account provider as well as the execution of the AIS are carried out directly by wealthAPI for the end user. After execution of the AIS functions, wealthAPI makes the corresponding data available to the end user for display and processing in the service provider's service. The service provider at no time receives sensitive payment data that would enable access to account information at the end user's account providers. The sensitive payment data is transferred directly to wealthAPI systems, processed by wealthAPI, and in the case of the AIS, stored by wealthAPI or finAPI GmbH on behalf of wealthAPI. The sensitive payment data entered by the end user is protected by wealthAPI against unauthorized access.",
          },
          sub2: {
            title: "2.1.2 wealthAPI AIS Functions",
            text: "In general, the AIS of wealthAPI provides the following functions for the end user, subject to the proviso that the functions available to the end user in individual cases also depend on the scope of services agreed between the end user and the service provider, so that individual functions listed below may not be available to the end user:",
            p1: "2.1.2.1 General",
            p1Text:
              "Receipt of the end user's personal access credentials at the respective account provider on a separate and secure website/system of wealthAPI. Receipt of a TAN or other additional security credential on a separate website/system of wealthAPI and transmission to the end user's account provider.",
            p2: "2.1.2.2 In addition, the AIS includes the following functions",
            p2Item1: "Single or repeated retrieval of account information.",
            p2Item2:
              "Storage and aggregation of retrieved account information for later retrieval by a service authorized by the end user.",
            p2Item3:
              "Retrieval of account information by the service used by the end user.",
            p2Item4:
              "Optional encrypted storage of access credentials for an account provider.",
            p2Item5:
              "Modification and deletion of previously stored access credentials.",
            p3: "2.1.2.4 Further optional supplementary services",
            p3Text:
              "The categorization of account information. Individual functions of the wealthAPI AIS depend on products and services of third parties over which wealthAPI has no influence. This may result in individual functions of the wealthAPI AIS being temporarily or permanently unavailable.",
          },
        },
        sub2: {
          title: "2.2 Guarantees Only in Written Form with Signature",
          text: 'In case of doubt, guarantees and assurances of characteristics by wealthAPI shall only be construed as such if they are made in written form (with signature) and designated as a "guarantee".',
        },
        sub3: {
          title: "2.3 Provision and Use",
          text: "The functionalities of wealthAPI are available to the end user within the scope of use agreed between the end user and the service provider and for use in accordance with this usage agreement.",
        },
      },
      section3: {
        title: "3 Obligations and Duties of the End User",
        sub1: {
          title: "3.1 Compliance with Prescribed Usage Scenarios",
          text1:
            "End users are not permitted to use the wealthAPI functions in a manner not expressly permitted in these terms of use.",
          text2: "End users may not access or use the wealthAPI AIS to",
          item1:
            "disrupt, overload, or interrupt the functionality of the wealthAPI AIS;",
          item2:
            "circumvent, impede, or manipulate the operation or functionality of the wealthAPI AIS;",
          item3: "circumvent or undermine technical restrictions;",
          item4:
            "embed or otherwise link the wealthAPI AIS on another website or in another application;",
          item5:
            "violate the security of the wealthAPI software or any network or server used by wealthAPI, or exploit security vulnerabilities thereof;",
          item6:
            "use the wealthAPI AIS in connection with activities that constitute a criminal offense or violate national and foreign legal provisions.",
        },
        sub2: {
          title: "3.2 Blocking in Case of Misuse",
          text: "wealthAPI is entitled to block the end user's access if there are indications of misuse or a threat to data security.",
        },
      },
      section4: {
        title: "4 Limitation of Liability",
        text: "wealthAPI shall be liable within the scope of statutory provisions for damages insofar as these",
        item1:
          "1. were caused intentionally or through gross negligence by wealthAPI, or",
        item2:
          "2. were caused through slight negligence by wealthAPI and are attributable to material breaches of duty that jeopardize the achievement of the purpose of this contract or to the breach of duties whose fulfillment is essential for the proper performance of this contract and on whose compliance the end user may rely (cardinal duty breach). In this case, wealthAPI shall only be liable up to the amount of damage typically foreseeable for a contract of this type.",
        text2:
          "The limitations of liability shall also apply to claims against employees and agents of wealthAPI.",
      },
      section5: {
        title: "5 Costs",
        text: "The use of the wealthAPI AIS is free of charge for the end user.",
      },
      section6: {
        title: "6 Term and Termination",
        sub1: {
          title: "6.1 Term and Termination",
          text1:
            "The contract begins upon contract conclusion and is concluded for an indefinite period. The contract may be terminated by either party with two weeks' notice. The right to extraordinary termination remains unaffected. Terminations must be in text form (e.g., email).",
          text2:
            "The contract shall terminate without the need for a declaration by the end user or wealthAPI if",
          item1:
            "the contractual relationship between wealthAPI and the service provider ends.",
          item2:
            "the contractual relationship between the end user and the service provider concerning the end user ends.",
        },
        sub2: {
          title: "6.2 Consequences of Termination",
          text: "Upon termination of the contract, wealthAPI will delete the end user's personal data, unless wealthAPI is legally entitled or obligated to retain it.",
        },
      },
      section7: {
        title: "7 Miscellaneous",
        sub1: {
          title: "7.1 Applicable Law",
          text: "This contract and all disputes arising in connection therewith shall be governed exclusively by German law.",
        },
        sub2: {
          title: "7.2 Jurisdiction",
          text: "If the customer is a registered merchant, a legal entity under public law, or a special fund under public law, the exclusive place of jurisdiction shall be Berlin. In this case, wealthAPI shall remain entitled to bring legal proceedings at the customer's registered office.",
        },
        sub3: {
          title: "7.3 Exclusive Applicability",
          text: "This usage agreement shall apply exclusively. Any conflicting or deviating general terms and conditions of the end user shall not be recognized by wealthAPI and shall have no legal effect, unless wealthAPI has expressly agreed to them in writing beforehand.",
        },
      },
    },
    precontractual: {
      title:
        "Pre-contractual Information for Account Information Services and Payment Initiation Services (Section 675d BGB in conjunction with Art. 248 EGBGB)",
      section1: {
        title: "1 Information about the Payment Service Provider",
        sub1: {
          title: "1.1 Name and Address of the Payment Service Provider",
        },
        sub2: {
          title: "1.2 Competent Supervisory Authority/Register",
          bafin: "Federal Financial Supervisory Authority (BaFin)",
          bafinBonn: "Office in Bonn:",
          bafinBonnAddress: "Graurheindorfer Str. 108",
          bafinBonnZip: "53117 Bonn",
          bafinFrankfurt: "Office in Frankfurt:",
          bafinFrankfurtAddress: "Marie-Curie-Str. 24-28",
          bafinFrankfurtZip: "60439 Frankfurt",
          registerId: "Payment Institutions Register: BaFin ID 152048",
          and: "and",
          bundesbank: "Deutsche Bundesbank",
          bundesbankDept: "Regional Office Brandenburg",
          bundesbankAddress: "Leibnizstr. 10",
          bundesbankZip: "10965 Berlin",
        },
      },
      section2: {
        title: "2 Information on the Use of Payment Services",
        sub1: {
          title: "2.1 Account Information Services",
          text: "The account information service provided by wealthAPI as an online service is an online service for communicating consolidated information about payment accounts and other accounts of credit and financial services institutions, credit card companies, and other financial data providers. The contract between the end user and wealthAPI for an account information service is concluded when the end user enters the personalized security credentials (user ID or similar, if applicable account number or IBAN and PIN/password) on the wealthAPI website and gives their express consent to the account information service by confirming the corresponding dialog field.",
        },
        sub2: {
          title: "2.2 Fees/Exchange Rate/Reference Exchange Rate",
          text: "The use of wealthAPI's payment services is free of charge for you. wealthAPI has no influence on fees, interest rates, and exchange rates from your contractual relationship with the account holder.",
        },
        sub3: {
          title: "2.3 Communication",
          text: "The pre-contractual information obligations are made available to the end user by wealthAPI before the conclusion of the respective contracts. Communication between the end user and wealthAPI takes place in German. This also applies to the contract language.",
        },
        sub4: {
          title: "2.4 Protective and Remedial Measures",
          text: "In the event of suspected or actual fraud or security risks, wealthAPI or the service provider will inform the end user thereof.",
        },
        sub5: {
          title: "2.5 Information on Liability",
          p1: "2.5.1 If unauthorized payment transactions are based on the use of a lost, stolen, or otherwise missing payment instrument or on other misuse of a payment instrument, the account provider may demand from the end user compensation for the resulting damage up to an amount of 50 euros.",
          p2: "2.5.2 The end user shall not be liable under Section 2.5.1 if",
          p2Item1:
            "1. it was not possible for the end user to detect the loss, theft, misappropriation, or other misuse of the payment instrument before the unauthorized payment transaction, or",
          p2Item2:
            "2. the loss of the payment instrument was caused by an employee, an agent, a branch of the end user's account provider, or another entity to which activities of the end user's account provider have been outsourced.",
          p3: "2.5.3 Notwithstanding Sections 2.5.1 and 2.5.2, the end user shall be liable to their account holder for the full amount of damage resulting from an unauthorized payment transaction if the end user",
          p3Item1: "1. acted with fraudulent intent, or",
          p3Item2:
            "2. caused the damage through intentional or grossly negligent breach of",
          p3Item2a:
            "a) one or more obligations pursuant to Section 675l(1), or",
          p3Item2b:
            "b) one or more agreed conditions for the issuance and use of the payment instrument.",
          p4: "2.5.4 Notwithstanding Sections 2.5.1 and 2.5.3, the end user shall not be liable for damages to their account holder if",
          p4Item1:
            "1. the end user's account provider did not require strong customer authentication within the meaning of Section 1(24) of the Payment Services Supervision Act, or",
          p4Item2:
            "2. the payee or their payment service provider did not accept strong customer authentication within the meaning of Section 1(24) of the Payment Services Supervision Act.",
          p4Text:
            "Sentence 1 shall not apply if the end user acted with fraudulent intent. In the case of sentence 1 number 2, the party that did not accept strong customer authentication shall be obligated to compensate the end user's account provider for the resulting damage.",
          p5: "2.5.5 Notwithstanding Sections 2.5.1 and 2.5.3, the end user shall not be liable for damages arising from the use of a payment instrument used after the notification pursuant to Section 675l(1) sentence 2. The payer shall also not be liable for damages within the meaning of paragraph 1 if the account provider has not fulfilled its obligation pursuant to Section 675m(1) no. 3. Sentences 1 and 2 shall not apply if the end user acted with fraudulent intent.",
        },
        sub6: {
          title:
            "2.6 Information on the Period within which the End User Must Notify the Account Provider of Unauthorized or Incorrectly Initiated or Executed Payment Transactions",
          text: "The end user is obligated to notify their account provider immediately upon discovery of an unauthorized or incorrectly executed payment transaction. Claims and objections of the end user against their account provider shall be excluded if the end user has not notified their account provider no later than 13 months after the day of the unauthorized or incorrect transaction.",
        },
        sub7: {
          title: "2.7 Liability for Unauthorized Payment Transactions",
          text: "In the case of an unauthorized payment transaction, the end user's account provider shall have no claim against the end user for reimbursement of expenses. The end user's account provider is obligated to refund the payment amount to the end user without undue delay and, if the amount was debited from a payment account, to restore that payment account to the state it would have been in without the debit from the unauthorized payment transaction. This obligation must be fulfilled without undue delay, but no later than by the end of the business day following the day on which the account provider was notified that the payment transaction was not authorized or otherwise became aware of it. Claims and objections of the end user against the account provider shall be excluded if the end user has not notified their account provider no later than 13 months after the day of the debit of an unauthorized or incorrectly executed payment transaction.",
        },
        sub8: {
          title:
            "2.8 Liability for Non-Execution, Defective, or Delayed Execution of a Payment Order",
          p1: "2.8.1 If a payment transaction is initiated by the end user, the end user may demand from their account provider, in the case of non-execution or defective execution of the payment order, the immediate and full refund of the payment amount. If the amount was debited from a payment account of the end user, that payment account must be restored to the state it would have been in without the defectively executed payment transaction. If fees were deducted from the payment amount contrary to Section 675q(1), the end user's account provider must transmit the deducted amount to the payee without undue delay. If the end user's account provider proves that the payment amount was received in full by the payee's payment service provider, liability under this paragraph shall not apply.",
          p2: "2.8.2 If a payment transaction is initiated by the end user, the end user may, in the case of delayed execution of the payment order, demand that their account provider assert the claim under sentence 2 against the payee's payment service provider. The end user's account provider may demand from the payee's payment service provider that the credit of the payment amount to the payee's payment account be made as if the payment transaction had been properly executed. If the end user's account provider proves that the payment amount was received by the payee's payment service provider in a timely manner, liability under this paragraph shall not apply.",
          p3: "2.8.3 Claims of the end user against their account provider under Section 2.8.1 sentences 1 and 2 shall not exist insofar as the payment order was executed in accordance with the incorrect customer identifier provided by the payment service user. In this case, however, the end user may demand that their account provider make reasonable efforts to recover the payment amount.",
          p4: "2.8.4 An end user may demand from their account provider, in addition to the claims under Section 2.8.1, the reimbursement of fees and interest that the account provider has charged or debited to the end user's payment account in connection with the non-execution or defective execution of the payment transaction.",
          p5: "2.8.5 If, in the case of involvement of multiple payment service providers in the payment transaction, at least one of these payment service providers is located within and at least one outside the European Economic Area, Sections 2.8.1 to 2.8.2 shall not apply to the portions of the payment transaction carried out within the European Economic Area.",
          p6: "2.8.6 Complaint and Legal Remedy Procedures/Dispute Resolution Procedures",
          p6Text:
            "For complaints, end users may contact the Federal Financial Supervisory Authority (BaFin) pursuant to Section 60 ZAG. Complaints must be filed in writing or on record with BaFin and should state the facts and the grounds for complaint. Complaints should be addressed to:",
          p6BafinAddress: "Federal Financial Supervisory Authority",
          p6BafinStreet: "Graurheindorfer Straße 108, 53117 Bonn",
          p6Schlichtung:
            "wealthAPI is generally willing to participate in dispute resolution proceedings at the Conciliation Board of the Deutsche Bundesbank. The Conciliation Board at the Deutsche Bundesbank is an official consumer conciliation body. Its subject-matter jurisdiction is determined by law.",
          p6SchlichtungTitle: "Conciliation Board at the Deutsche Bundesbank",
          p6SchlichtungPO: "P.O. Box 11 12 32",
          p6SchlichtungZip: "60047 Frankfurt",
          p6SchlichtungPhone: "Phone: 069 / 2388 1907",
          p6SchlichtungEmail: "Email: schlichtung@bundesbank.de",
          p6SchlichtungWeb: "Internet:",
          p6SchlichtungUrl:
            "http://www.bundesbank.de/Navigation/DE/Service/Schlichtungsstelle/schlichtungsstelle.html",
        },
      },
    },
    privacy: {
      title:
        "Privacy Policy of wealthAPI GmbH for the Use of wealthAPI Services",
      version: "Version 1.0 - 27.12.2019",
      section1: {
        title:
          "1. Information about the Controller and Data Protection Officer",
        responsible:
          "The controller within the meaning of data protection law is:",
        companyName: 'wealthAPI GmbH (hereinafter "wealthAPI")',
        directors:
          "Managing Directors: André Rabenstein, Dr. Wolfram Stacklies",
        oldZip: "12107 Berlin",
        registration:
          "registered at the District Court of Charlottenburg under HRB 166061 B",
        dpoTitle: "Contact the Data Protection Officer",
        dpoText:
          "If you have questions about data protection, please send us an email or contact our data protection officer directly:",
      },
      section2: {
        title: "2. General Information on Data Processing",
        text: 'wealthAPI processes personal data in accordance with applicable law, in particular Regulation (EU) 2016/679 of the European Parliament and of the Council of 27.04.2016 ("General Data Protection Regulation", GDPR) and the German Federal Data Protection Act (BDSG). wealthAPI generally uses all customer, end user, and prospective customer data (hereinafter "customer data") only',
        item1: "for the implementation of pre-contractual measures,",
        item2:
          'for the fulfillment of its contractual obligations towards the respective customer, end user, or prospective customer (hereinafter "customers") as described in the usage agreement for end users, and',
        item3:
          "for the fulfillment of other legal, in particular regulatory obligations (Art. 6(1)(b), (c) GDPR).",
        item4:
          "In addition, processing may also take place to protect legitimate interests of wealthAPI, for example the creation of anonymized analyses to improve or expand services for customers, for purposes of receivables management, legal defense, or direct marketing for own services (e.g., newsletters), insofar as the interests, fundamental rights, or fundamental freedoms of the customer do not prevail (Art. 6(1)(f) GDPR); in this respect, the customer has the right to object.",
        item5:
          "In principle, Rentablo does not disclose customer data to third parties. For the above-mentioned purposes, wealthAPI exceptionally discloses customer data to third parties contractually bound to data protection and data security (e.g., wealthAPI employees, external service providers such as account information services commissioned by wealthAPI, IT service providers, operators of end user applications based on wealthAPI services), as well as to account-holding and custody institutions. The disclosure of customer data is in each case limited to the extent necessary for the fulfillment of the purpose.",
        item6:
          "Processing of customer data and/or their disclosure to third parties for purposes other than those mentioned above shall only take place on the basis of proper consent of the customer (Art. 6(1)(a) GDPR).",
        item7:
          "wealthAPI stores and processes personal customer data for as long as is necessary for the fulfillment of its contractual and legal obligations. It should be noted that the business relationship with customers is designed to be long-term. Once the customer has communicated personal data to wealthAPI and wealthAPI has established a contractual relationship (e.g., contract for the provision of wealthAPI account information services) on this basis and provided such services, there are commercial, tax, and regulatory archiving, documentation, and disclosure obligations to which wealthAPI is bound and which also include customer data. Such periods range from two to ten years.",
        item8:
          "If the data is no longer required for the fulfillment of contractual or legal obligations, it will be regularly deleted, unless its (temporary) further processing is necessary for the preservation of evidence within the limitation periods (up to 30 years), insofar as wealthAPI has a prevailing legitimate interest pursuant to Art. 6(1)(f) GDPR for such storage beyond the statutory retention periods.",
      },
      section3: {
        title: "3. Rights of the Data Subject",
        generalTitle: "General Data Protection Rights",
        generalText:
          "Customers have the right to information under Art. 15 GDPR, the right to rectification under Art. 16 GDPR, the right to erasure under Art. 17 GDPR, the right to restriction of processing under Art. 18 GDPR, the right to object under Art. 21 GDPR, and the right to data portability under Art. 20 GDPR.",
        revocationTitle: "Right of Revocation",
        revocationText:
          "Some data processing operations are only possible with the express consent of the customer. Customers may revoke consent already given at any time. The lawfulness of the data processing carried out until the revocation remains unaffected by the revocation.",
        exerciseTitle:
          "Exercise of Data Protection Rights, Cooperation Obligations, and Limitations",
        exerciseText1:
          "For the exercise of certain objection and revocation rights, there is occasionally the possibility of clicking on links or buttons; customers are specifically made aware of this in the respective context. In addition, customers may at any time contact the data protection officer by post or email to assert their data protection rights (contact details above).",
        exerciseNote: "Note:",
        exerciseText2:
          "Customer inquiries can only be processed if customers provide wealthAPI with their full first and last name, their current and, if applicable, former address, date of birth, and email address. This information serves exclusively for verification purposes and thus constitutes a protection for customers so that unauthorized third parties do not receive customers' personal data or exercise their data protection rights. Additionally helpful, but not necessary, would be any offer, reference, and/or contract numbers that wealthAPI has communicated to customers, so that wealthAPI can identify the relevant data more quickly.",
        exerciseText3:
          "When exercising the right to information and the right to erasure, the restrictions under Sections 34 and 35 BDSG apply. Furthermore, restrictions may arise from the fact that full or partial fulfillment of data protection rights in individual cases is precluded by other statutory provisions or a legitimate interest of wealthAPI.",
        complaintTitle: "Right to Lodge a Complaint",
        complaintText:
          "Customers have the right to lodge a complaint with the supervisory authority responsible for wealthAPI. There is generally no obligation for the customer to provide personal data until the conclusion of the contractual relationship (e.g., contract for the provision of wealthAPI account information services). However, without such data, the conclusion of the contractual relationship and its fulfillment through the provision of the contractually agreed services to the customer is not possible for wealthAPI.",
      },
    },
  },
  disclaimerPage: {
    header: {
      title: "Disclaimer",
      subtitle: "Disclaimer",
    },
    content: {
      section1:
        "Copyright © {{year}} {{companyName}} (hereinafter {{mandatorShortName}}).",
      section1Break: "All rights reserved.",
      section2:
        "Reprinting, redistribution and electronic archiving of content only with written permission of the publisher. Despite careful review of the underlying sources, the publisher assumes no liability for the content of the offering. Any liability for damages incurred is excluded.",
      section3:
        "The publisher is not liable for unsolicited manuscripts and documents. The information and communications contained herein are intended exclusively for information and personal use. None of the information contained herein constitutes an offer to sell or the solicitation of offers to buy a futures contract, security or option.",
      section4:
        "The assessments of stocks, certificates and other financial products published on {{mandatorShortName}} or other publications do not constitute a solicitation to buy or sell the securities discussed. If the author(s)/editorial team expresses a personal opinion in an article/tweet, this should not be construed as advisory services. The assessments are also independent. They are based on sources that we consider trustworthy and reliable. We assume no obligation for third-party emission data. Despite careful processing, we cannot guarantee the accuracy of the information and prices. All opinions and information serve exclusively for information purposes, do not constitute any liability obligation and should not be understood as a solicitation to make a transaction. The strategies presented also do not constitute a call for replication, not even tacitly.",
      section5:
        "We expressly point out that trading in stocks, warrants, certificates, options and other financial products involves fundamental risks and total loss of the capital invested cannot be excluded. The opinions, strategies and information presented must under no circumstances be construed as general or personal advice, as the content merely reflects the opinion of the editorial team. Past gains cannot guarantee future results. Anyone who makes investment decisions based on an article from {{mandatorShortName}} or a recommendation from other {{mandatorShortName}} community members acts at their own risk. Investors should seek advice from a bank-independent expert as to how far the securities presented suit their personal risk profile.",
      section6:
        "Visitors of {{mandatorShortName}} agree to this disclaimer by reading the articles published here and contact with users from the community and consequently release the author(s) of the articles or watchlists from all liability and warranty claims.",
      section7:
        "All price information is displayed with varying delays depending on the selected exchange (Deutsche Börse: 15 minutes, Nasdaq: 20 minutes, Dow Jones: 20 minutes, NYSE: 20 minutes). All price information is provided without warranty; claims against the publisher or rights holders (e.g. Dow Jones, Shanghai Stock Exchange) are excluded.",
      section8:
        "{{mandatorShortName}} assumes no warranty for the content of posts published in the discussion forum. The author of a post is solely responsible for its content. It is pointed out that the dissemination of false facts with the aim of manipulating stock prices is subject to criminal prosecution. {{mandatorShortName}} does not check individual posts for their accuracy or truthfulness. {{mandatorShortName}} reserves the right to delete posts and exclude members from using the platform.",
      section9:
        "This website uses Google Analytics, a web analytics service provided by Google Inc., to enable analysis of website usage. The information generated by Google Analytics about your use of this website (including your IP address) is transmitted to and stored on a Google Inc. server in the USA. Google will use this information solely to analyze website usage by creating anonymized reports and graphs on the number of visits, number of pages accessed per user, etc. We use these exclusively for the purpose of our own usage analysis and above all for the optimization and demand-oriented design of our websites. More information about the technology used by Google can be found at <0>www.google.com/analytics</0>. By using this website, you consent to the processing of data collected about you by Google in the manner and for the purpose described above.",
    },
    trademarks: {
      section1:
        "The following names or designations are registered trademarks of Deutsche Börse AG: Deutsche Börse®, FWB®, Neuer Markt® (word-image mark), SMAX®, European Energy Exchange® EEX®, Eurex®, Xetra®, DAX®, TecDAX®, MDAX®, SDAX®, CDAX®, HDAX®, VDAX®, JEX®, REX®, PEX®, Xelsius®, XTF Exchange Traded Funds®.",
      section2: "STOXX® and EURO STOXX® are trademarks of STOXX Limited.",
      section3:
        "iBoxx is a registered trademark of International Index Company Ltd.",
      section4:
        "SWX, SWX Swiss Exchange, Swiss Market Index, SMI, Swiss Performance Index, SPI, SNMI, SWX Eurobonds and SWX New Market are registered trademarks of the SWX Swiss Exchange.",
      section5:
        "The copyright of Nikkei 225 is owned by Nihon Keizai Shimbun, Inc. NIKKEI.",
      section6:
        'DOW JONES Disclaimer: THE INDEX DATA ARE PROVIDED TO YOU "AS IS". NEITHER S&P DOW JONES INDICES, DOW JONES & COMPANY, INC. ("DOW JONES") NOR ANY OF THEIR RESPECTIVE AFFILIATES, AGENTS OR LICENSORS WARRANTS THE ACCURACY, COMPLETENESS, CURRENTNESS, NONINFRINGEMENT, MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE OF THE INDICES OR INDEX DATA. ALTHOUGH S&P DOW JONES INDICES MAKES REASONABLE EFFORTS TO COMPLY WITH ITS GUIDELINES REGARDING THE SELECTION OF COMPONENTS IN THE DOW JONES ISLAMIC MARKET INDICES, S&P DOW JONES INDICES CANNOT GUARANTEE OR WARRANT THAT THOSE INDICES OR THE DATA RELATED THERETO WILL COMPLY WITH SHARIAH LAW OR OTHER ISLAMIC PRINCIPLES AND S&P DOW JONES INDICES EXPRESSLY DISCLAIMS ANY SUCH WARRANTY. NEITHER S&P DOW JONES INDICES NOR ANY OF ITS AFFILIATES, AGENTS OR LICENSORS SHALL BE LIABLE TO YOU OR ANYONE ELSE FOR ANY LOSS OR INJURY RESULTING DIRECTLY FROM USE OF THE INDICES OR INDEX DATA CAUSED IN WHOLE OR PART BY S&P DOW JONES INDICES\' NEGLIGENCE OR CONTINGENCIES BEYOND ITS CONTROL IN PROCURING, COMPILING, INTERPRETING, REPORTING OR DELIVERING THE INDICES OR INDEX DATA. IN NO EVENT WILL S&P DOW JONES INDICES, DOW JONES OR ANY OF THEIR RESPECTIVE AFFILIATES, AGENTS OR LICENSORS BE LIABLE TO YOU OR ANYONE ELSE FOR ANY DECISION MADE OR ACTION TAKEN BY YOU IN RELIANCE ON THE INDICES. NEITHER S&P DOW JONES INDICES, DOW JONES NOR ANY OF THEIR RESPECTIVE AFFILIATES, AGENTS OR LICENSORS SHALL BE LIABLE TO YOU OR ANYONE ELSE FOR ANY DAMAGES (INCLUDING, WITHOUT LIMITATION, CONSEQUENTIAL, SPECIAL, INCIDENTAL, INDIRECT, OR SIMILAR DAMAGES) EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.',
    },
    other: {
      section1:
        'PDF Import: Parts of the PDF import are based on the project "Tresor Import" (<0>https://github.com/tresorone/tresor-import</0>).',
      section2:
        "For data from Ariva: All price information is delayed by at least 15 minutes or more according to the regulations of the respective exchange (NYSE/AMEX: 20 min.). Technology and data by Ariva.",
    },
  },
  accountReview: {
    title: "Review additional accounts",
    subtitle:
      "Please select which additional accounts (optional) should be imported.",
    description:
      "Please review if any reference account or other account should also be imported. Select the account by toggling the switch to the right.",
    requiredSection: "Portfolios & reference accounts (not editable)",
    confirm: "Confirm",
    deleteError:
      "Some accounts could not be removed. Please try again or contact support.",
  },
  referenceAccountPage: {
    breadcrumb: "Edit reference account",
    accountsCard: {
      title: "Settlement accounts",
      description:
        "Link additional accounts through which purchases and sales of this portfolio are settled.",
    },
    changeButton: "Change",
    cancelButton: "Cancel",
    selectPrimary: {
      title: "Select primary account",
      confirm: "Apply",
    },
    addTrigger: "Add another settlement account",
  },
  goals: {
    overview: {
      title: "Goals",
      subtitle:
        "Wealth is today's value of the assigned accounts; plan is the value your plan sets for today.",
      newGoal: "New goal",
    },
    status: {
      onTrack: "On track",
      behindPlan: "Behind plan",
      atRisk: "At risk",
    },
    figures: {
      wealth: "Wealth",
      plan: "Plan",
      deviation: "Gap",
    },
    deviation: {
      abovePlan: "{{amount}} ({{percent}}) above plan",
      belowPlan: "{{amount}} ({{percent}}) below plan",
      abovePlanShort: "{{amount}} above plan",
      belowPlanShort: "{{amount}} below plan",
    },
    card: {
      target: "Target {{amount}} by {{date}}",
      details: "Details",
    },
    actions: {
      menu: "Actions for {{name}}",
      edit: "Edit",
      showOnDashboard: "Show on dashboard",
      shownOnDashboard: "Shown on dashboard",
      shownOnDashboardNotice: "“{{name}}” is now shown on your dashboard",
      delete: "Delete goal",
      deleteTitle: "Delete the goal “{{name}}”?",
      deleteText:
        "The goal and its plan are deleted. Your accounts stay as they are.",
      deletedNotice: "Goal “{{name}}” deleted",
    },
    detail: {
      progress: "Wealth and plan",
    },
    chart: {
      today: "Today",
      mode: "Chart type",
      line: "Line",
      bar: "Bars",
      range: "Period",
      ranges: {
        fiveYears: "5Y",
        tenYears: "10Y",
        untilTarget: "To the target",
      },
      period: "{{from}} to {{to}}",
      target: "Target {{amount}}",
    },
    banner: {
      behindTitle: "Your wealth is {{percent}} below plan.",
      behindText:
        "A higher monthly saving or a later target date gets you back on track.",
      atRiskTitle: "Your goal is at risk.",
      atRiskText:
        "Your wealth is {{percent}} below plan, with {{remaining}} left until the target date.",
      atRiskTextNoTime: "Your wealth is {{percent}} below plan.",
      adjustPlan: "Adjust plan",
    },
    plan: {
      title: "Plan",
      edit: "Edit plan",
      target: "Target",
      targetValue: "{{amount}} by {{date}}",
      todaysMoney: "in today's money",
      remaining: "{{duration}} left",
      targetDateReached: "Target date reached",
      savings: "Monthly savings",
      perMonth: "{{amount}} / month",
      since: "since {{date}}, starting with {{amount}}",
      accounts: "Accounts",
      accountCount_one: "{{count}} account",
      accountCount_other: "{{count}} accounts",
    },
    duration: {
      years_one: "{{count}} year",
      years_other: "{{count}} years",
      months_one: "{{count}} month",
      months_other: "{{count}} months",
    },
    icons: {
      beach: "Retirement",
      "home-outline": "Home",
      finance: "Wealth",
      car: "Car",
      "airplane-takeoff": "Travel",
      bullseye: "General",
    },
    wizard: {
      newGoal: "New goal",
      stepLabel: "Step {{current}} of {{total}} · {{name}}",
      cancel: "Cancel",
      saved: "Goal “{{name}}” saved",
      saveError:
        "The goal could not be saved. Please check your entries and try again.",
      accounts: {
        stepName: "Accounts",
        title: "Which accounts count towards this goal?",
        subtitle:
          "The current value of these accounts is your progress. Portfolios, accounts and material assets can be combined, across banks.",
        required: "Please select at least one account.",
        selected_one: "{{count}} account selected",
        selected_other: "{{count}} accounts selected",
        value: "current value {{amount}}",
        valueAsStart: "current value {{amount}}, suggested as starting wealth",
      },
      plan: {
        stepName: "Plan",
        title: "What does your plan look like?",
        subtitle:
          "From starting wealth, monthly savings and term we calculate the return you need for your target.",
        initialWealth: "Starting wealth",
        initialWealthHint_one: "Value of the selected account",
        initialWealthHint_other: "Value of the {{count}} selected accounts",
        initialWealthHintAt_one:
          "Value of the selected account at the start of {{date}}",
        initialWealthHintAt_other:
          "Value of the {{count}} selected accounts at the start of {{date}}",
        startMonth: "Start date",
        startMonthInvalid: "Please choose a month up to today.",
        target: "Target wealth",
        targetTooLow: "The target wealth must exceed the starting wealth.",
        targetInTodaysMoney: "in today's money · equals {{amount}} in {{date}}",
        years: "Term",
        yearsValue: "{{years}} · until {{date}}",
        savings: "Monthly savings",
        savingsTotal: "about {{amount}} paid in until the target date",
        adjustInflation: "Adjust the target for inflation",
        inflationRate: "Inflation rate",
        inflationValue: "{{rate}} % p. a.",
        result: "Result",
        requiredYield: "Required return",
        yieldValue: "{{percent}} p. a.",
        rating: {
          realistic: "realistic",
          challenging: "challenging",
          ambitious: "ambitious",
        },
        summary:
          "Your plan needs this return per year to reach {{amount}} by {{date}}.",
        summaryWithoutYield:
          "Starting wealth and savings reach {{amount}} by {{date}} even without returns.",
        chartTitle: "Plan until {{date}}",
      },
      details: {
        stepName: "Name and icon",
        title: "Almost done: what is your goal called?",
        subtitle: "Name and icon appear in the overview and on your dashboard.",
        name: "Goal name",
        nameRequired: "Please give your goal a name.",
        nameTooLong: "The name can have at most 255 characters.",
        description: "Description (optional)",
        icon: "Which icon fits your goal?",
        targetDate: "Target date",
        dashboardHint:
          "The dashboard shows one goal. Your first goal is shown automatically.",
        save: "Save goal",
      },
    },
    dashboard: {
      plan: "Plan {{amount}} ·",
      emptyTitle: "No financial goal",
      emptyText: "Big plans? Set a goal and keep an eye on it.",
    },
    empty: {
      title: "Set your first financial goal",
      text: "Set a target amount and a target date and assign the matching accounts. We keep comparing their current value with your plan.",
      steps: {
        define: {
          title: "Set a goal",
          text: "Target wealth, target date and monthly savings. Accounts from different banks can be combined.",
        },
        track: {
          title: "Track your progress",
          text: "The value of your accounts is compared with the value your plan sets.",
        },
        adjust: {
          title: "Adjust in time",
          text: "You see the return you need and can adjust your savings or the target date.",
        },
      },
      create: "Create goal",
    },
  },
};
